<style scoped lang="scss">
#create-ms-ind {
  font-family: 'Manrope';
  background: #f9f9f9;
  min-height: calc(100vh - 45px);
}

.val-dom-ques {
  display: flex;

  & .code {
    margin-left: auto;
  }
}

.i-menu {
  display: flex;
  align-items: stretch;
  margin: 10px;

  &-item {
    margin: 0 10px 10px 10px;
    padding: 15px 20px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    cursor: pointer;
    // box-shadow:0  5px 10px rgba(154,160,185,0.05),0 15px 40px rgba(166,173,201,0.2) !important;
    border-radius: 5px;
    border: 1px solid #ced4da;
    background-color: white;

    &.selected {
      border: 1px solid #01947b !important;
      background-color: #e5fffb;

    }

    &-radio {
      position: absolute;
      right: 7px;
      top: 12px;
    }

    & .i-title {
      font-weight: 600;
      font-size: 20px;
      margin: 0;

      &-info {
        color: rgb(99, 99, 99);
        font-size: 12px;
        font-weight: 500;
        opacity: 0.85;
        letter-spacing: .2px;
      }
    }

    &.primary>* {
      color: #01947b;

    }

    &.secondary>* {
      color: #0277BD;
    }

    &.tertiary>* {
      color: #E91E63;
    }

    &.quaternary>* {
      color: #FF6F00;
    }

    &.quinary>* {
      color: #6A1B9A;
    }

    &.senary>* {
      color: #424242;
    }

  }
}

.i-menu>.item>.icon {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.i-menu>.item>.icon>div {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
}

.i-menu>.item>.title {
  font-size: 14px !important;
  font-weight: 600 !important;
  margin-bottom: auto;
  font-family: "Jakarta Plus", "Helvetica Neue", Helvetica, sans-serif;

}

.questionnaire {
  min-height: 67vh;
  display: flex;
  flex-direction: column;
  border: 1px solid #b8b8b8;
  position: relative;
  background: white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  &-navigation {
    display: flex;
    border-bottom: none;
    border-top: 1px solid #e0e0e0;
    // border-bottom:1px solid #e0e0e0;
    background: white;
    padding: 0px 50px 0px 50px;

    & .item {

      font-size: 13px;
      font-weight: 500;
      padding: 5px 15px;
      margin-top: -1px;
      border-left: 1px solid #e0e0e0;

      &:last-child {
        border-right: 1px solid #e0e0e0;
      }

      &.active {
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #005f4f;
        // border:1px solid #005f4f;
      }

      &.invalid {
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #dc3545;
        border-color: rgb(255, 214, 214);
      }

      &.status {
        font-weight: 600;
        background: white;
        margin-left: auto;
        border: none;
        font-size: 12px;
        padding-right: 0;

        & div {
          border-radius: 5px;
          padding: 1px 3px;
        }

        & .draft {
          background-color: #cccccc;
          color: #424242;
          border: 1px solid #cccccc;
        }

        & .submitted {
          color: #1976D2;
          background: #E3F2FD;
          border: 1px solid #90CAF9;

          &.darker {
            background: #006aff;
            color: white;
          }
        }

        & .under-review {
          color: #7b6400;
          background: #ffe600;
          border: 1px solid #d8c300;
        }

        & .correction-required,
        &.revised {
          color: #7B1FA2;
          background: #F3E5F5;
          border: 1px solid #CE93D8;

        }

        & .rejected {
          background: rgb(253, 208, 208);
          color: rgb(201, 0, 0);
          border: 1px solid rgb(255, 143, 143);
        }

        & .approved {
          font-weight: 600;
          background: #c4ffc4;
          color: rgb(22, 139, 22);
          border: 1px solid rgb(97, 213, 97);
        }

        & .published {
          font-weight: 500;
          background: rgb(192, 255, 192);
          color: rgb(25, 136, 25);
          border: 1px solid rgb(154, 234, 154);
        }

      }

    }


    & .button-navigation {
      & .prev {
        padding: 5px 15px;
      }

      & .next {
        padding: 5px 15px;
        background: teal;
        color: white;
      }

    }
  }

  &.entry-mode {
    & .blok-detail {
      padding: 20px 25px;

      & .question {
        border: none !important;
      }

    }
  }

  & .blok {
    & .blok-title {
      color: #2d2d2d;
      font-size: 14px;
      font-weight: 700;
      background: #e5e5e5;
      padding: 0.25rem 0.5rem;
      text-align: center;

      border-top: 1px solid #b8b8b8;
      border-bottom: 1px solid #b8b8b8;
      text-transform: uppercase;
    }

    &:first-child .blok-title {
      border-top: none;
    }
  }

  & .blok-detail {
    padding: 20px 25px;

    & .question {
      padding: 10px 0px;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }

      &:not(:last-child) {
        border-bottom: 1px solid rgb(210, 210, 210);
      }

      &__name {
        font-size: 13px;
        font-weight: 700;
        margin-bottom: 0rem;
        color: #212121;
      }

      &__value {
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 0rem;
        color: #525252;

        & input,
        & .vue-treeselect,
        & textarea,
        & div[role="radiogroup"],
        & ul {
          margin-top: 3px !important;
        }

        & div[role="radiogroup"] {
          margin-left: 3px !important;
        }

        & .custom-checkbox {
          margin-left: 3px !important;
        }

        & ul {
          margin-left: -35px !important;
        }
      }

      & ul.list {
        list-style-type: none;
        margin-left: -40px;
        margin-bottom: 0;

        & li::before {
          content: '- ';
        }

        & li:only-child::before {
          content: '';
        }
      }
    }

    & p.question {
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 0rem;
      color: #212121;
    }

    & p {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 0rem;
      color: #525252;
    }

  }

  &__status {
    margin-top: -7px;
    margin-left: 4px;
    padding: 3px 5px;
    letter-spacing: .3px;
    font-size: 12px;
    border-radius: 5px 0px 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: rgb(251, 229, 229);
    border: 1px solid #cccccc;
    background-color: #cccccc;
    color: #424242;

    &2 {
      border-radius: 0px 0px 0px 15px;
      position: absolute;
      top: -1px;
      right: -1px;
      padding: 5px 10px;
    }

    &3 {
      margin-top: 0px;
      margin-left: 0px;
      font-weight: 600;
      padding: 3px 5px;
    }

    &.draft,
    &2.draft,
    &3.draft {
      color: #424242;
      background: #cccccc;
      border: 1px solid #bbbbbb;
    }

    &.submitted,
    &2.submitted,
    &3.submitted {
      color: #1976D2;
      background: #E3F2FD;
      border: 1px solid #90CAF9;

      &.darker {
        background: #006aff;
        color: white;
      }
    }

    &.under-review,
    &2.under-review,
    &3.under-review {
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border: 1px solid #dfcd2b;
    }

    &.correction-required,
    &.revised,
    &2.correction-required,
    &2.revised,
    &3.correction-required,
    &3.revised {
      color: #7B1FA2;
      background: #F3E5F5;
      border: 1px solid #CE93D8;

    }

    &.rejected,
    &2.rejected,
    &3.rejected {
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border: 1px solid rgb(255, 143, 143);
    }

    &.approved,
    &2.approved,
    &3.approved {
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border: 1px solid rgb(97, 213, 97);
    }

    &.published,
    &2.published,
    &3.published {
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border: 1px solid rgb(154, 234, 154);
    }

  }

  &__body {
    flex-direction: column;
    display: flex;
    flex-grow: 1;
  }

  &__footer {
    border-top: 1px solid #b8b8b8;
    bottom: 0;
    display: flex;
    padding: 10px 20px;
  }

}


/* ============================================================
   History Status (ms_keg_histories)
   ============================================================ */
.history-status {
  margin-top: 12px;

  &__item {
    padding: 8px 10px;
    margin-bottom: 8px;
    border-left: 3px solid #e0e0e0;
    background: #fafafa;
    border-radius: 4px;
  }

  &__number {
    font-size: 11px;
    font-weight: 600;
    color: #424242;
    min-width: 18px;
  }

  &__badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .3px;
    border: 1px solid transparent;

    &--draft {
      color: #424242;
      background: #cccccc;
      border-color: #bbbbbb;
    }

    &--submitted {
      color: #1976D2;
      background: #E3F2FD;
      border-color: #90CAF9;
    }

    &--under-review {
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border-color: #dfcd2b;
    }

    &--correction-required,
    &--revised {
      color: #7B1FA2;
      background: #F3E5F5;
      border-color: #CE93D8;
    }

    &--rejected {
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border-color: rgb(255, 143, 143);
    }

    &--approved {
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border-color: rgb(97, 213, 97);
    }

    &--published {
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border-color: rgb(154, 234, 154);
    }
  }

  &__info {
    font-size: 10px;
    color: #757575;
    margin-top: 4px;
    margin-left: 18px;
    font-style: italic;
  }

  &__rejection {
    font-size: 11px;
    color: #c9302c;
    margin-top: 4px;
    margin-left: 18px;
    padding: 4px 6px;
    background: #fff5f5;
    border-radius: 3px;
    border: 1px solid #f5c6cb;
  }
}
</style>
<style>
td span:not(:first-child) .mx-datepicker {
  margin-top: 8px !important;

}
</style>
<template>
  <div id="create-ms-ind">
    <div class="page-control--secondary">
      <div class="page-control__body">
        <div class="page-control__left">
          <!-- {{appData.current_role}} -->
          <button class="button button--text button--action mr-2" id="backUsulanList" @click="$router.back()">
            <VueFeather type="arrow-left" size="18" stroke-width="1.5" style="display:block"></VueFeather>
          </button>
          <b-popover target="backUsulanList" triggers="hover" placement="bottom">
            <template #title>Kembali ke halaman daftar usulan</template>
            Pastikan anda sudah menyimpan isian terlebih dahulu dengan klik tombol draft atau submit, karena ketika
            kembali isian
            ada akan hilang
          </b-popover>
          <div class="my-1">
            <div class="d-flex align-items-start"
              style="font-family:'Manrope',;font-weight:600;font-size:16px;color:#032F05;line-height:1">
              <div v-if="route == 'UpdateMsKeg'">
                Update Metadata Kegiatan <span class="text-primary">{{ data.judul_kegiatan }}</span>
              </div>
              <div v-else>
                {{ route == 'AddMsKeg' ? 'Lapor' : 'Lapor Siklus' }}
                <span class="text-primary">Metadata Kegiatan </span>Baru
              </div>
            </div>
            <div class="" style="font-family:'Manrope';font-weight:500;font-size:12px;color:#515151;">
              Harap baca panduan terlebih dahulu, agar pelaporan Anda dapat menjadi lebih mudah.
            </div>

          </div>
        </div>
        <div class="page-control__center">
        </div>
        <div class="page-control__right align-items-center">
          <button 
            v-if="route == 'UpdateMsKeg'"
            class="button mr-2" 
            :variant="isReviewOpen ? 'primary' : 'outlined'" 
            size="sm" 
            @click="isReviewOpen = !isReviewOpen"
            title="Tampilkan / Sembunyikan Catatan Pemeriksaan"
          >
            <VueFeather type="mail" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Catatan Pemeriksaan
            <span v-if="(form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
              {{ (form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
            </span>
          </button>
          <div class="tags">
            <div :class="'mr-0 tag tag--status ' + statusFormatterStyle(form.status)">
              <div class="tag__field">Status</div>
              <div class="tag__value">{{ statusFormatter(form.status) }}</div>
            </div>
          </div>

          <div class="w-10 mr-2" style="border-right:1px solid #e4e4e4; height:35px;"></div>
          <div class="w-170 form--sm mr-2" v-show="false">
            <b-input-group class="input-group-treeselect">
              <b-input-group-prepend is-text class="bg-none">
                <b-icon icon="keyboard"></b-icon>
              </b-input-group-prepend>
              <Treeselect :clearable="false" v-model="inputMode" placeholder="Input Mode"
                :options="[{ id: 0, label: 'Entri Mode' }, { id: 1, label: 'Kuesioner Mode' }]" />
            </b-input-group>
          </div>
          <button class="button mr-2" variant="outlined" size="sm" @click="save('DRAFT')">
            <VueFeather type="check" size="15" stroke-width="2.5" style="display:block;"></VueFeather>&nbsp;&nbsp;Simpan
            Sementara
          </button>
          <button class="button" variant="primary" size="sm" @click="save('SUBMITTED')">
            <VueFeather type="send" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Submit
          </button>
        </div>
      </div>
      <div class="page-control__footer" v-if="section.currentIndex != null">
        <div class="questionnaire-navigation">
          <div class="item"
            :class="section.items[index].status == 'invalid' ? 'invalid' : (section.currentIndex == index ? 'active' : '')"
            v-for="(item, index) in section.items" :key="index"
            v-show="index == 5 && data.cara_pengumpulan_data != 'SURVEI' ? false : true"
            @click="() => { validateForm(); section.currentIndex = index; }">
            {{ item.name }}
          </div>

        </div>
      </div>
    </div>

    <div class="content content--borderless">
      <div v-if="isLoading" class="content__loading">
        <img src="@/assets/icons/loading-plane.gif" width="200" height="200" style="margin-top:-60px" />
        <div style="margin-top:-60px">
          Sedang mengambil data ke server, harap tunggu sebentar....
        </div>
      </div>
      <div v-else class="content__body" style="margin: 25px 65px">
        <b-row class="h-100p">
          <b-col id="form" class="form form--sm h-100p px-0">
            <div class="questionnaire" :class="inputMode == 0 ? 'entry-mode' : 'ques-mode'"
              v-show="section.currentIndex != 9">
              <div class="questionnaire__body">

                <div class="mt-4 i-form" v-if="section.currentIndex == null">
                  <div class="text-left my-2 i-text-14"
                    style="padding-left:20px;color:#2e2e2e;font-weight:500;opacity:0.8">
                    Pilih salah satu jenis metadata statistik kegiatan yang akan dilaporkan
                  </div>
                  <b-row class="i-menu">
                    <b-col 
                      v-for="(item,index) in options.jenis_statistik"  :key="index" 
                      @click="onSelectJenisStatistik(item.id)"
                      :class="data.jenis_statistik == item.id ? 'i-menu-item selected '+ item.color: 'i-menu-item '+ item.color"
                      style="cursor: pointer;"
                    >
                      <div class="i-menu-item-radio" style="pointer-events: none;">
                        <b-form-radio :checked="data.jenis_statistik" :value="item.id" name="jenis-statistik-radio"></b-form-radio>
                      </div>
                      <div class="text-left">
                        <div class="i-title">{{ item.label }}</div>
                        <div class="i-title-info">{{ item.description }}</div>
                      </div>
                    </b-col>
                  </b-row>


                </div>

                <ValidationObserver ref="halamanAwalObserver" v-show="section.currentIndex == 0">
                  <div class="blok">
                    <div class="blok-detail">
                      <div class="question pb-3 pt-3 mb-2 px-4" v-if="data.jenis_statistik == 'STATISTIK_SEKTORAL'"
                        style="border-bottom: 1px solid rgb(210, 210, 210) !important;margin-top:-20px;margin-left:-25px !important;margin-right:-25px !important;"
                        :style="rekomendasi && rekomendasi.status == '0' ? 'background:#fff4f6' : 'background:#f1fcfd'">
                        <div class="question__name">Apakah mendapatkan Rekomendasi kegiatan statistik dari BPS?</div>
                        <div class="question__value">
                          <b-form-radio-group v-model="formExt.getRecommendation"
                            :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))"
                            @input="getRecommendationChanged"></b-form-radio-group>
                        </div>
                        <div class="question__name mt-2" v-if="formExt.getRecommendation">Identitas Rekomendasi:</div>
                        <div class="question__value " v-if="formExt.getRecommendation">
                          <ValidationProvider name="No Rekomendasi" :rules="formExt.getRecommendation ? 'required' : ''"
                            v-slot="{ errors }">
                            <div class="d-flex">
                              <b-form-input v-model="data.identitas_rekomendasi"
                                placeholder="Isikan No Rekomendasi yang didapat dari BPS"
                                :state="errors[0] ? false : (data.identitas_rekomendasi ? true : null)">
                              </b-form-input>
                              <button class="button ml-2" variant="primary" size="sm" @click="loadRekomendasi"
                                style="margin-top: 3px;padding-left:15px;padding-right:15px">
                                <VueFeather type="search" size="16" stroke-width="2" style="display:block"></VueFeather>
                                &nbsp;&nbsp;Cek Rekomendasi
                              </button>
                            </div>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="alert mt-3" v-if="rekomendasi && rekomendasi.status == '0'"
                          style="background:#FFEBEE;border-color:#F44336 !important">
                          <div class="alert__icon">
                            <b-icon icon="exclamation-triangle-fill"
                              style="width: 20px; height: 20px;color: #D32F2F ;"></b-icon>
                          </div>
                          <div class="alert__value text-medium text-12" style="color:#B71C1C">
                            Rekomendasi tidak ditemukan. Pastikan Anda menginput kode yang benar. Jika tetap tidak
                            ditemukan
                            ganti jawaban pertanyaan "Apakah mendapatkan Rekomendasi kegiatan statistik dari BPS?"
                            menjadi
                            Tidak
                          </div>
                        </div>
                        <div class="alert alert--primary mt-3" v-if="rekomendasi && rekomendasi.status == '1'"
                          style="color:teal;background:#eafdff;border-color: #7dc2c9 !important">
                          <div class="alert__icon">
                            <b-icon icon="check-circle-fill"
                              style="width: 18px; height: 18px;color: #009586 ;"></b-icon>

                          </div>
                          <div class="alert__value text-medium text-12" style="color:teal">
                            Ditemukan. Silahkan lanjut pengentrian, beberapa field akan otomatis terisi sesuai dengan
                            isian
                            yang telah di isikan di aplikasi Romantik
                          </div>
                        </div>
                      </div>
                      <div class="question">
                        <b-row>
                          <b-col>
                            <div class="question__name">Judul Kegiatan:</div>
                            <div class="question__value">
                              <ValidationProvider name="Judul Kegiatan" :rules="judulKegiatanRules" v-slot="{ errors }">
                                <b-form-input v-model="data.judul_kegiatan"
                                  placeholder="Isikan judul kegiatan statistik yang dilakukan"
                                  :state="errors[0] ? false : (data.judul_kegiatan ? true : null)">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </div>
                          </b-col>
                          <b-col cols="auto">
                            <div class="question__name">Tahun:</div>
                            <div class="question__value">
                              <ValidationProvider name="Tahun Kegiatan" rules="required|digits:4" v-slot="{ errors }">
                                <b-form-input v-model="data.tahun" placeholder="Isikan Tahun Kegiatan"
                                  :state="errors[0] ? false : (data.tahun ? true : null)">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                      <div class="question">
                        <div class="question__name">Cara Pengumpulan Data:</div>
                        <div class="question__value" v-if="inputMode == 0">
                          <ValidationProvider name="Cara Pengumpulan Data" rules="required" v-slot="{ errors }">
                            <Treeselect :clearable="false" placeholder="Pilih Cara Pengumpulan Data"
                              v-model="data.cara_pengumpulan_data" :options="options.cara_pengumpulan_data"
                              :class="errors[0] ? 'invalid' : (data.cara_pengumpulan_data ? 'valid' : null)"
                              @input="changeQuesModeValue('cara_pengumpulan_data')" />
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Kode Cara Pengumpulan Data" rules="required|between:1,4"
                            v-slot="{ errors }">
                            <b-row>
                              <b-col>
                                <div class="val-dom-ques"
                                  v-for="item in options.cara_pengumpulan_data.filter((x, index) => index < 2)"
                                  :key="item">
                                  <div class="label">{{ item.label }}</div>
                                  <div class="code">-{{ item.code }}</div>
                                </div>
                              </b-col>

                              <b-col>
                                <div class="val-dom-ques"
                                  v-for="item in options.cara_pengumpulan_data.filter((x, index) => index >= 2)"
                                  :key="item">
                                  <div class="label">{{ item.label }}</div>
                                  <div class="code">-{{ item.code }}</div>
                                </div>
                              </b-col>

                              <b-col cols="1">

                                <b-form-input v-model="ques.cara_pengumpulan_data" class="mt-0"
                                  :state="errors[0] ? false : (ques.cara_pengumpulan_data ? true : null)"
                                  @input="changeEntriModeValue('cara_pengumpulan_data')">
                                </b-form-input>

                              </b-col>
                            </b-row>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">Sektor Kegiatan:</div>
                        <div class="question__value" v-if="inputMode == 0">
                          <ValidationProvider name="Sektor Kegiatan" rules="required" v-slot="{ errors }">
                            <Treeselect :clearable="false" placeholder="Pilih Sektor Kegiatan"
                              v-model="data.sektor_kegiatan" :options="options.sektor_kegiatan"
                              :class="errors[0] ? 'invalid' : (data.sektor_kegiatan ? 'valid' : null)" />
                            <!-- @input="changeQuesModeValue('sektor_kegiatan')" -->
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Kode Sektor Kegiatan" rules="required|between:1,22"
                            v-slot="{ errors }">
                            <b-row>
                              <b-col>
                                <div class="val-dom-ques"
                                  v-for="item in options.sektor_kegiatan.filter((x, index) => index < 11)" :key="item">
                                  <div class="label">{{ item.label }}</div>
                                  <div class="code">-{{ item.code }}</div>
                                </div>
                              </b-col>

                              <b-col>
                                <div class="val-dom-ques"
                                  v-for="item in options.sektor_kegiatan.filter((x, index) => index >= 11)" :key="item">
                                  <div class="label">{{ item.label }}</div>
                                  <div class="code">-{{ item.code }}</div>
                                </div>
                              </b-col>

                              <b-col cols="1">
                                <b-form-input v-model="ques.sektor_kegiatan" class="mt-0"
                                  :state="errors[0] ? false : (ques.sektor_kegiatan ? true : null)"
                                  @input="changeEntriModeValue('sektor_kegiatan')">
                                </b-form-input>
                              </b-col>
                            </b-row>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </ValidationObserver>

                <ValidationObserver ref="blokIObserver" v-show="section.currentIndex == 1">
                  <div id="blok_i" class="blok">
                    <div class="blok-title"> I. Penyelenggara</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">1.1. Instansi Penyelenggara:</div>
                        <div class="question__value">
                          <ValidationProvider name="Instansi Penyelenggara" rules="required" v-slot="{ errors }">
                            <Treeselect clearable valueFormat="object" placeholder="Nama Instansi Penyelenggara"
                              v-model="formExt.produsenData"
                              :class="errors[0] ? 'invalid' : (formExt.produsenData ? 'valid' : null)" :async="true"
                              :options="options.produsen_data" :loadOptions="produsenDataLoadOptions"
                              :normalizer="produsenDataNormalizer" @input="() => {
                                if (formExt.produsenData) {
                                  if (formExt.produsenData.details) {
                                    data.blok_i.instansi_penyelanggara = formExt.produsenData.name;
                                    data.blok_i.alamat_instansi_penyelenggara = {
                                      alamat: formExt.produsenData.details.address,
                                      telepon: formExt.produsenData.details.phone,
                                      email: formExt.produsenData.details.email,
                                      faksimile: formExt.produsenData.details.fax,
                                    };
                                  }
                                  form.produsen_data = {
                                    id: formExt.produsenData.id,
                                    name: formExt.produsenData.name,
                                    province_code: formExt.produsenData.provinceCode,
                                    city_code: formExt.produsenData.cityCode
                                  };

                                } else {
                                  data.blok_i.instansi_penyelanggara = null;
                                  data.blok_i.alamat_instansi_penyelenggara = {
                                    alamat: null,
                                    telepon: null,
                                    email: null,
                                    faksimile: null,
                                  };
                                  form.produsen_data = null;
                                }
                              }"
                              searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... " />
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name"> 1.2. Alamat Lengkap Instansi Penyelenggara:</div>
                        <div class="question__value">
                          <b-form-input v-model="data.blok_i.alamat_instansi_penyelenggara.alamat" disabled
                            placeholder="Alamat Instansi Penyelenggara" />
                        </div>
                        <b-row class="mt-2">
                          <b-col>
                            <div class="question">
                              <div class="question__name">Telepon:</div>
                              <div class="question__value">
                                <b-form-input v-model="data.blok_i.alamat_instansi_penyelenggara.telepon" disabled
                                  placeholder="Telepon Instansi Penyelenggara" />
                              </div>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="question">
                              <div class="question__name">Faksmile:</div>
                              <div class="question__value">
                                <b-form-input v-model="data.blok_i.alamat_instansi_penyelenggara.faksimile" disabled
                                  placeholder="Faksmile Instansi Penyelenggara" />
                              </div>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="question">
                              <div class="question__name">Email:</div>
                              <div class="question__value">
                                <b-form-input v-model="data.blok_i.alamat_instansi_penyelenggara.email" disabled
                                  placeholder="Email Instansi Penyelenggara" />
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </ValidationObserver>

                <ValidationObserver ref="blokIIObserver" v-show="section.currentIndex == 2">
                  <div id="blok_ii" class="blok">
                    <div class="blok-title">II. Penanggung Jawab</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">2.1. Unit Eselon Penanggung Jawab:</div>
                        <b-row class="mt-2">
                          <b-col>
                            <div class="question">
                              <div class="question__name">Eselon 1:</div>
                              <div class="question__value">
                                <ValidationProvider name="Eselon 1" rules="required" v-slot="{ errors }">
                                  <b-form-input v-model="data.blok_ii.unit_penanggung_jawab.eselon1"
                                    placeholder="Tulisakan nama penanggung jawab setingkat Eselon 1 "
                                    :state="errors[0] ? false : (data.blok_ii.unit_penanggung_jawab.eselon1 ? true : null)">
                                  </b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                              </div>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="question">
                              <div class="question__name">Eselon 2:</div>
                              <div class="question__value">
                                <ValidationProvider name="Eselon 2" rules="required" v-slot="{ errors }">
                                  <b-form-input v-model="data.blok_ii.unit_penanggung_jawab.eselon2"
                                    placeholder="Tulisakan nama penanggung jawab setingkat Eselon 2 "
                                    :state="errors[0] ? false : (data.blok_ii.unit_penanggung_jawab.eselon2 ? true : null)">
                                  </b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>

                      <div class="question">
                        <div class="question__name">2.2. Penanggung Jawab Teknis (setingkat Eselon 3):</div>
                        <div class="question">
                          <div class="question__name">Nama:</div>
                          <div class="question__value">
                            <b-form-input v-model="data.blok_ii.penanggung_jawab_teknis.nama"
                              placeholder="Tulisakan nama penanggung jawab teknis "
                              :state="data.blok_ii.penanggung_jawab_teknis.nama ? true : null">
                            </b-form-input>
                          </div>

                          <div class="question__name mt-2">Jabatan:</div>
                          <div class="question__value">
                            <ValidationProvider name="Jabatan penanggung jawab" rules="required" v-slot="{ errors }">
                              <b-form-input v-model="data.blok_ii.penanggung_jawab_teknis.jabatan"
                                placeholder="Tulisakan jabatan penanggung jawab teknis "
                                :state="errors[0] ? false : (data.blok_ii.penanggung_jawab_teknis.jabatan ? true : null)">
                              </b-form-input>
                              <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                          </div>

                          <div class="question__name mt-2">Alamat:</div>
                          <div class="question__value">
                            <ValidationProvider name="Alamat penanggung jawab" rules="required" v-slot="{ errors }">
                              <b-form-input v-model="data.blok_ii.penanggung_jawab_teknis.alamat"
                                placeholder="Tulisakan Alamat penanggung jawab teknis "
                                :state="errors[0] ? false : (data.blok_ii.penanggung_jawab_teknis.alamat ? true : null)">
                              </b-form-input>
                              <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                          </div>

                          <b-row class="mt-2">
                            <b-col>
                              <div class="question__name">Telepon:</div>
                              <div class="question__value">
                                <ValidationProvider name="Telepon penanggung jawab" rules="numeric" v-slot="{ errors }">
                                  <b-form-input v-model="data.blok_ii.penanggung_jawab_teknis.telepon"
                                    placeholder="Tulisakan Telepon penanggung jawab teknis "
                                    :state="errors[0] ? false : (data.blok_ii.penanggung_jawab_teknis.telepon ? true : null)">
                                  </b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                              </div>
                            </b-col>
                            <b-col>
                              <div class="question__name">Faksmile:</div>
                              <div class="question__value">
                                <b-form-input v-model="data.blok_ii.penanggung_jawab_teknis.faksimile"
                                  placeholder="Tulisakan Faksmile penanggung jawab teknis "
                                  :state="data.blok_ii.penanggung_jawab_teknis.faksimile ? true : null">
                                </b-form-input>
                              </div>
                            </b-col>
                            <b-col>
                              <div class="question__name">Email:</div>
                              <div class="question__value">
                                <ValidationProvider name="Email penanggung jawab" rules="email" v-slot="{ errors }">
                                  <b-form-input v-model="data.blok_ii.penanggung_jawab_teknis.email"
                                    placeholder="Tulisakan Email penanggung jawab teknis "
                                    :state="errors[0] ? false : (data.blok_ii.penanggung_jawab_teknis.email ? true : null)">
                                  </b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                              </div>
                            </b-col>
                          </b-row>
                        </div>

                      </div>
                    </div>
                  </div>
                </ValidationObserver>

                <ValidationObserver ref="blokIIIObserver" v-show="section.currentIndex == 3">
                  <div id="blok_iii" class="blok">
                    <div class="blok-title">III. Perencanaan dan Persiapan</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">3.1. Latar Belakang Kegiatan:</div>
                        <div class="question__value">
                          <ValidationProvider name="Latar Belakang Kegiatan" rules="required" v-slot="{ errors }"
                            mode="eager">
                            <b-form-textarea rows="3" v-model="data.blok_iii.latar_belakang_kegiatan"
                              placeholder="Tuliskan secara jelas Latar Belakang Kegiatan"
                              :state="errors[0] ? false : (data.blok_iii.latar_belakang_kegiatan ? true : null)">
                            </b-form-textarea>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">3.2. Tujuan Kegiatan:</div>
                        <div class="question__value">
                          <ValidationProvider name="Tujuan Kegiatan" rules="required" v-slot="{ errors }">
                            <b-form-textarea rows="3" v-model="data.blok_iii.tujuan_kegiatan"
                              placeholder="Tuliskan secara jelas Tujuan Kegiatan"
                              :state="errors[0] ? false : (data.blok_iii.tujuan_kegiatan ? true : null)">
                            </b-form-textarea>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question border-bottom-0">
                        <div class="question__name">3.3. Rencana Jadwal Kegiatan:</div>
                        <div class="table-wrapper mt-2">
                          <table class="table table--light">
                            <thead>
                              <tr>
                                <th colspan="2" class="w-50"></th>
                                <th class="text-center w-50">
                                  <div class="d-flex">
                                    <div class="mr-2" style="flex:1">
                                      Tanggal Mulai
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      Tanggal Selesai
                                    </div>
                                    <div class="w-30"></div>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-bold text-right w-1p"
                                  style="border-right:0 !important;padding-right:0 !important">A.</td>
                                <td colspan="2" class="text-bold">Perencanaan</td>
                              </tr>
                              <tr>
                                <td style="border-right:0 !important"></td>
                                <td class="pl-2 w-25" style="padding-top:12px !important">1. &nbsp;Perencanaan Kegiatan
                                </td>
                                <td class="text-center">
                                  <div
                                    v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan || [{ awal: null, akhir: null }]"
                                    :key="index" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + data.tahun"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan[0].awal"
                                        name="Tanggal Mulai Perencanaan" placeholder="Isikan Tanggal Mulai Perencanaan"
                                        v-if="index == 0" />
                                      <BDatePickerWithValidation :key="index"
                                        :rules="'required|after:' + data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan[index - 1].akhir + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + data.tahun"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan[index].awal"
                                        name="Tanggal Mulai Perencanaan" placeholder="Isikan Tanggal Mulai Perencanaan"
                                        v-else />
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan[index].awal"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan[index].akhir"
                                        name="Tanggal Selesai Perencanaan"
                                        placeholder="Isikan Tanggal Selesai Perencanaan" />
                                    </div>
                                    <div class="w-30">
                                      <b-button v-if="index == 0" class="button button--action button--action--view2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan.push({ awal: null, akhir: null })">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <b-button v-else class="button button--action button--action--delete2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style="border-right:0 !important"></td>
                                <td class="sub-title" style="padding-top:12px !important">2. &nbsp;Desain</td>
                                <td class="text-center">
                                  <div
                                    v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.desain || [{ awal: null, akhir: null }]"
                                    :key="index + 1" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan[0].awal + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + data.tahun"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.desain[0].awal"
                                        name="Tanggal Mulai Desain" placeholder="Isikan Tanggal Mulai Desain"
                                        v-if="index == 0" />
                                      <BDatePickerWithValidation :key="index"
                                        :rules="'required|after:' + data.blok_iii.rencana_jadwal_kegiatan.desain[index - 1].akhir + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + data.tahun"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.desain[index].awal"
                                        name="Tanggal Mulai Desain" placeholder="Isikan Tanggal Mulai Desain" v-else />
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.desain[index].awal"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.desain[index].akhir"
                                        name="Tanggal Selesai Desain" placeholder="Isikan Tanggal Selesai Desain" />
                                    </div>
                                    <div class="w-30">
                                      <b-button v-if="index == 0" class="button button--action button--action--view2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.desain.push({ awal: null, akhir: null })">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <b-button v-else class="button button--action button--action--delete2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.desain.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="text-bold">
                                <td class="text-right" style="border-right:0 !important;padding-right:0 !important">B.
                                </td>
                                <td colspan="3">Pengumpulan</td>
                              </tr>
                              <tr>
                                <td style="border-right:0 !important"></td>
                                <td class="sub-title" style="padding-top:12px !important">3. &nbsp;Pengumpulan Data</td>
                                <td class="text-center">
                                  <div
                                    v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data || [{ awal: null, akhir: null }]"
                                    :key="index + 1" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.desain[0].awal + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data[0].awal"
                                        name="Tanggal Mulai Pengumpulan Data"
                                        placeholder="Isikan Tanggal Mulai Pengumpulan Data" v-if="index == 0" />
                                      <BDatePickerWithValidation :key="index"
                                        :rules="'required|after:' + data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data[index - 1].akhir + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data[index].awal"
                                        name="Tanggal Mulai Pengumpulan Data"
                                        placeholder="Isikan Tanggal Mulai Pengumpulan Data" v-else />
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data[index].awal"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data[index].akhir"
                                        name="Tanggal Selesai Pengumpulan Data"
                                        placeholder="Isikan Tanggal Selesai Pengumpulan Data" />
                                    </div>
                                    <div class="w-30">
                                      <b-button v-if="index == 0" class="button button--action button--action--view2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data.push({ awal: null, akhir: null })">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <b-button v-else class="button button--action button--action--delete2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="text-bold">
                                <td class="text-right" style="border-right:0 !important;padding-right:0 !important">C.
                                </td>
                                <td colspan="3">Pemeriksaan</td>
                              </tr>
                              <tr>
                                <td style="border-right:0 !important"></td>
                                <td class="sub-title" style="padding-top:12px !important">4. &nbsp;Pengolahan Data</td>

                                <td class="text-center">
                                  <div
                                    v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data || [{ awal: null, akhir: null }]"
                                    :key="index + 1" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data[0].awal + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data[0].awal"
                                        name="Tanggal Mulai Pengolahan Data"
                                        placeholder="Isikan Tanggal Mulai Pengolahan Data" v-if="index == 0" />
                                      <BDatePickerWithValidation :key="index"
                                        :rules="'required|after:' + data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data[index - 1].akhir + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data[index].awal"
                                        name="Tanggal Mulai Pengolahan Data"
                                        placeholder="Isikan Tanggal Mulai Pengolahan Data" v-else />
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data[index].awal"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data[index].akhir"
                                        name="Tanggal Selesai Pengolahan Data"
                                        placeholder="Isikan Tanggal Selesai Pengolahan Data" />
                                    </div>
                                    <div class="w-30">
                                      <b-button v-if="index == 0" class="button button--action button--action--view2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data.push({ awal: null, akhir: null })">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <b-button v-else class="button button--action button--action--delete2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="text-bold">
                                <td class="text-right" style="border-right:0 !important;padding-right:0 !important">D.
                                </td>
                                <td colspan="3">Penyebarluasan</td>
                              </tr>
                              <tr>
                                <td style="border-right:0 !important"></td>
                                <td class="sub-title" style="padding-top:12px !important">5. &nbsp;Analisis</td>

                                <td class="text-center">
                                  <div
                                    v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.analisis || [{ awal: null, akhir: null }]"
                                    :key="index + 1" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data[0].awal + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.analisis[0].awal"
                                        name="Tanggal Mulai Analisis Data"
                                        placeholder="Isikan Tanggal Mulai Analisis Data" v-if="index == 0" />
                                      <BDatePickerWithValidation :key="index"
                                        :rules="'required|after:' + data.blok_iii.rencana_jadwal_kegiatan.analisis[index - 1].akhir + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.analisis[index].awal"
                                        name="Tanggal Mulai Analisis Data"
                                        placeholder="Isikan Tanggal Mulai Analisis Data" v-else />
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.analisis[index].awal"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.analisis[index].akhir"
                                        name="Tanggal Selesai Analisis Data"
                                        placeholder="Isikan Tanggal Selesai Analisis Data" />
                                    </div>
                                    <div class="w-30">
                                      <b-button v-if="index == 0" class="button button--action button--action--view2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.analisis.push({ awal: null, akhir: null })">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <b-button v-else class="button button--action button--action--delete2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.analisis.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style="border-right:0 !important"></td>
                                <td class="sub-title" style="padding-top:12px !important">6. &nbsp;Diseminasi Hasil</td>

                                <td class="text-center">
                                  <div
                                    v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil || [{ awal: null, akhir: null }]"
                                    :key="index + 1" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.analisis[0].awal + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[0].awal"
                                        name="Tanggal Mulai Diseminasi Data"
                                        placeholder="Isikan Tanggal Mulai Diseminasi Data" v-if="index == 0" />
                                      <BDatePickerWithValidation :key="index"
                                        :rules="'required|after:' + data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[index - 1].akhir + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[index].awal"
                                        name="Tanggal Mulai Diseminasi Data"
                                        placeholder="Isikan Tanggal Mulai Diseminasi Data" v-else />
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[index].awal"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[index].akhir"
                                        name="Tanggal Selesai Diseminasi Data"
                                        placeholder="Isikan Tanggal Selesai Diseminasi Data" />
                                    </div>
                                    <div class="w-30">
                                      <b-button v-if="index == 0" class="button button--action button--action--view2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil.push({ awal: null, akhir: null })">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <b-button v-else class="button button--action button--action--delete2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style="border-right:0 !important"></td>
                                <td class="sub-title" style="padding-top:12px !important">7. &nbsp;Evaluasi</td>

                                <td class="text-center">
                                  <div
                                    v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.evaluasi || [{ awal: null, akhir: null }]"
                                    :key="index + 1" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[0].awal + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.evaluasi[0].awal"
                                        name="Tanggal Mulai Evaluasi" placeholder="Isikan Tanggal Mulai Evaluasi"
                                        v-if="index == 0" />
                                      <BDatePickerWithValidation :key="index"
                                        :rules="'required|after:' + data.blok_iii.rencana_jadwal_kegiatan.evaluasi[index - 1].akhir + '|tahun: ' + (parseInt(data.tahun) - 3) + ', ' + (parseInt(data.tahun) + 1)"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.evaluasi[index].awal"
                                        name="Tanggal Mulai Evaluasi" placeholder="Isikan Tanggal Mulai Evaluasi"
                                        v-else />
                                    </div>
                                    <div class="mr-2" style="flex:1">
                                      <BDatePickerWithValidation
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.evaluasi[index].awal"
                                        v-model="data.blok_iii.rencana_jadwal_kegiatan.evaluasi[index].akhir"
                                        name="Tanggal Selesai Evaluasi" placeholder="Isikan Tanggal Selesai Evaluasi" />
                                    </div>
                                    <div class="w-30">
                                      <b-button v-if="index == 0" class="button button--action button--action--view2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.evaluasi.push({ awal: null, akhir: null })">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <b-button v-else class="button button--action button--action--delete2"
                                        @click="data.blok_iii.rencana_jadwal_kegiatan.evaluasi.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <ValidationObserver ref="blokIIIVariableObserver" v-slot="{ validate }">
                        <div class="question">
                          <div class="question__name">3.4. Variabel (Karakteristik) yang Dikumpulkan:</div>
                          <div class="table-wrapper mt-2">
                            <b-table-simple class="table table--light table--bordered">
                              <thead>
                                <tr>
                                  <th class="w-30">No</th>
                                  <th>Nama Variabel (Kharakteristik)</th>
                                  <th class="w-200">Konsep</th>
                                  <th>Definsi</th>
                                  <th class="w-200">Referensi Waktu<br>(Periode Enumerasi)</th>
                                  <th class="w-51">Aksi</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in data.blok_iii.variabel_yang_dikumpulkan" :key="index">
                                  <td class="text-center">
                                    {{ index + 1 }}
                                  </td>
                                  <td>
                                    <ValidationProvider :name="'Nama Variabel ke-' + (index + 1)" rules="required"
                                      v-slot="{ errors }">
                                      <b-form-textarea rows="3"
                                        v-model="data.blok_iii.variabel_yang_dikumpulkan[index].nama"
                                        placeholder="Tuliskan Nama Variabel"
                                        :state="errors[0] ? false : (data.blok_iii.variabel_yang_dikumpulkan.nama ? true : null)">
                                      </b-form-textarea>
                                      <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                    </ValidationProvider>
                                  </td>
                                  <td>
                                    <ValidationProvider :name="'Konsep Variabel ke-' + (index + 1)" rules="required"
                                      v-slot="{ errors }">
                                      <b-form-textarea rows="3"
                                        v-model="data.blok_iii.variabel_yang_dikumpulkan[index].konsep"
                                        placeholder="Tuliskan Konsep Variabel yang digunakan"
                                        :state="errors[0] ? false : (data.blok_iii.variabel_yang_dikumpulkan.konsep ? true : null)">
                                      </b-form-textarea>
                                      <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                    </ValidationProvider>
                                  </td>
                                  <td>
                                    <ValidationProvider :name="'Definisi Variabel ke-' + (index + 1)" rules="required"
                                      v-slot="{ errors }">
                                      <b-form-textarea rows="3"
                                        v-model="data.blok_iii.variabel_yang_dikumpulkan[index].definisi"
                                        placeholder="Tuliskan secara jelas Definisi Variabel"
                                        :state="errors[0] ? false : (data.blok_iii.variabel_yang_dikumpulkan.definisi ? true : null)">
                                      </b-form-textarea>
                                      <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                    </ValidationProvider>
                                  </td>
                                  <td>
                                    <ValidationProvider :name="'Referensi Waktu Variabel ke-' + (index + 1)"
                                      rules="required" v-slot="{ errors }">
                                      <b-form-textarea rows="3"
                                        v-model="data.blok_iii.variabel_yang_dikumpulkan[index].referensi_waktu"
                                        placeholder="Tuliskan Referensi Waktu Variabeln"
                                        :state="errors[0] ? false : (data.blok_iii.variabel_yang_dikumpulkan.referensi_waktu ? true : null)">
                                      </b-form-textarea>
                                      <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                    </ValidationProvider>
                                  </td>
                                  <td class="d-flex align-items-center flex-column">

                                    <b-button v-if="data.blok_iii.variabel_yang_dikumpulkan.length > 1"
                                      class="button button--action button--action--delete2 mb-2"
                                      @click="data.blok_iii.variabel_yang_dikumpulkan.splice(index, 1)">
                                      <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                      </VueFeather>
                                    </b-button>

                                    <b-button v-if="index == data.blok_iii.variabel_yang_dikumpulkan.length - 1"
                                      class="button button--action button--action--view2" @click="() => {
                                        validate().then(result => {
                                          if (result) {
                                            data.blok_iii.variabel_yang_dikumpulkan.push({ nama: null, konsep: null, definisi: null, referensi_waktu: null });
                                          }
                                        })
                                      }">
                                      <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                      </VueFeather>
                                    </b-button>
                                  </td>
                                </tr>
                              </tbody>
                            </b-table-simple>
                          </div>
                        </div>
                      </ValidationObserver>

                    </div>
                  </div>
                </ValidationObserver>

                <ValidationObserver ref="blokIVObserver" v-show="section.currentIndex == 4">
                  <div id="blok_iv" class="blok">
                    <div class="blok-title">IV. Desain Kegiatan</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">4.1. Kegiatan Ini Dilakukan:</div>
                        <div class="question__value">
                          <b-form-radio-group 
                            id="radio_blok_iv_kegiatan_ini_dilakukan"
                            name="radio_blok_iv_kegiatan_ini_dilakukan"
                            key="rg_kegiatan_ini_dilakukan"
                            v-model="data.blok_iv.kegiatan_ini_dilakukan" 
                          >
                            <b-form-radio 
                              v-for="item in options.kegiatan_ini_dilakukan" 
                              :key="'keg_opt_' + item.id" 
                              :value="item.id"
                              :name="'radio_blok_iv_kegiatan_ini_dilakukan'"
                            >
                              {{ item.label }}
                            </b-form-radio>
                          </b-form-radio-group>
                          <ValidationProvider 
                            vid="kegiatan_ini_dilakukan"
                            name="Kegiatan Ini Dilakukan" 
                            rules="required" 
                            mode="eager"
                            v-slot="{errors}"
                          >
                            <input type="hidden" :value="data.blok_iv.kegiatan_ini_dilakukan" />
                            <b-form-invalid-feedback :state="false" v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question" v-if="data.blok_iv.kegiatan_ini_dilakukan == 'BERULANG'">
                        <div class="question__name">4.2. Frekuensi Penyelenggaraan:</div>
                        <div class="question__value">
                          <b-form-radio-group 
                            id="radio_blok_iv_frekuensi_penyelanggara"
                            name="radio_blok_iv_frekuensi_penyelanggara"
                            key="rg_frekuensi_penyelanggara"
                            v-model="data.blok_iv.frekuensi_penyelanggara" 
                          >
                            <b-form-radio 
                              v-for="item in options.frekuensi_penyelanggara" 
                              :key="'frek_opt_' + item.id" 
                              :value="item.id"
                              :name="'radio_blok_iv_frekuensi_penyelanggara'"
                            >
                              {{ item.label }}
                            </b-form-radio>
                          </b-form-radio-group>
                          <ValidationProvider 
                            vid="frekuensi_penyelanggara"
                            name="Frekuensi Penyelenggaraan" 
                            :rules="data.blok_iv.kegiatan_ini_dilakukan == 'BERULANG' ? 'required' : ''" 
                            mode="eager"
                            v-slot="{errors}"
                          >
                            <input type="hidden" :value="data.blok_iv.frekuensi_penyelanggara" />
                            <b-form-invalid-feedback :state="false" v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">4.3. Tipe Pengumpulan Data:</div>
                        <div class="question__value">
                          <b-form-radio-group 
                            id="radio_blok_iv_tipe_pengumpulan_data"
                            name="radio_blok_iv_tipe_pengumpulan_data"
                            key="rg_tipe_pengumpulan_data"
                            v-model="data.blok_iv.tipe_pengumpulan_data" 
                          >
                            <b-form-radio 
                              v-for="item in options.tipe_pengumpulan_data" 
                              :key="'tipe_opt_' + item.id" 
                              :value="item.id"
                              :name="'radio_blok_iv_tipe_pengumpulan_data'"
                            >
                              {{ item.label }}
                            </b-form-radio>
                          </b-form-radio-group>
                          <ValidationProvider 
                            vid="tipe_pengumpulan_data"
                            name="Tipe Pengumpulan Data" 
                            rules="required" 
                            mode="eager"
                            v-slot="{errors}"
                          >
                            <input type="hidden" :value="data.blok_iv.tipe_pengumpulan_data" />
                            <b-form-invalid-feedback :state="false" v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">4.4. Cakupan Wilayah Pengumpulan Data:</div>
                        <div class="question__value">
                          <b-form-radio-group 
                            id="radio_blok_iv_cakupan_wilayah_pengumpulan_data"
                            name="radio_blok_iv_cakupan_wilayah_pengumpulan_data"
                            key="rg_cakupan_wilayah_pengumpulan_data"
                            v-model="data.blok_iv.cakupan_wilayah_pengumpulan_data" 
                          >
                            <b-form-radio 
                              v-for="item in options.cakupan_wilayah_pengumpulan_data" 
                              :key="'cakupan_opt_' + item.id" 
                              :value="item.id"
                              :name="'radio_blok_iv_cakupan_wilayah_pengumpulan_data'"
                            >
                              {{ item.label }}
                            </b-form-radio>
                          </b-form-radio-group>
                          <ValidationProvider 
                            vid="cakupan_wilayah_pengumpulan_data"
                            name="Cakupan Wilayah Pengumpulan Data" 
                            rules="required" 
                            mode="eager"
                            v-slot="{errors}"
                          >
                            <input type="hidden" :value="data.blok_iv.cakupan_wilayah_pengumpulan_data" />
                            <b-form-invalid-feedback :state="false" v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question border-bottom-0"
                        v-if="data.blok_iv.cakupan_wilayah_pengumpulan_data == 'SEBAGIAN_WILAYAH_INDONESIA'">
                        <div class="question__name">4.5. Wilayah Kegiatan:</div>
                        <div class="w-100 mt-2">
                          <ValidationProvider name="Wilayah Kegiatan" rules="required" v-slot="{ errors }">
                            <Treeselect v-model="formExt.wilayah" valueFormat="object" placeholder="Pilih Wilayah"
                              class="hide-label" value-consists-of="LEAF_PRIORITY" :multiple="true"
                              :options="options.userWilayah" :loadOptions="loadOptions" :normalizer="wilayahNormalizer"
                              :class="errors[0] ? 'invalid' : (formExt.wilayah ? 'valid' : null)">
                            </Treeselect>
                            <b-form-invalid-feedback :state="!errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="text-12 mt-1 text-left w-100">Pilih untuk menambahkan atau menghapus cakupan
                          wilayah,
                          Jika pilihan wilayah kosong, maka isikan dulu pertanyaan <b>Instansi Penyelenggara</b></div>
                        <div class="table-wrapper mt-2" style="overflow-y: auto;max-height: 400px;">
                          <table class="table table--light table--bordered">
                            <thead>
                              <tr>
                                <th class="w-40">No.</th>
                                <th class="text-left">Provinsi</th>
                                <th class="text-left">Kabupaten/Kota</th>
                                <!-- <th class="w-1p">Hapus</th> -->
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data"
                                :key="index">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td>{{ item.nama_provinsi }}</td>
                                <td>{{ item.nama_kabupaten_kota }}</td>
                              </tr>
                              <tr v-if="data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data.length == 0">
                                <td colspan="3">
                                  <div class="table__empty">
                                    <div>
                                      <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                      Belum ada wilayah yang diinput
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">4.6. Metode Pengumpulan Data:</div>
                        <div class="question__value">
                          <ValidationProvider name="Metode Pengumpulan Data"
                            :rules="Object.values(data.blok_iv.metode_pengumpulan_data).filter(val => val == true).length == 0 ? 'required|is:true' : ''"
                            v-slot="{ errors }">
                            <b-form-checkbox
                              v-model="data.blok_iv.metode_pengumpulan_data.wawancara">Wawancara</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_iv.metode_pengumpulan_data.mengisi_kuesioner_sendiri">Mengisi Kuesioner
                              Sendiri</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_iv.metode_pengumpulan_data.pengamatan">Pengamatan</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_iv.metode_pengumpulan_data.pengumpulan_data_sekunder">Pengumpulan Data
                              Sekunder</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_iv.metode_pengumpulan_data.lainnya">Lainnya</b-form-checkbox>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          <ValidationProvider name="Metode Pengumpulan Data Lainnya" rules="required" v-slot="{ errors }"
                            v-if="data.blok_iv.metode_pengumpulan_data.lainnya">
                            <b-form-input style="margin-left:3px"
                              v-model="data.blok_iv.metode_pengumpulan_data.metode_pengumpulan_lainnya"
                              placeholder="Tulisakan Metode Pengumpulan Data Lainnya"
                              :state="errors[0] ? false : (data.blok_iv.metode_pengumpulan_data.metode_pengumpulan_lainnya ? true : null)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">4.7. Sarana Pengumpulan Data:</div>
                        <div class="question__value">
                          <ValidationProvider name="Sarana Pengumpulan Data"
                            :rules="Object.values(data.blok_iv.sarana_pengumpulan_data).filter(val => val == true).length == 0 ? 'required|is:true' : ''"
                            v-slot="{ errors }">
                            <b-form-checkbox v-model="data.blok_iv.sarana_pengumpulan_data.papi">Paper-assisted Personal
                              Interviewing (PAPI)</b-form-checkbox>
                            <b-form-checkbox v-model="data.blok_iv.sarana_pengumpulan_data.capi">Computer-assisted
                              Personal
                              Interviewing (CAPI)</b-form-checkbox>
                            <b-form-checkbox v-model="data.blok_iv.sarana_pengumpulan_data.cati">Computer-assisted
                              Telephones Interviewing (CATI)</b-form-checkbox>
                            <b-form-checkbox v-model="data.blok_iv.sarana_pengumpulan_data.cawi">Computer Aided Web
                              Interviewing (CAWI)</b-form-checkbox>
                            <b-form-checkbox v-model="data.blok_iv.sarana_pengumpulan_data.mail">Mail</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_iv.sarana_pengumpulan_data.lainnya">Lainnya</b-form-checkbox>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          <ValidationProvider name="Sarana Pengumpulan Data Lainnya" rules="required" v-slot="{ errors }"
                            v-if="data.blok_iv.sarana_pengumpulan_data.lainnya">
                            <b-form-input style="margin-left:3px"
                              v-model="data.blok_iv.sarana_pengumpulan_data.sarana_pengumpulan_lainnya"
                              placeholder="Tulisakan Sarana Pengumpulan Data Lainnya"
                              :state="errors[0] ? false : (data.blok_iv.sarana_pengumpulan_data.sarana_pengumpulan_lainnya ? true : null)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">4.8. Unit Pengumpulan Data:</div>
                        <div class="question__value">
                          <ValidationProvider name="Unit Pengumpulan Data"
                            :rules="Object.values(data.blok_iv.unit_pengumpulan_data).filter(val => val == true).length == 0 ? 'required|is:true' : ''"
                            v-slot="{ errors }">
                            <b-form-checkbox
                              v-model="data.blok_iv.unit_pengumpulan_data.individu">Individu</b-form-checkbox>
                            <b-form-checkbox v-model="data.blok_iv.unit_pengumpulan_data.rumah_tangga">Rumah
                              Tangga</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_iv.unit_pengumpulan_data.usaha_atau_perusahaan">Usaha/Perusahaan</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_iv.unit_pengumpulan_data.lainnya">Lainnya</b-form-checkbox>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          <ValidationProvider name="Unit Pengumpulan Data Lainnya" rules="required" v-slot="{ errors }"
                            v-if="data.blok_iv.unit_pengumpulan_data.lainnya">
                            <b-form-input style="margin-left:3px"
                              v-model="data.blok_iv.unit_pengumpulan_data.unit_pengumpulan_data_lainnya"
                              placeholder="Tulisakan Unit Pengumpulan Data Lainnya"
                              :state="errors[0] ? false : (data.blok_iv.unit_pengumpulan_data.unit_pengumpulan_data_lainnya ? true : null)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </ValidationObserver>

                <ValidationObserver ref="blokVObserver" v-show="section.currentIndex == 5"
                  v-if="data.cara_pengumpulan_data == 'SURVEI'">
                  <div id="blok_v" class="blok">
                    <div class="blok-title">
                      <div>V. Desain Sampel</div>
                      <div class="text-12 text-semi-bold" style="text-transform:none">Diisi jika cara pengumpulan data
                        adalah Survei</div>
                    </div>
                    <div class="blok-detail">
                      <div class="question" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                        <div class="question__name">5.1. Jenis Rancangan Sampel:</div>
                        <div class="question__value">
                          <!-- <b-form-radio-group v-model="data.blok_v.jenis_rancangan_sampel" :options="options.jenis_rancangan_sampel.map(x=>({text:x.label,value:x.id}))" ></b-form-radio-group> -->
                          <ValidationProvider name="Jenis Rancangan Sampel"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' ? 'required' : ''" mode="eager"
                            v-slot="{ errors }">
                            <b-form-radio-group v-model="data.blok_v.jenis_rancangan_sampel"
                              :options="options.jenis_rancangan_sampel.map(x => ({ text: x.label, value: x.id }))"
                              :state="errors[0] ? false : (data.blok_v.jenis_rancangan_sampel ? true : null)">
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                        <div class="question__name">5.2. Metode Pemilihan Sampel Tahap Terakhir:</div>
                        <div class="question__value">
                          <!-- <b-form-radio-group 
                            v-model="data.blok_v.metode_pemilihan_sampel_tahap_terakhir" 
                            :options="options.metode_pemilihan_sampel_tahap_terakhir.map(x=>({text:x.label,value:x.id}))" 
                            @input="data.blok_v.metode_yang_digunakan = data.blok_v.metode_pemilihan_sampel_tahap_terakhir=='SAMPEL_PROBABILITAS' ? 'SIMPLE_RANDOM_SAMPLING':'QUOTA_SAMPLING'"
                          ></b-form-radio-group> -->
                          <ValidationProvider name="Metode Pemilihan Sampel Tahap Terakhir"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' ? 'required' : ''" mode="eager"
                            v-slot="{ errors }">
                            <b-form-radio-group v-model="data.blok_v.metode_pemilihan_sampel_tahap_terakhir"
                              :options="options.metode_pemilihan_sampel_tahap_terakhir.map(x => ({ text: x.label, value: x.id }))"
                              :state="errors[0] ? false : (data.blok_v.metode_pemilihan_sampel_tahap_terakhir ? true : null)">
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question"
                        v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'">
                        <div class="question__name">5.3. Metode Yang Digunakan:</div>
                        <div class="question__value">
                          <ValidationProvider name="Metode Yang Digunakan"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS' ? 'required' : ''"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group
                              v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'"
                              v-model="data.blok_v.metode_yang_digunakan"
                              :options="options.metode_sampel_probabilitas.map(x => ({ text: x.label, value: x.id }))" stacked>
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question"
                        v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_NONPROBABILITAS'">
                        <div class="question__name">5.3. Metode Yang Digunakan:</div>
                        <div class="question__value">
                          <ValidationProvider name="Metode Yang Digunakan"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_NONPROBABILITAS' ? 'required' : ''"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group
                              v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_NONPROBABILITAS'"
                              v-model="data.blok_v.metode_yang_digunakan"
                              :options="options.metode_sampel_nonprobabilitas.map(x => ({ text: x.label, value: x.id }))"
                              stacked>
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question"
                        v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'">
                        <div class="question__name">5.4. Kerangka Sampel Tahap Terakhir:</div>
                        <div class="question__value">
                          <ValidationProvider name="Kerangka Sampel Tahap Terakhir"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS' ? 'required' : ''"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group
                              v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'"
                              v-model="data.blok_v.kerangka_sampel_tahap_terakhir"
                              :options="options.kerangka_sampel_tahap_terakhir.map(x => ({ text: x.label, value: x.id }))"
                              stacked>
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question"
                        v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'">
                        <div class="question__name">5.5. Fraksi Sampel Keseluruhan:</div>
                        <div class="question__value">
                          <ValidationProvider name="Fraksi Sampel Keseluruhan"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS' ? 'required' : ''"
                            v-slot="{ errors }">
                            <b-form-textarea
                              v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'"
                              rows="3" v-model="data.blok_v.fraksi_sampel_keseluruhan"
                              placeholder="Tuliskan Fraksi Sampel Keseluruhan"
                              :state="errors[0] ? false : (data.blok_v.fraksi_sampel_keseluruhan ? true : null)">
                            </b-form-textarea>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question"
                        v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'">
                        <div class="question__name">5.6. Nilai Perkiraan Sampling Error Variabel Utama:</div>
                        <div class="question__value">
                          <ValidationProvider name="Nilai Perkiraan Sampling Error Variabel Utama"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS' ? 'required' : ''"
                            v-slot="{ errors }">
                            <b-form-input
                              v-if="data.cara_pengumpulan_data == 'SURVEI' & data.blok_v.metode_pemilihan_sampel_tahap_terakhir == 'SAMPEL_PROBABILITAS'"
                              v-model="data.blok_v.nilai_perkiraan_sampling_error_variabel_utama"
                              placeholder="Tulisakan Nilai Perkiraan Sampling Error Variabel Utama"
                              :state="errors[0] ? false : (data.blok_v.nilai_perkiraan_sampling_error_variabel_utama ? true : null)"></b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                        <div class="question__name">5.7. Unit Sampel:</div>
                        <div class="question__value">
                          <ValidationProvider name="Unit Sampel"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' ? 'required' : ''" v-slot="{ errors }">
                            <b-form-input v-if="data.cara_pengumpulan_data == 'SURVEI'"
                              v-model="data.blok_v.unit_sampel" placeholder="Tulisakan Unit Sampel"
                              :state="errors[0] ? false : (data.blok_v.unit_sampel ? true : null)"></b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                        <div class="question__name">5.8. Unit Observasi:</div>
                        <div class="question__value">
                          <ValidationProvider name="Unit Observasi"
                            :rules="data.cara_pengumpulan_data == 'SURVEI' ? 'required' : ''" v-slot="{ errors }">
                            <b-form-input v-if="data.cara_pengumpulan_data == 'SURVEI'"
                              v-model="data.blok_v.unit_observasi" placeholder="Tulisakan Unit Observasi"
                              :state="errors[0] ? false : (data.blok_v.unit_observasi ? true : null)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>

                </ValidationObserver>

                <ValidationObserver ref="blokVIObserver" v-show="section.currentIndex == 6">
                  <div id="blok_vi" class="blok">
                    <div class="blok-title">VI. Pengumpulan Data</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">6.1. Apakah Melakukan Uji Coba (Pilot Survey)?</div>
                        <div class="question__value">
                          <!-- <b-form-radio-group v-model="data.blok_vi.apakah_melakukan_uji_coba" :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))" ></b-form-radio-group> -->

                          <ValidationProvider name="Apakah Melakukan Uji Coba (Pilot Survey)" rules="required"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group v-model="data.blok_vi.apakah_melakukan_uji_coba"
                              :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))" stacked>
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">6.2. Metode Pemeriksaan Kualitas Pengumpulan Data:</div>
                        <div class="question__value">
                          <ValidationProvider name="Metode Pemeriksaan Kualitas Pengumpulan Data"
                            :rules="Object.values(data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data).filter(val => val == true).length == 0 ? 'required|is:true' : ''"
                            v-slot="{ errors }">
                            <b-form-checkbox
                              v-model="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.kunjungan_kembali">Kunjungan
                              Kembali</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.supervisi">Supervisi</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.taskforce">Task
                              Force</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya">Lainnya</b-form-checkbox>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          <ValidationProvider name="Metode Pengumpulan Data Lainnya" rules="required" v-slot="{ errors }"
                            v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya">
                            <b-form-input style="margin-left:3px"
                              v-model="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.metode_pemeriksaan_kualitas_pengumpulan_data_lainnya"
                              placeholder="Tulisakan Metode Pengumpulan Data Lainnya"
                              :state="errors[0] ? false : (data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.metode_pemeriksaan_kualitas_pengumpulan_data_lainnya ? true : null)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">6.3. Apakah Melakukan Penyesuaian Nonrespon?</div>
                        <div class="question__value">
                          <!-- <b-form-radio-group v-model="data.blok_vi.apakah_melakukan_penyesuaian_nonrespon" :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))"></b-form-radio-group> -->
                          <ValidationProvider name="Apakah Melakukan Penyesuaian Nonrespon" rules="required"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group v-model="data.blok_vi.apakah_melakukan_penyesuaian_nonrespon"
                              :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))"
                              :state="errors[0] ? false : (data.blok_vi.apakah_melakukan_penyesuaian_nonrespon ? true : null)">
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question"
                        v-if="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati">
                        <div class="question__name">6.4. Petugas Pengumpulan Data:</div>
                        <div class="question__value">
                          <!-- <b-form-radio-group v-model="data.blok_vi.petugas_pengumpulan_data" :options="options.petugas_pengumpulan_data.map(x=>({text:x.label,value:x.id}))" stacked></b-form-radio-group> -->
                          <ValidationProvider name="Petugas Pengumpulan Data"
                            :rules="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati ? 'required' : ''"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group
                              v-if="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati"
                              v-model="data.blok_vi.petugas_pengumpulan_data"
                              :options="options.petugas_pengumpulan_data.map(x => ({ text: x.label, value: x.id }))"
                              :state="errors[0] ? false : (data.blok_vi.petugas_pengumpulan_data ? true : null)">
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question"
                        v-if="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati">
                        <div class="question__name">6.5. Persyaratan Pendidikan Terendah Petugas Pengumpulan Data:</div>
                        <div class="question__value">
                          <!-- <b-form-radio-group v-model="data.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data" :options="options.persyaratan_pendidikan_terendah_petugas_pengumpulan_data.map(x=>({text:x.label,value:x.id}))" stacked></b-form-radio-group> -->
                          <ValidationProvider name="Persyaratan Pendidikan Terendah Petugas Pengumpulan Data"
                            :rules="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati ? 'required' : ''"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group
                              v-if="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati"
                              v-model="data.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data"
                              :options="options.persyaratan_pendidikan_terendah_petugas_pengumpulan_data.map(x => ({ text: x.label, value: x.id }))"
                              :state="errors[0] ? false : (data.blok_vi.petugas_pengumpulan_data ? true : null)">
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="question"
                        v-if="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati">
                        <div class="question__name">6.6. Jumlah Petugas:</div>
                        <div>
                          <div class="d-flex align-items-center my-2">
                            <ValidationProvider name="Supervisor/penyelia/pengawas"
                              :rules="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati ? 'required' : ''"
                              v-slot="{ errors }">
                              <b-input-group append="Orang">
                                <template #prepend>
                                  <b-input-group-text
                                    class="text-13 text-medium w-230">Supervisor/penyelia/pengawas</b-input-group-text>
                                </template>
                                <template #append>
                                  <b-input-group-text class="text-13 text-medium">Orang</b-input-group-text>
                                </template>
                                <b-form-input style="margin-top:0 !important"
                                  v-model="data.blok_vi.jumlah_petugas_supervisor"
                                  placeholder="Tulisakan jumlah Supervisor/penyelia/pengawas"
                                  :state="errors[0] ? false : (data.blok_vi.jumlah_petugas_supervisor ? true : null)">
                                </b-form-input>
                              </b-input-group>
                              <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                          </div>
                          <div class="d-flex align-items-center">
                            <ValidationProvider name="Pengumpul data/enumerator"
                              :rules="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati ? 'required|min_value:' + data.blok_vi.jumlah_petugas_supervisor : ''"
                              v-slot="{ errors }">
                              <b-input-group append="Orang">
                                <template #prepend>
                                  <b-input-group-text class="text-13 text-medium w-230">Pengumpul
                                    data/enumerator</b-input-group-text>
                                </template>
                                <template #append>
                                  <b-input-group-text class="text-13 text-medium">Orang</b-input-group-text>
                                </template>
                                <b-form-input style="margin-top:0 !important"
                                  v-model="data.blok_vi.jumlah_petugas_enumerator"
                                  placeholder="Tulisakan jumlah Pengumpul data/enumerator"
                                  :state="errors[0] ? false : (data.blok_vi.jumlah_petugas_enumerator ? true : null)">
                                </b-form-input>
                              </b-input-group>
                              <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                      <div class="question"
                        v-if="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati">
                        <div class="question__name">6.7. Apakah Melakukan Pelatihan Petugas?</div>
                        <div class="question__value">
                          <!-- <b-form-radio-group v-model="data.blok_vi.apakah_melakukan_pelatihan_petugas" :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))" ></b-form-radio-group> -->
                          <ValidationProvider name="Apakah Melakukan Pelatihan Petugas"
                            :rules="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati ? 'required' : ''"
                            mode="eager" v-slot="{ errors }">
                            <b-form-radio-group
                              v-if="data.blok_iv.sarana_pengumpulan_data.papi || data.blok_iv.sarana_pengumpulan_data.capi || data.blok_iv.sarana_pengumpulan_data.cati"
                              v-model="data.blok_vi.apakah_melakukan_pelatihan_petugas"
                              :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))"
                              :state="errors[0] ? false : (data.blok_vi.apakah_melakukan_pelatihan_petugas ? true : null)">
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </ValidationObserver>

                <ValidationObserver ref="blokVIIObserver" v-show="section.currentIndex == 7">
                  <div id="blok_vii" class="blok">
                    <div class="blok-title">VII. Pengolahan Dan Analisis</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">7.1. Tahapan Pengolahan Data:</div>
                        <div>
                          <div class="d-flex align-items-center">
                            <div class="question__value w-200">Penyuntingan (Editing)</div>
                            <div class="w-10">:</div>
                            <div class="question__value">
                              <!-- <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.editing " :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))" ></b-form-radio-group> -->
                              <ValidationProvider name="Penyuntingan (Editing)" rules="required" mode="eager"
                                v-slot="{ errors }">
                                <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.editing"
                                  :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))"
                                  :state="errors[0] ? false : (data.blok_vii.tahapan_pengolahan_data.editing ? true : null)">
                                </b-form-radio-group>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>

                            </div>
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="question__value w-200">Penyandian (Coding)</div>
                            <div class="w-10">:</div>
                            <div class="question__value">
                              <!-- <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.coding " :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))" ></b-form-radio-group> -->
                              <ValidationProvider name="Penyandian (Coding)" rules="required" mode="eager"
                                v-slot="{ errors }">
                                <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.coding"
                                  :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))"
                                  :state="errors[0] ? false : (data.blok_vii.tahapan_pengolahan_data.coding ? true : null)">
                                </b-form-radio-group>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="question__value w-200">Data Entry</div>
                            <div class="w-10">:</div>
                            <div class="question__value">
                              <!-- <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.data_entry " :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))" ></b-form-radio-group> -->
                              <ValidationProvider name="Data Entry" rules="required" mode="eager" v-slot="{ errors }">
                                <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.data_entry"
                                  :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))"
                                  :state="errors[0] ? false : (data.blok_vii.tahapan_pengolahan_data.data_entry ? true : null)">
                                </b-form-radio-group>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="question__value w-200">Penyahihan (Validasi)</div>
                            <div class="w-10">:</div>
                            <div class="question__value ">
                              <!-- <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.validasi " :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))" ></b-form-radio-group> -->
                              <ValidationProvider name="Penyahihan (Validasi)" rules="required" mode="eager"
                                v-slot="{ errors }">
                                <b-form-radio-group v-model="data.blok_vii.tahapan_pengolahan_data.validasi"
                                  :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))"
                                  :state="errors[0] ? false : (data.blok_vii.tahapan_pengolahan_data.validasi ? true : null)">
                                </b-form-radio-group>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">7.2. Metode Analisis:</div>
                        <div class="question__value">
                          <ValidationProvider name="Metode Analisis" rules="required" mode="eager" v-slot="{ errors }">
                            <b-form-radio-group v-model="data.blok_vii.metode_analisis"
                              :options="options.metode_analisis.map(x => ({ text: x.label, value: x.id }))"
                              :state="errors[0] ? false : (data.blok_vii.metode_analisis ? true : null)">
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>


                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">7.3. Unit Analisis:</div>
                        <div class="question__value">
                          <ValidationProvider name="Unit Analisis"
                            :rules="Object.values(data.blok_vii.unit_analsis).filter(val => val == true).length == 0 ? 'required|is:true' : ''"
                            v-slot="{ errors }" mode="eager">
                            <b-form-checkbox v-model="data.blok_vii.unit_analsis.individu">Individu</b-form-checkbox>
                            <b-form-checkbox v-model="data.blok_vii.unit_analsis.rumah_tangga">Rumah
                              Tangga</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_vii.unit_analsis.usaha_atau_perusahaan">Usaha/Perusahaan</b-form-checkbox>
                            <b-form-checkbox v-model="data.blok_vii.unit_analsis.lainnya">Lainnya</b-form-checkbox>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          <ValidationProvider name="Unit Analisis Lainnya"
                            :rules="data.blok_vii.unit_analsis.lainnya ? 'required' : ''" v-slot="{ errors }"
                            v-if="data.blok_vii.unit_analsis.lainnya" mode="eager">
                            <b-form-input v-if="data.blok_vii.unit_analsis.lainnya" style="margin-left:3px"
                              v-model="data.blok_vii.unit_analsis.unit_analisis_lainnya"
                              placeholder="Tulisakan Unit Analisis Lainnya"
                              :state="errors[0] ? false : (data.blok_vii.unit_analsis.unit_analisis_lainnya ? true : null)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">7.4. Tingkat Penyajian Hasil Analisis:</div>
                        <div class="question__value">
                          <ValidationProvider name="Tingkat Penyajian Hasil Analisis"
                            :rules="Object.values(data.blok_vii.tingkat_penyajian_hasil_analisis).filter(val => val == true).length == 0 ? 'required|is:true' : ''"
                            v-slot="{ errors }" mode="eager">
                            <b-form-checkbox
                              v-model="data.blok_vii.tingkat_penyajian_hasil_analisis.nasional">Nasional</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_vii.tingkat_penyajian_hasil_analisis.provinsi">Provinsi</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_vii.tingkat_penyajian_hasil_analisis.kabupaten_atau_kota">Kabupaten/Kota</b-form-checkbox>
                            <b-form-checkbox
                              v-model="data.blok_vii.tingkat_penyajian_hasil_analisis.lainnya">Lainnya</b-form-checkbox>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          <ValidationProvider name="Tingkat Penyajian Hasil Analisis Lainnya"
                            :rules="data.blok_vii.tingkat_penyajian_hasil_analisis.lainnya ? 'required' : ''"
                            v-slot="{ errors }" v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.lainnya"
                            mode="eager">
                            <b-form-input v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.lainnya"
                              style="margin-left:3px"
                              v-model="data.blok_vii.tingkat_penyajian_hasil_analisis.tingkat_penyajian_hasil_analisis_lainnya"
                              placeholder="Tuliskan Tingkat Penyajian Hasil Analisis Lainnya"
                              :state="errors[0] ? false : (data.blok_vii.tingkat_penyajian_hasil_analisis.tingkat_penyajian_hasil_analisis_lainnya ? true : null)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                    </div>
                  </div>
                </ValidationObserver>

                <ValidationObserver ref="blokVIIIObserver" v-show="section.currentIndex == 8">
                  <div id="blok_viii" class="blok">
                    <div class="blok-title">VIII. Diseminasi Hasil</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">8.1. Produk Kegiatan yang Tersedia untuk Umum</div>
                        <div>
                          <div class="d-flex align-items-center">
                            <div class="question__value w-200">Tercetak (Hardcopy)</div>
                            <div class="w-10">:</div>
                            <div class="question__value">
                              <b-form-radio-group v-model="data.blok_viii.ketersediaan_produk_tercetak"
                                :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))" @input="() => {
                                  data.blok_viii.rencana_jadwal_rilis_produk_tercetak = data.blok_viii.ketersediaan_produk_tercetak ? [null] : [];
                                }">
                              </b-form-radio-group>
                            </div>
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="question__value w-200">Digital (Softcopy)</div>
                            <div class="w-10">:</div>
                            <div class="question__value">
                              <b-form-radio-group v-model="data.blok_viii.ketersediaan_produk_digital"
                                :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))" @input="() => {
                                  data.blok_viii.rencana_jadwal_rilis_produk_digital = data.blok_viii.ketersediaan_produk_digital ? [null] : [];
                                }">
                              </b-form-radio-group>
                            </div>
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="question__value w-200">Data Mikro</div>
                            <div class="w-10">:</div>
                            <div class="question__value">
                              <b-form-radio-group v-model="data.blok_viii.ketersediaan_produk_mikrodata"
                                :options="options.ya_tidak.map(x => ({ text: x.label, value: x.id }))" @input="() => {
                                  data.blok_viii.rencana_jadwal_rilis_produk_mikrodata = data.blok_viii.ketersediaan_produk_mikrodata ? [null] : [];
                                }">
                              </b-form-radio-group>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="question"
                        v-if="data.blok_viii.ketersediaan_produk_tercetak || data.blok_viii.ketersediaan_produk_digital || data.blok_viii.ketersediaan_produk_mikrodata">
                        <div class="question__name">8.2. Rencana Rilis Produk Kegiatan</div>
                        <div class="table-wrapper mt-2">
                          <table class="table table--light table--bordered">
                            <thead>
                              <tr>
                                <th class="w-50"></th>
                                <th class="text-center w-50">Tanggal Rilis</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- ========================================
                                  PRODUK TERCETAK (HARDCOPY)
                                  ======================================== -->
                              <tr>
                                <td class="v-align-center">Tercetak (Hardcopy)</td>
                                <td class="text-center">
                                  <div v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_tercetak"
                                    :key="'tercetak-' + index" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="flex-grow-1">
                                      <!-- Item Pertama: Validasi >= tanggal mulai diseminasi -->
                                      <BDatePickerWithValidation v-if="index == 0"
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[0].awal"
                                        v-model="data.blok_viii.rencana_jadwal_rilis_produk_tercetak[0]"
                                        name="Tanggal Rilis Produk Tercetak (Hardcopy)"
                                        placeholder="Tanggal Rilis Produk Tercetak (Hardcopy)" />
                                      <!-- Item Selanjutnya: Validasi >= tanggal rilis sebelumnya -->
                                      <BDatePickerWithValidation v-else :key="'tercetak-picker-' + index"
                                        :rules="'required|sameOrAfter:' + data.blok_viii.rencana_jadwal_rilis_produk_tercetak[index - 1]"
                                        v-model="data.blok_viii.rencana_jadwal_rilis_produk_tercetak[index]"
                                        name="Tanggal Rilis Produk Tercetak (Hardcopy)"
                                        placeholder="Tanggal Rilis Produk Tercetak (Hardcopy)" />
                                    </div>
                                    <div class="ml-2 w-30">
                                      <!-- Tombol Delete (jika lebih dari 1 item) -->
                                      <b-button v-if="data.blok_viii.rencana_jadwal_rilis_produk_tercetak.length > 1"
                                        class="button button--action button--action--delete2"
                                        @click="data.blok_viii.rencana_jadwal_rilis_produk_tercetak.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <!-- Tombol Add (hanya di item terakhir) -->
                                      <b-button
                                        v-if="index == data.blok_viii.rencana_jadwal_rilis_produk_tercetak.length - 1"
                                        :class="index > 0 ? 'mt-2' : ''" class="button button--action button--action--view2"
                                        @click="data.blok_viii.rencana_jadwal_rilis_produk_tercetak.push(null)">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>

                              <!-- ========================================
                                  PRODUK DIGITAL (SOFTCOPY)
                                  ======================================== -->
                              <tr>
                                <td class="v-align-center">Digital (Softcopy)</td>
                                <td class="text-center">
                                  <div v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_digital"
                                    :key="'digital-' + index" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="flex-grow-1">
                                      <!-- Item Pertama: Validasi >= tanggal mulai diseminasi -->
                                      <BDatePickerWithValidation v-if="index == 0"
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[0].awal"
                                        v-model="data.blok_viii.rencana_jadwal_rilis_produk_digital[0]"
                                        name="Tanggal Rilis Produk Digital (Softcopy)"
                                        placeholder="Tanggal Rilis Produk Digital (Softcopy)" />
                                      <!-- Item Selanjutnya: Validasi >= tanggal rilis sebelumnya -->
                                      <BDatePickerWithValidation v-else :key="'digital-picker-' + index"
                                        :rules="'required|sameOrAfter:' + data.blok_viii.rencana_jadwal_rilis_produk_digital[index - 1]"
                                        v-model="data.blok_viii.rencana_jadwal_rilis_produk_digital[index]"
                                        name="Tanggal Rilis Produk Digital (Softcopy)"
                                        placeholder="Tanggal Rilis Produk Digital (Softcopy)" />
                                    </div>
                                    <div class="ml-2 w-30">
                                      <!-- Tombol Delete (jika lebih dari 1 item) -->
                                      <b-button v-if="data.blok_viii.rencana_jadwal_rilis_produk_digital.length > 1"
                                        class="button button--action button--action--delete2"
                                        @click="data.blok_viii.rencana_jadwal_rilis_produk_digital.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <!-- Tombol Add (hanya di item terakhir) -->
                                      <b-button
                                        v-if="index == data.blok_viii.rencana_jadwal_rilis_produk_digital.length - 1"
                                        :class="index > 0 ? 'mt-2' : ''" class="button button--action button--action--view2"
                                        @click="data.blok_viii.rencana_jadwal_rilis_produk_digital.push(null)">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>

                              <!-- ========================================
                                  PRODUK MIKRODATA
                                  ======================================== -->
                              <tr>
                                <td class="v-align-center">Data Mikro</td>
                                <td class="text-center">
                                  <div v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_mikrodata"
                                    :key="'mikrodata-' + index" class="d-flex" :class="index != 0 ? 'mt-2' : ''">
                                    <div class="flex-grow-1">
                                      <!-- Item Pertama: Validasi >= tanggal mulai diseminasi -->
                                      <BDatePickerWithValidation v-if="index == 0"
                                        :rules="'required|sameOrAfter:' + data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil[0].awal"
                                        v-model="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata[0]"
                                        name="Tanggal Rilis Produk Data Mikro"
                                        placeholder="Tanggal Rilis Produk Data Mikro" />
                                      <!-- Item Selanjutnya: Validasi >= tanggal rilis sebelumnya -->
                                      <BDatePickerWithValidation v-else :key="'mikrodata-picker-' + index"
                                        :rules="'required|sameOrAfter:' + data.blok_viii.rencana_jadwal_rilis_produk_mikrodata[index - 1]"
                                        v-model="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata[index]"
                                        name="Tanggal Rilis Produk Data Mikro"
                                        placeholder="Tanggal Rilis Produk Data Mikro" />
                                    </div>
                                    <div class="ml-2 w-30">
                                      <!-- Tombol Delete (jika lebih dari 1 item) -->
                                      <b-button v-if="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.length > 1"
                                        class="button button--action button--action--delete2"
                                        @click="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.splice(index, 1)">
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                      <!-- Tombol Add (hanya di item terakhir) -->
                                      <b-button
                                        v-if="index == data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.length - 1"
                                        :class="index > 0 ? 'mt-2' : ''" class="button button--action button--action--view2"
                                        @click="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.push(null)">
                                        <VueFeather type="plus" size="14" stroke-width="2" style="display:block;">
                                        </VueFeather>
                                      </b-button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
              <div class="questionnaire__footer">
                <button class="button" variant="outlined" size="sm" @click="prev" v-if="section.currentIndex != null">
                  <VueFeather type="arrow-left-circle" size="16" stroke-width="2" style="display:block"></VueFeather>
                  &nbsp;&nbsp;Sebelumnya
                </button>
                <button class="button ml-auto" variant="primary" size="sm" @click="next"
                  v-if="section.currentIndex != section.items.length - 1"
                  :disabled="section.currentIndex == null && data.jenis_statistik == null">
                  Selanjutnya&nbsp;&nbsp;
                  <VueFeather type="arrow-right-circle" size="16" stroke-width="2" style="display:block"></VueFeather>
                </button>
              </div>
            </div>

            <div class="questionnaire" v-if="section.currentIndex == 9">
              <div :class="'questionnaire__status2 ' + statusFormatterStyle(form.status)">{{ statusFormatter(form.status) }}
              </div>
              <div class="blok">
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">Judul Kegiatan :</div>
                    <div class="question__value">
                      {{ capitalize(data.judul_kegiatan) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">Tahun:</div>
                    <div class="question__value">
                      {{ data.tahun }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">Cara Pengumpulan Data:</div>
                    <div class="question__value">
                      {{ capitalize(data.cara_pengumpulan_data) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">Sektor Kegiatan:</div>
                    <div class="question__value">
                      {{ capitalize(data.sektor_kegiatan) }}
                    </div>
                  </div>
                  <div class="question" v-if="form.jenis_statistik == 'STATISTIK_SEKTORAL'">
                    <div class="question__name">Apakah mendapatkan rekomendasi kegiatan statistik dari BPS?</div>
                    <div class="question__value">
                      {{ capitalize(data.identitas_rekomendasi ? 'Ya' : 'Tidak') }}
                    </div>
                    <div class="question__name mt-2" v-if="data.identitas_rekomendasi">Identitas Rekomendasi:</div>
                    <div class="question__value" v-if="data.identitas_rekomendasi">
                      {{ capitalize(data.identitas_rekomendasi) }}
                    </div>
                  </div>
                </div>
              </div>

              <div id="blok_i" class="blok">
                <div class="blok-title"> I. Penyelenggara</div>
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">1.1. Instansi Penyelenggara:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_i.instansi_penyelanggara) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name"> 1.2. Alamat Lengkap Instansi Penyelenggara:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_i.alamat_instansi_penyelenggara.alamat) }}
                    </div>
                    <b-row class="mt-2">
                      <b-col>
                        <div class="question">
                          <div class="question__name">Telepon:</div>
                          <div class="question__value">
                            {{ capitalize(data.blok_i.alamat_instansi_penyelenggara.telepon) }}
                          </div>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="question">
                          <div class="question__name">Faksmile:</div>
                          <div class="question__value">
                            {{ capitalize(data.blok_i.alamat_instansi_penyelenggara.faksimile) }}
                          </div>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="question">
                          <div class="question__name">Email:</div>
                          <div class="question__value">
                            {{ data.blok_i.alamat_instansi_penyelenggara.email }}
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>


              <div id="blok_ii" class="blok">
                <div class="blok-title">II. Penanggung Jawab</div>
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">2.1. Unit Eselon Penanggung Jawab:</div>
                    <b-row class="mt-2">
                      <b-col>
                        <div class="question">
                          <div class="question__name">Eselon 1:</div>
                          <div class="question__value">
                            {{ capitalize(data.blok_ii.unit_penanggung_jawab.eselon1) }}
                          </div>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="question">
                          <div class="question__name">Eselon 2:</div>
                          <div class="question__value">
                            {{ capitalize(data.blok_ii.unit_penanggung_jawab.eselon2) }}
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>

                  <div class="question">
                    <div class="question__name">2.2. Penanggung Jawab Teknis (setingkat Eselon 3):</div>
                    <div class="question">
                      <div class="question__name">Nama:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_ii.penanggung_jawab_teknis.nama) }}
                      </div>

                      <div class="question__name mt-2">Jabatan:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_ii.penanggung_jawab_teknis.jabatan) }}
                      </div>

                      <div class="question__name mt-2">Alamat:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_ii.penanggung_jawab_teknis.alamat) }}
                      </div>

                      <b-row class="mt-2">
                        <b-col>
                          <div class="question__name">Telepon:</div>
                          <div class="question__value">
                            {{ capitalize(data.blok_ii.penanggung_jawab_teknis.telepon) }}
                          </div>
                        </b-col>
                        <b-col>
                          <div class="question__name">Faksmile:</div>
                          <div class="question__value">
                            {{ capitalize(data.blok_ii.penanggung_jawab_teknis.faksimile) }}
                          </div>
                        </b-col>
                        <b-col>
                          <div class="question__name">Email:</div>
                          <div class="question__value">
                            {{ data.blok_ii.penanggung_jawab_teknis.email }}
                          </div>
                        </b-col>
                      </b-row>
                    </div>

                  </div>
                </div>
              </div>


              <div id="blok_iii" class="blok">
                <div class="blok-title">III. Perencanaan dan Persiapan</div>
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">3.1. Latar Belakang Kegiatan:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_iii.latar_belakang_kegiatan) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">3.2. Tujuan Kegiatan:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_iii.tujuan_kegiatan) }}
                    </div>
                  </div>
                  <div class="question border-bottom-0">
                    <div class="question__name">3.3. Rencana Jadwal Kegiatan:</div>
                    <div class="table-wrapper mt-2">
                      <table class="table table--light table--bordered">
                        <thead>
                          <tr>
                            <th colspan="2"></th>
                            <th class="text-center">Tanggal Mulai</th>
                            <th class="text-center">Tanggal Selesai</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-bold text-right w-max-25 w-26"
                              style="border-right:0 !important;padding-right:0 !important">A.</td>
                            <td colspan="3" class="text-bold">Perencanaan</td>
                          </tr>
                          <tr>
                            <td style="border-right:0 !important"></td>
                            <td class="pl-2">1. &nbsp;Perencanaan Kegiatan</td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan"
                                v-bind:key="index">
                                {{ item.awal | formatDate }}
                              </div>
                            </td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan"
                                v-bind:key="index">
                                {{ item.akhir | formatDate }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="border-right:0 !important"></td>
                            <td class="sub-title">2. &nbsp;Desain</td>
                            <td class="text-center">
                              <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.desain"
                                v-bind:key="index">
                                {{ item.awal | formatDate }}
                              </div>
                            </td>
                            <td class="text-center">
                              <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.desain"
                                v-bind:key="index">
                                {{ item.akhir | formatDate }}
                              </div>
                            </td>
                          </tr>
                          <tr class="text-bold">
                            <td class="text-right" style="border-right:0 !important;padding-right:0 !important">B.</td>
                            <td colspan="3">Pengumpulan</td>
                          </tr>
                          <tr>
                            <td style="border-right:0 !important"></td>
                            <td class="sub-title">3. &nbsp;Pengumpulan Data</td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data"
                                v-bind:key="index">
                                {{ item.awal | formatDate }}
                              </div>
                            </td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data"
                                v-bind:key="index">
                                {{ item.akhir | formatDate }}
                              </div>
                            </td>
                          </tr>
                          <tr class="text-bold">
                            <td class="text-right" style="border-right:0 !important;padding-right:0 !important">C.</td>
                            <td colspan="3">Pemeriksaan</td>
                          </tr>
                          <tr>
                            <td style="border-right:0 !important"></td>
                            <td class="sub-title">4. &nbsp;Pengolahan Data</td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data"
                                v-bind:key="index">
                                {{ item.awal | formatDate }}
                              </div>
                            </td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data"
                                v-bind:key="index">
                                {{ item.akhir | formatDate }}
                              </div>
                            </td>
                          </tr>
                          <tr class="text-bold">
                            <td class="text-right" style="border-right:0 !important;padding-right:0 !important">D.</td>
                            <td colspan="3">Penyebarluasan</td>
                          </tr>
                          <tr>
                            <td style="border-right:0 !important"></td>
                            <td class="sub-title">5. &nbsp;Analisis</td>
                            <td class="text-center">
                              <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.analisis"
                                v-bind:key="index">
                                {{ item.awal | formatDate }}
                              </div>
                            </td>
                            <td class="text-center">
                              <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.analisis"
                                v-bind:key="index">
                                {{ item.akhir | formatDate }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="border-right:0 !important"></td>
                            <td class="sub-title">6. &nbsp;Diseminasi Hasil</td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil"
                                v-bind:key="index">
                                {{ item.awal | formatDate }}
                              </div>
                            </td>
                            <td class="text-center">
                              <div class="mb-0"
                                v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil"
                                v-bind:key="index">
                                {{ item.akhir | formatDate }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="border-right:0 !important"></td>
                            <td class="sub-title">7. &nbsp;Evaluasi</td>
                            <td class="text-center">
                              <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.evaluasi"
                                v-bind:key="index">
                                {{ item.awal | formatDate }}
                              </div>
                            </td>
                            <td class="text-center">
                              <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.evaluasi"
                                v-bind:key="index">
                                {{ item.akhir | formatDate }}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="question">
                    <div class="question__name">3.4. Variabel (Karakteristik) yang Dikumpulkan:</div>
                    <div class="table-wrapper mt-2">
                      <b-table class="table--light table--bordered" :items="data.blok_iii.variabel_yang_dikumpulkan"
                        :fields="[
                          { key: 'no', thClass: 'w-40', tdClass: 'text-center' },
                          { key: 'nama', label: 'Nama Variabel (Kharakteristik)', thClass: '' },
                          'konsep',
                          'definisi',
                          { key: 'referensi_waktu', label: 'Referensi Waktu (periode Enumerasi)', thClass: '' }
                        ]">
                        <template #cell(no)="data"> {{ data.index + 1 }}. </template>
                        <template #empty>
                          <div class="table__empty">
                            <div>
                              <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Variabel belukm diinput
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>


              <div id="blok_iv" class="blok">
                <div class="blok-title">IV. Desain Kegiatan</div>
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">4.1. Kegiatan Ini Dilakukan:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_iv.kegiatan_ini_dilakukan) }}
                    </div>
                  </div>

                  <div class="question" v-if="data.blok_iv.kegiatan_ini_dilakukan == 'BERULANG'">
                    <div class="question__name">4.2. Frekuensi Penyelenggaraan:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_iv.frekuensi_penyelanggara) }}
                    </div>
                  </div>

                  <div class="question">
                    <div class="question__name">4.3. Tipe Pengumpulan Data:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_iv.tipe_pengumpulan_data) }}
                    </div>
                  </div>

                  <div class="question">
                    <div class="question__name">4.4. Cakupan Wilayah Pengumpulan Data:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_iv.cakupan_wilayah_pengumpulan_data) }}
                    </div>
                  </div>

                  <div class="question border-bottom-0"
                    v-if="data.blok_iv.cakupan_wilayah_pengumpulan_data == 'SEBAGIAN_WILAYAH_INDONESIA'">
                    <div class="question__name">4.5. Wilayah Kegiatan:</div>
                    <div class="table-wrapper mt-2">
                      <b-table class="table--light table--bordered"
                        :items="data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data" :fields="table.wilayahFields">
                        <template #cell(no)="data"> {{ data.index + 1 }}. </template>
                      </b-table>
                    </div>
                  </div>

                  <div class="question">
                    <div class="question__name">4.6. Metode Pengumpulan Data:</div>
                    <div class="question__value">
                      <ul class="list">
                        <li v-if="data.blok_iv.metode_pengumpulan_data.wawancara">Wawancara</li>
                        <li v-if="data.blok_iv.metode_pengumpulan_data.mengisi_kuesioner_sendiri">Mengisi Kuesioner
                          Sendiri
                        </li>
                        <li v-if="data.blok_iv.metode_pengumpulan_data.pengamatan">Pengamatan</li>
                        <li v-if="data.blok_iv.metode_pengumpulan_data.pengumpulan_data_sekunder">Pengumpulan Data
                          Sekunder
                        </li>
                        <li v-if="data.blok_iv.metode_pengumpulan_data.lainnya">Lainnya :
                          {{ data.blok_iv.metode_pengumpulan_data.metode_pengumpulan_lainnya }}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">4.7. Sarana Pengumpulan Data:</div>
                    <div class="question__value">
                      <ul class="list">
                        <li v-if="data.blok_iv.sarana_pengumpulan_data.papi">Paper-assisted Personal Interviewing (PAPI)
                        </li>
                        <li v-if="data.blok_iv.sarana_pengumpulan_data.capi">Computer-assisted Personal Interviewing
                          (CAPI)
                        </li>
                        <li v-if="data.blok_iv.sarana_pengumpulan_data.cati">Computer-assisted Telephones Interviewing
                          (CATI)</li>
                        <li v-if="data.blok_iv.sarana_pengumpulan_data.cawi">Computer Aided Web Interviewing (CAWI)</li>
                        <li v-if="data.blok_iv.sarana_pengumpulan_data.mail">Mail</li>
                        <li v-if="data.blok_iv.sarana_pengumpulan_data.lainnya">Lainnya :
                          {{ data.blok_iv.sarana_pengumpulan_data.sarana_pengumpulan_lainnya }}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">4.8. Unit Pengumpulan Data:</div>
                    <div class="question__value">
                      <ul class="list">
                        <li v-if="data.blok_iv.unit_pengumpulan_data.individu">Individu</li>
                        <li v-if="data.blok_iv.unit_pengumpulan_data.rumah_tangga">Rumah Tangga</li>
                        <li v-if="data.blok_iv.unit_pengumpulan_data.usaha_atau_perusahaan">Usaha/Perusahaan</li>
                        <li v-if="data.blok_iv.unit_pengumpulan_data.lainnya">Lainnya :
                          {{ data.blok_iv.unit_pengumpulan_data.unit_pengumpulan_data_lainnya }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>


              <div id="blok_v" class="blok">
                <div class="blok-title" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                  <div>V. Desain Sampel</div>
                  <div class="text-12 text-semi-bold" style="text-transform:none">Diisi jika cara pengumpulan data
                    adalah
                    Survei</div>
                </div>
                <div class="blok-detail" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                  <div class="question">
                    <div class="question__name">5.1. Jenis Rancangan Sampel:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.jenis_rancangan_sampel) }}
                    </div>
                  </div>

                  <div class="question">
                    <div class="question__name">5.2. Metode Pemilihan Sampel Tahap Terakhir:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.metode_pemilihan_sampel_tahap_terakhir) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">5.3. Metode Yang Digunakan:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.metode_yang_digunakan) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">5.4. Kerangka Sampel Tahap Terakhir:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.kerangka_sampel_tahap_terakhir) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">5.5. Fraksi Sampel Keseluruhan:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.fraksi_sampel_keseluruhan) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">5.6. Nilai Perkiraan Sampling Error Variabel Utama:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.nilai_perkiraan_sampling_error_variabel_utama) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">5.7. Unit Sampel:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.unit_sampel) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">5.8. Unit Observasi:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_v.unit_observasi) }}
                    </div>
                  </div>
                </div>
              </div>


              <div id="blok_vi" class="blok">
                <div class="blok-title">VI. Pengumpulan Data</div>
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">6.1. Apakah Melakukan Uji Coba (Pilot Survey)?</div>
                    <div class="question__value">
                      {{ data.blok_vi.apakah_melakukan_uji_coba == true ? "Ya" : "Tidak" }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">6.2. Metode Pemeriksaan Kualitas Pengumpulan Data:</div>
                    <div class="question__value">
                      <ul class="list">
                        <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.kunjungan_kembali">Kunjungan
                          Kembali</li>
                        <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.supervisi">Supervisi</li>
                        <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.taskforce">Task Force</li>
                        <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya">Lainnya:
                          {{ data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.metode_pemeriksaan_kualitas_pengumpulan_data_lainnya }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">6.3. Apakah Melakukan Penyesuaian Nonrespon?</div>
                    <div class="question__value">
                      {{ data.blok_vi.apakah_melakukan_penyesuaian_nonrespon == true ? "Ya" : "Tidak" }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">6.4. Petugas Pengumpulan Data:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_vi.petugas_pengumpulan_data) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">6.5. Persyaratan Pendidikan Terendah Petugas Pengumpulan Data:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data) }}
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">6.6. Jumlah Petugas:</div>
                    <div>
                      <div class="d-flex">
                        <div class="question__value w-200">Supervisor/penyelia/pengawas</div>
                        <div class="question__value">
                          : {{ data.blok_vi.jumlah_petugas_supervisor }} orang
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="question__value w-200">Pengumpul data/enumerator</div>
                        <div class="question__value">
                          : {{ data.blok_vi.jumlah_petugas_enumerator }} orang
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">6.7. Apakah Melakukan Pelatihan Petugas?</div>
                    <div class="question__value">
                      {{ data.blok_vi.apakah_melakukan_pelatihan_petugas ? "Ya" : "Tidak" }}
                    </div>
                  </div>
                </div>
              </div>

              <div id="blok_vii" class="blok">
                <div class="blok-title">VII. Pengolahan Dan Analisis</div>
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">7.1. Tahapan Pengolahan Data:</div>
                    <div>
                      <div class="d-flex">
                        <div class="question__value w-200">Penyuntingan (Editing)</div>
                        <div class="question__value">
                          : {{ data.blok_vii.tahapan_pengolahan_data.editing ? 'Ya' : 'Tidak' }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="question__value w-200">Penyandian (Coding)</div>
                        <div class="question__value">
                          : {{ data.blok_vii.tahapan_pengolahan_data.coding ? 'Ya' : 'Tidak' }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="question__value w-200">Data Entry</div>
                        <div class="question__value">
                          : {{ data.blok_vii.tahapan_pengolahan_data.data_entry ? 'Ya' : 'Tidak' }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="question__value w-200">Penyahihan (Validasi)</div>
                        <div class="question__value">
                          : {{ data.blok_vii.tahapan_pengolahan_data.validasi ? 'Ya' : 'Tidak' }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="question">
                    <div class="question__name">7.2. Metode Analisis:</div>
                    <div class="question__value">
                      {{ capitalize(data.blok_vii.metode_analisis) }}
                    </div>
                  </div>

                  <div class="question">
                    <div class="question__name">7.3. Unit Analisis:</div>
                    <div class="question__value">
                      <ul class="list">
                        <li v-if="data.blok_vii.unit_analsis.individu">Individu</li>
                        <li v-if="data.blok_vii.unit_analsis.rumah_tangga">Rumah Tangga</li>
                        <li v-if="data.blok_vii.unit_analsis.usaha_atau_perusahaan">Usaha/Perusahaan</li>
                        <li v-if="data.blok_vii.unit_analsis.lainnya">Lainnya:
                          {{ data.blok_vii.unit_analsis.unit_analisis_lainnya }}</li>
                      </ul>
                    </div>
                  </div>

                  <div class="question">
                    <div class="question__name">7.4. Tingkat Penyajian Hasil Analisis:</div>
                    <div class="question__value">
                      <ul class="list">
                        <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.nasional">Nasional</li>
                        <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.provinsi">Provinsi</li>
                        <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.kabupaten_atau_kota">Kabupaten/Kota
                        </li>
                        <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.lainnya">Lainnya:
                          {{ data.blok_vii.tingkat_penyajian_hasil_analisis.tingkat_penyajian_hasil_analisis_lainnya }}
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>

              <div id="blok_viii" class="blok">
                <div class="blok-title">VIII. Diseminasi Hasil</div>
                <div class="blok-detail">
                  <div class="question">
                    <div class="question__name">8.1. Produk Kegiatan yang Tersedia untuk Umum</div>
                    <div>
                      <div class="d-flex">
                        <div class="question__value w-200">Tercetak (Hardcopy)</div>
                        <div class="question__value">
                          : {{ data.blok_viii.ketersediaan_produk_tercetak ? 'Ya' : 'Tidak' }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="question__value w-200">Digital (Softcopy)</div>
                        <div class="question__value">
                          : {{ data.blok_viii.ketersediaan_produk_digital ? 'Ya' : 'Tidak' }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="question__value w-200">Data Mikro</div>
                        <div class="question__value">
                          : {{ data.blok_viii.ketersediaan_produk_mikrodata ? 'Ya' : 'Tidak' }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="question"
                    v-if="(data.blok_viii.rencana_jadwal_rilis_produk_tercetak && data.blok_viii.rencana_jadwal_rilis_produk_tercetak.length > 0) ||
                      (data.blok_viii.rencana_jadwal_rilis_produk_digital && data.blok_viii.rencana_jadwal_rilis_produk_digital.length > 0) ||
                      (data.blok_viii.rencana_jadwal_rilis_produk_mikrodata && data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.length > 0)">
                    <div class="question__name">8.2. Rencana Rilis Produk Kegiatan</div>
                    <div class="question__value">
                      <div class="table-wrapper mt-2">
                        <table class="table table--light table--bordered">
                          <thead>
                            <tr>
                              <th class="w-200 text-left">Jenis Produk</th>
                              <th class="text-center">Tanggal Rilis</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Tercetak (Hardcopy)</td>
                              <td class="text-center">
                                <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_tercetak"
                                  v-bind:key="index">
                                  {{ item | formatDate }} <span
                                    v-if="data.blok_viii.rencana_jadwal_rilis_produk_tercetak.length > 1">,</span>

                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>Digital (Softcopy)</td>
                              <td class="text-center">
                                <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_digital"
                                  v-bind:key="index">
                                  {{ item | formatDate }} <span
                                    v-if="data.blok_viii.rencana_jadwal_rilis_produk_digital.length > 1">,</span>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>Data Mikro</td>
                              <td class="text-center">
                                <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_mikrodata"
                                  v-bind:key="index">
                                  {{ item | formatDate }} <span
                                    v-if="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.length > 1">,</span>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>




          </b-col>
          <b-col id="review" cols="4" sm="4" md="4" lg="4" xl="3" class="pr-0 mr-0" v-if="isReviewVisible">
            <div class="sidebar-cards-wrapper" style="position: sticky; top: 157px; max-height: calc(100vh - 175px); overflow-y: auto; padding-right: 2px;">
              
              <!-- CARD 1: Catatan Pemeriksaan -->
              <div class="review my-0 mx-0 mb-3" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;"> 
                <div class="review__header" style="cursor: pointer;" @click="isReviewCardOpen = !isReviewCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="mail" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Catatan Pemeriksaan
                    <span v-if="(form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
                      {{ (form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button mr-1" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isReviewCardOpen = !isReviewCardOpen"
                      :title="isReviewCardOpen ? 'Sembunyikan Catatan Pemeriksaan' : 'Tampilkan Catatan Pemeriksaan'"
                    >
                      <VueFeather :type="isReviewCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                    <button class="button" variant="icon" size="sm" @click.stop="isReviewOpen = false" title="Tutup Panel">
                      <VueFeather type="x" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isReviewCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px;">
                    <div style="margin-bottom:20px;" v-if="form.reviews && form.reviews.length>0" >
                        <div v-for="(reviewItem, reviewIndex) in form.reviews" :key="reviewIndex" class="review-item d-block">
                          <div class="d-flex">
                              <div class="review-item__number">{{reviewIndex+1}}.</div>
                              <div class="review-item__note">
                                <span class="review-item__field" v-if="reviewItem.field">
                                  #{{ getReviewFieldLabel(reviewItem.field) }} : 
                                </span>
                                {{reviewItem.note}}
                              </div>
                          </div>
                          <div class="d-flex align-items-center review-item__info pt-1 mb-1" style="padding-left:19px">
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-if="reviewItem.created_at">{{reviewItem.created_at | formatDate}}</div>
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-else-if="msKeg">{{msKeg.created_at | formatDate}}</div>
                              <div class="ml-auto" v-if="route == 'UpdateMsKeg'">
                                <b-button  
                                    class="button button--action button--action--delete" 
                                    style="height:20px;width:20px!important;min-width:20px!important" 
                                    v-b-tooltip.hover title="Hapus Catatan"
                                    @click="removeReviewNote(reviewIndex)"
                                >
                                    <VueFeather type="x" size="12"></VueFeather>
                                </b-button>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div class="history-review" v-if="msKeg" >
                        <div class="text-bold text-primary" style="margin:5px 11px">History Pemeriksaan:</div>
                        <div v-if="reviewHistories && reviewHistories.length==0" class="" style="margin-top:-5px;margin-left:11px"> Belum ada history yang tersedia</div>
                        <div v-else class="mt-1">
                          <div v-for="(reviewItem, reviewIndex) in reviewHistories" :key="reviewIndex" class="review-item d-block">
                              <div class="d-flex">
                                  <div class="review-item__number">{{reviewIndex+1}}.</div>
                                  <div class="review-item__note">
                                    <span class="review-item__field" v-if="reviewItem.field">
                                      #{{ getReviewFieldLabel(reviewItem.field) }} : 
                                    </span>
                                    {{reviewItem.note}}
                                  </div>
                              </div>
                              <div class="d-flex align-items-center review-item__info pt-1" style="padding-left:19px" v-if="reviewItem.created_at">
                                  <div class="text-10 text-500 mr-2" style="line-height:1">{{reviewItem.created_at | formatDate}}</div>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>

                  <div class="review__footer form form--sm mt-auto" v-if="route == 'UpdateMsKeg'">
                    <Treeselect  
                      placeholder="Pilih attribute/blok (opsional)"
                      v-model="review.field" 
                      :options="reviewFields" 
                      :clearable="true" 
                      class="small-container"
                      :loadOptions="loadOptions"
                    >
                    </Treeselect>
                    <b-form-textarea 
                      class="mt-1 text-13"
                      rows="3"
                      v-model="review.note" 
                      placeholder="Tuliskan catatan pemeriksaan..." 
                    >
                    </b-form-textarea>
                    <div class="d-flex justify-content-between align-items-center mt-2">
                      <button 
                        class="button button--secondary button--sm" 
                        variant="outlined" 
                        size="sm" 
                        :disabled="isSavingReview"
                        @click="saveReviewsOnly"
                        title="Simpan catatan pemeriksaan ke server"
                      >
                        <VueFeather type="save" size="13" stroke-width="2"></VueFeather>&nbsp; Simpan Catatan
                      </button>
                      <button 
                        class="button" 
                        variant="primary" 
                        size="sm" 
                        :disabled="!review.note || !review.note.trim()" 
                        @click="addReviewNote"
                      >
                        <VueFeather type="plus" size="14" stroke-width="2"></VueFeather>&nbsp; Tambah Catatan
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- CARD 2: Histori Status -->
              <div class="review my-0 mx-0" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;" v-if="msKeg && msKegHistories && msKegHistories.length>0">
                <div class="review__header" style="cursor: pointer;" @click="isHistoryStatusCardOpen = !isHistoryStatusCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="clock" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Histori Status
                    <span class="badge badge-light ml-1 text-primary">
                      {{ msKegHistories.length }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isHistoryStatusCardOpen = !isHistoryStatusCardOpen"
                      :title="isHistoryStatusCardOpen ? 'Sembunyikan Histori Status' : 'Tampilkan Histori Status'"
                    >
                      <VueFeather :type="isHistoryStatusCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isHistoryStatusCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px; padding: 10px 12px;">
                    <div class="history-status mt-0" style="margin: 0px 0px;">
                      <div v-for="(history, historyIndex) in msKegHistories" :key="historyIndex" class="history-status__item">
                          <div class="d-flex align-items-center">
                              <div class="history-status__number">{{historyIndex+1}}.</div>
                              <div :class="'history-status__badge history-status__badge--'+ statusFormatterStyle(history.status)">
                                  {{statusFormatter(history.status)}}
                              </div>
                              <div class="text-10 text-500 ml-auto" v-if="history.created_at" style="line-height:1">
                                  {{history.created_at | formatDate}}
                              </div>
                          </div>
                          <div class="history-status__info" v-if="history.created_by && history.created_by.organization && history.created_by.organization.name">
                              <span>{{history.created_by.organization.name}}</span>
                          </div>
                          <div class="history-status__rejection" v-if="history.status == 'REJECTED' && history.rejection_note">
                              <strong>Catatan Penolakan:</strong> {{history.rejection_note}}
                          </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>

            </div>
          </b-col>
        </b-row>
      </div>

    </div>
    <b-modal hide-header hide-footer id="modal-error" size="sm" content-class="modal--error text-center mt-5"
      dialog-class="d-flex justify-content-center">
      <div>
        <div class="text-center py-5 px-2" style="color:red">
          <div class="mb-3 d-flex justify-content-center align-item-center">
            <div class="border mx-4 " style="border-color:#F48FB1 !important;width:40%">
              <div style="position:relative;background-color:#FCE4EC;height:20px;border-color:#F48FB1 !important"
                class="border-bottom mb-2">
                <div style="position:absolute;top:-10px;right:-10px">
                  <VueFeather type="x-circle" size="20" stroke-width="1.5" fill="#FCE4EC"></VueFeather>
                </div>
              </div>
              <div class="px-3 py-2" style="">
                <b-skeleton animation width="85%" height="10px"
                  style="background-color:#fff1f6;border:1px solid #F8BBD0;margin-bottom:10px"></b-skeleton>
                <b-skeleton animation width="55%" height="10px"></b-skeleton>
                <b-skeleton animation width="70%" height="10px"></b-skeleton>
                <b-skeleton animation width="100%" height="10px"></b-skeleton>
              </div>
            </div>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            {{ modal.error.title }}
          </div>
          <!-- <div style="font-weight:500;font-size:13px;color:#616161;word-break: break-word;" v-text='modal.error.description'> -->
          <!-- {{modal.error.description}}  -->
          <!-- </div> -->
          <div class="mt-3">
            <b-button class="i-button"
              style="color:white !important;background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600"
              v-on:click="() => { $bvModal.hide('modal-error'); }">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="sm" id="modal-loading"
      content-class="modal modal--confirmation text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div class="text-center px-3 py-4">
        <img src="@/assets/img/loader.gif" width="100" height="100" />
        <div style="font-weight:600;font-size:16px;color:#01ad85">
          Mohon tunggu sebentar
        </div>
        <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
          Proses pengecekan Rekomendasi sedang berlangsung
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer id="modal-saving" size="sm" content-class="modal modal--error text-center p-2"
      centered dialog-class="d-flex justify-content-center">
      <div v-if="saveState == 'SAVING'">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Proses menyimpan sedang berlangsung
          </div>
        </div>
      </div>
      <div v-if="saveState == 'SUCCESS'">
        <div class="text-center py-3">
          <img src="@/assets/img/success.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Berhasil menyimpan
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Anda akan di <i>redirect</i> ke halaman Daftar Pelaporan dalam beberapa detik
          </div>
        </div>
      </div>
      <div v-if="saveState == 'ERROR'">
        <div class="text-center py-3" style="color:red">
          <div>
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            Error
          </div>
          <div style="font-weight:600;font-size:13px;color:#0a4e5c;font-family:'Open Sans'">
            {{ saveError }}
          </div>
          <div class="mt-2">
            <b-button
              style="background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600"
              v-on:click="() => { $bvModal.hide('modal-saving'); }">Kembali</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- MODAL KONFIRMASI STATISTIK DASAR WILAYAH -->
    <b-modal
      id="modal-confirm-statistik-dasar"
      ref="confirmStatistikDasarModal"
      size="lg"
      centered
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      dialog-class="my-4 px-3 px-md-4"
      content-class="border-0 shadow-lg rounded-lg overflow-hidden"
      header-class="px-4 px-md-5 pt-4 pb-3 border-bottom-0 bg-white"
      body-class="px-4 px-md-5 py-3 bg-white"
      footer-class="px-4 px-md-5 pb-4 pt-3 border-top-0 bg-white"
    >
      <!-- Modal Header -->
      <template #modal-header>
        <div class="d-flex align-items-center w-100">
          <div 
            class="mr-3 d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
            style="width: 48px; height: 48px; background-color: #fffbeb; color: #d97706; border: 1px solid #fde68a;"
          >
            <VueFeather type="alert-triangle" size="24"></VueFeather>
          </div>
          <div>
            <h5 class="modal-title font-weight-bold mb-1 text-dark" style="font-size: 1.2rem; line-height: 1.3;">
              Apakah benar ada Statistik Dasar di wilayah anda?
            </h5>
            <span class="text-muted small" style="font-size: 13px;">
              Konfirmasi jenis metadata statistik kegiatan untuk instansi daerah
            </span>
          </div>
        </div>
      </template>

      <!-- Modal Body -->
      <div class="py-2">
        <!-- Penjelasan Regulasi & Ketentuan -->
        <div 
          class="alert alert-warning border-0 p-3 p-md-4 mb-3 rounded-lg" 
          style="background-color: #fffdf5; color: #92400e; font-size: 13.5px; line-height: 1.6; border-left: 4px solid #f59e0b !important;"
        >
          <div class="font-weight-bold mb-2 d-flex align-items-center" style="font-size: 14px;">
            <VueFeather type="info" size="16" class="mr-2" style="vertical-align: -2px;"></VueFeather>
            Ketentuan UU No. 16 Tahun 1997 tentang Statistik
          </div>
          <div class="mb-2">
            <strong>Statistik Dasar</strong> diselenggarakan oleh <strong>Badan Pusat Statistik (BPS)</strong> secara eksklusif untuk keperluan yang bersifat luas dan berskala makro/nasional.
          </div>
          <div>
            Instansi Pemerintah Daerah (Provinsi / Kabupaten / Kota) pada umumnya menyelenggarakan <strong>Statistik Sektoral</strong> untuk mendukung tugas pokok dan fungsi instansi di wilayah masing-masing.
          </div>
        </div>

        <!-- Informasi Pengguna & Wilayah -->
        <div class="p-3 p-md-4 rounded-lg border mb-3" style="background-color: #f8fafc; font-size: 13px;">
          <div class="font-weight-bold text-dark mb-2 d-flex align-items-center" style="font-size: 13px;">
            <VueFeather type="map-pin" size="14" class="mr-2 text-secondary" style="vertical-align: -2px;"></VueFeather>
            Identitas Instansi Pengguna:
          </div>
          <div class="row no-gutters py-2 border-bottom" v-if="userRegionLabel">
            <div class="col-sm-4 text-muted">Wilayah:</div>
            <div class="col-sm-8 font-weight-bold text-dark">{{ userRegionLabel }}</div>
          </div>
          <div class="row no-gutters py-2 border-bottom" v-if="user && user.organization && user.organization.name">
            <div class="col-sm-4 text-muted">Organisasi / Instansi:</div>
            <div class="col-sm-8 text-dark font-weight-bold">{{ user.organization.name }}</div>
          </div>
          <div class="row no-gutters py-2" v-if="activeRoleLabel">
            <div class="col-sm-4 text-muted">Peran Akun:</div>
            <div class="col-sm-8">
              <span class="badge badge-info px-2 py-1" style="font-size: 11.5px;">{{ activeRoleLabel }}</span>
            </div>
          </div>
        </div>

        <!-- Pertanyaan Konfirmasi -->
        <div class="p-3 p-md-4 rounded-lg border mb-2" style="background-color: #f0fdf4; border-color: #bbf7d0 !important;">
          <div class="text-dark font-weight-bold mb-1" style="font-size: 13.5px;">
            Apakah Anda yakin ingin tetap memilih <span class="text-primary font-weight-bold">Statistik Dasar</span>?
          </div>
          <div class="text-muted" style="font-size: 12.5px; line-height: 1.5;">
            Jika kegiatan statistik ini merupakan inisiatif kegiatan dari dinas/OPD/instansi daerah Anda, silakan pilih <strong>Statistik Sektoral</strong>.
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <template #modal-footer>
        <div class="d-flex flex-wrap justify-content-end align-items-center w-100" style="gap: 10px;">
          <b-button 
            variant="outline-secondary" 
            class="px-4 py-2 font-weight-bold"
            style="font-size: 13px;"
            @click="cancelStatistikDasar"
          >
            Batal
          </b-button>
          <b-button 
            variant="primary" 
            class="px-4 py-2 font-weight-bold text-white shadow-sm"
            style="background-color: #01947b; border-color: #01947b; font-size: 13px;"
            @click="switchToStatistikSektoral"
          >
            <VueFeather type="check" size="14" class="mr-1" style="vertical-align: -2px;"></VueFeather>
            Pilih Statistik Sektoral (Disarankan)
          </b-button>
          <b-button 
            variant="warning" 
            class="px-4 py-2 font-weight-bold text-dark shadow-sm"
            style="font-size: 13px;"
            @click="confirmStatistikDasar"
          >
            Ya, Benar (Statistik Dasar)
          </b-button>
        </div>
      </template>
    </b-modal>

  </div>
  
</template>

<script>
import "@/assets/scss/main.scss";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueFeather from 'vue-feather';

import BDatePickerWithValidation from "@/components/inputs/BDatePicker2WithValidation";
import lodash from "lodash";
import moment from "moment";

import SdiOrganizationService from "@/services/SdiOrganizationService";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import "vue-select/dist/vue-select.css";
import MsService from "../../../services/MsService";
import { reviewFields, flatReviewFields } from "../reviewKegFields";
import rekomendasiService from "../../../services/RekomendasiService";
import WilayahService from "../../../services/WilayahService";
import { judulKegiatanRules } from "./Rules";
import store from "../../../store";
export default {
  components: {
    VueFeather,
    Treeselect,
    ValidationObserver,
    ValidationProvider,
    BDatePickerWithValidation
  },
  inject: ['appData'],
  data: () => ({
    route:null,
    isStatistikDasarConfirmed: false,
    baseId:null,
    updatedId:null,
    user:null,
    userRoles:[],
    isLoading:false,
    saveState:'SUCCESS',
    saveError:null,
    section:{
      currentIndex:null,
      items:[
        {
          id: "Identitas",
          name: "Halaman Awal",
          status: 'valid',
        },
        {
          id: "BlokI",
          name: "Blok I",
          status: 'valid',
        },
        {
          id: "BlokII",
          name: "Blok II",
          status: 'valid',
        },
        {
          id: "BlokIII",
          name: "Blok III",
          status: 'valid',
        },
        {
          id: "BlokIV",
          name: "Blok IV",
          status: 'valid',
        },
        {
          id: "BlokV",
          name: "Blok V",
          status: 'valid',
        },
        {
          id: "BlokVI",
          name: "Blok VI",
          status: 'valid',
        },
        {
          id: "BlokVII",
          name: "Blok VII",
          status: 'valid',
        },
        {
          id: "BlokVIII",
          name: "Blok VIII",
          status: 'valid',
        },
        {
          id: "Ringkasan",
          name: "Ringkasan",
          status: 'valid',
        },
      ],
    },
    inputMode: 0,
    rekomendasi: null,
    msKeg: null,
    formExt: {
      getRecommendation: false,
      produsenData: null,
      wilayah: null,

    },
    review: {
      field: null,
      note: null,
    },
    isReviewOpen: true,
    isReviewCardOpen: true,
    isHistoryStatusCardOpen: true,
    isSavingReview: false,
    reviewFields: reviewFields,
    flatReviewFields: flatReviewFields,
    form:{
      base_id:null,
      submission_period: new Date().getFullYear(),
      data: null,
      reviews: [],
      status: "DRAFT",
      rejection_note: null,
      submitter: null,
      produsen_data: null,
      walidata_pusat: null,
      version: 'v2',
      changes: null,
      // reviews: [
      //   {
      //     created_at: null,
      //     field: null,
      //     note: null
      //   }
      // ],
      // submitter: {
      //   name: null,
      //   username: null,
      //   email: null,
      //   organization: {
      //     id: 0,
      //     name: null,
      //     address: null,
      //     province: {
      //       code: null,
      //       name: null
      //     },
      //     city: {
      //       code: null,
      //       name: null
      //     }
      //   }
      // },
      // rejection_note: {
      //   note: null,
      //   type: "IMPROPERLY_REQUEST"
      // },
      // produsen_data: {
      //   id: 0,
      //   name: null,
      //   province_code: null,
      //   city_code: null
      // },
      // walidata_pusat: {
      //   id: 0,
      //   name: null
      // },
    },
    data: {
      judul_kegiatan: null,
      tahun: null,
      jenis_statistik: null,
      cara_pengumpulan_data: null,
      sektor_kegiatan: null,
      identitas_rekomendasi: null,
      blok_i: {
        instansi_penyelanggara: null,
        alamat_instansi_penyelenggara: {
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null
        }
      },
      blok_ii: {
        unit_penanggung_jawab: {
          eselon1: null,
          eselon2: null
        },
        penanggung_jawab_teknis: {
          nama: null,
          jabatan: null,
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null
        }
      },
      blok_iii: {
        latar_belakang_kegiatan: null,
        tujuan_kegiatan: null,
        rencana_jadwal_kegiatan: {
          perencanaan_kegiatan: [
            { awal: null, akhir: null }  // ✅ Array dengan 1 object
          ],
          desain: [
            { awal: null, akhir: null }
          ],
          pengumpulan_data: [
            { awal: null, akhir: null }
          ],
          pengolahan_data: [
            { awal: null, akhir: null }
          ],
          analisis: [
            { awal: null, akhir: null }
          ],
          diseminasi_hasil: [
            { awal: null, akhir: null }
          ],
          evaluasi: [
            { awal: null, akhir: null }
          ]
        },

        variabel_yang_dikumpulkan: [
          {
            nama: null,
            konsep: null,
            definisi: null,
            referensi_waktu: null
          }
        ]
      },
      blok_iv: {
        kegiatan_ini_dilakukan: null,
        frekuensi_penyelanggara: null,
        tipe_pengumpulan_data: null,
        cakupan_wilayah_pengumpulan_data: null,
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: null,
          mengisi_kuesioner_sendiri: null,
          pengamatan: null,
          pengumpulan_data_sekunder: null,
          lainnya: null,
          metode_pengumpulan_lainnya: null
        },
        sarana_pengumpulan_data: {
          papi: null,
          capi: null,
          cati: null,
          cawi: null,
          mail: null,
          lainnya: null,
          sarana_pengumpulan_lainnya: null
        },
        unit_pengumpulan_data: {
          individu: null,
          rumah_tangga: null,
          usaha_atau_perusahaan: null,
          lainnya: null,
          unit_pengumpulan_data_lainnya: null
        }
      },
      blok_v: {
        jenis_rancangan_sampel: null,
        metode_pemilihan_sampel_tahap_terakhir: null,
        metode_yang_digunakan: null,
        kerangka_sampel_tahap_terakhir: null,
        fraksi_sampel_keseluruhan: null,
        nilai_perkiraan_sampling_error_variabel_utama: null,
        unit_sampel: null,
        unit_observasi: null
      },
      blok_vi: {
        apakah_melakukan_uji_coba: null,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: null,
          supervisi: null,
          taskforce: null,
          lainnya: null,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: null
        },
        apakah_melakukan_penyesuaian_nonrespon: null,
        petugas_pengumpulan_data: null,
        persyaratan_pendidikan_terendah_petugas_pengumpulan_data: null,
        jumlah_petugas_supervisor: 0,
        jumlah_petugas_enumerator: 0,
        apakah_melakukan_pelatihan_petugas: null
      },
      blok_vii: {
        tahapan_pengolahan_data: {
          editing: null,
          coding: null,
          data_entry: null,
          validasi: null
        },
        metode_analisis: null,
        unit_analsis: {
          individu: null,
          rumah_tangga: null,
          usaha_atau_perusahaan: null,
          lainnya: null,
          unit_analisis_lainnya: null
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: null,
          provinsi: null,
          kabupaten_atau_kota: null,
          kecamatan: null,
          lainnya: null,
          tingkat_penyajian_hasil_analisis_lainnya: null
        }
      },
      blok_viii: {
        ketersediaan_produk_tercetak: false,
        ketersediaan_produk_digital: false,
        ketersediaan_produk_mikrodata: false,
        rencana_jadwal_rilis_produk_tercetak: [],
        rencana_jadwal_rilis_produk_digital: [],
        rencana_jadwal_rilis_produk_mikrodata: []
      }
    },
    ques: {
      judul_kegiatan: null,
      tahun: new Date().getFullYear(),
      jenis_statistik: "STATISTIK_DASAR",
      cara_pengumpulan_data: null,
      sektor_kegiatan: null,
      identitas_rekomendasi: null,
      blok_i: {
        instansi_penyelanggara: null,
        blok_ialamat_instansi_penyelenggara: {
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null
        }
      },
      blok_ii: {
        unit_penanggung_jawab: {
          eselon1: null,
          eselon2: null
        },
        penanggung_jawab_teknis: {
          nama: null,
          jabatan: null,
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null
        }
      },
      blok_iii: {
        latar_belakang_kegiatan: null,
        tujuan_kegiatan: null,
        rencana_jadwal_kegiatan: {
          perencanaan_kegiatan: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          desain: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          pengumpulan_data: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          pengolahan_data: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          analisis: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          diseminasi_hasil: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          evaluasi: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ]
        },
        variabel_yang_dikumpulkan: [
          {
            nama: null,
            konsep: null,
            definisi: null,
            referensi_waktu: null
          }
        ]
      },
      blok_iv: {
        kegiatan_ini_dilakukan: "HANYA_SEKALI",
        frekuensi_penyelanggara: "HARIAN",
        tipe_pengumpulan_data: "LONGITUDINAL_PANEL",
        cakupan_wilayah_pengumpulan_data: "SELURUH_WILAYAH_INDONESIA",
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: null,
          mengisi_kuesioner_sendiri: null,
          pengamatan: null,
          pengumpulan_data_sekunder: null,
          lainnya: null,
          metode_pengumpulan_lainnya: null
        },
        sarana_pengumpulan_data: {
          papi: null,
          capi: null,
          cati: null,
          cawi: true,
          mail: true,
          lainnya: true,
          sarana_pengumpulan_lainnya: null
        },
        unit_pengumpulan_data: {
          individu: true,
          rumah_tangga: true,
          usaha_atau_perusahaan: true,
          lainnya: true,
          unit_pengumpulan_data_lainnya: null
        }
      },
      blok_v: {
        jenis_rancangan_sampel: "SINGLE_STAGE_ATAU_PHASE",
        metode_pemilihan_sampel_tahap_terakhir: "SAMPEL_PROBABILITAS",
        metode_yangdigunakan: "SIMPLE_RANDOM_SAMPLING",
        kerangka_sampel_tahap_terakhir: "LIST_FRAME",
        fraksi_sampel_keseluruhan: null,
        nilai_perkiraan_sampling_error_variabel_utama: null,
        unit_sampel: null,
        unit_observasi: null
      },
      blok_vi: {
        apakah_melakukan_uji_coba: true,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: true,
          supervisi: true,
          taskforce: true,
          lainnya: true,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: null
        },
        apakah_melakukan_penyesuaian_nonrespon: true,
        petugas_pengumpulan_data: "STAF_INSTANSI_PENYELENGGARA",
        persyaratan_pendidikan_terendah_petugas_pengumpulan_data: "KURANG_DARI_ATAU_SAMA_DENGAN_SMP",
        jumlah_petugas_supervisor: 0,
        jumlah_petugas_enumerator: 0,
        apakah_melakukan_pelatihan_petugas: true
      },
      blok_vii: {
        tahapan_pengolahan_data: {
          editing: true,
          coding: true,
          data_entry: true,
          validasi: true
        },
        metode_analisis: "DESKRIPTIF",
        unit_analsis: {
          individu: true,
          rumah_tangga: true,
          usaha_atau_perusahaan: true,
          lainnya: true,
          unit_analisis_lainnya: null
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: true,
          provinsi: true,
          kabupaten_atau_kota: true,
          kecamatan: true,
          lainnya: true,
          tingkat_penyajian_hasil_analisis_lainnya: null
        }
      },
      blok_viii: {
        ketersediaan_produk_tercetak: true,
        ketersediaan_produk_digital: true,
        ketersediaan_produk_mikrodata: true,
        rencana_jadwal_rilis_produk_tercetak: [
        ],
        rencana_jadwal_rilis_produk_digital: [
        ],
        rencana_jadwal_rilis_produk_mikrodata: [
        ]
      }
    },
    table: {
      wilayahFields: [
        {
          key: "no",
          label: "No",
          thStyle: { width: "50px" },
          tdClass: "text-center"
        },
        {
          key: "nama_provinsi",
          label: "Nama Provinsi"
        },
        {
          key: "nama_kabupaten_kota",
          label: "Kabupaten/Kota"
        }
      ],
    },

    options: {
      status: [
        { id: "DRAFT", label: "Draft" },
        { id: "SUBMITTED", label: "Submit" },
        { id: "UNDER_REVIEW", label: "Sedang Diperiksa" },
        { id: "REVISED", label: "Sudah Diperbaiki" },
        { id: "CORRECTION_REQUIRED", label: "Perlu Perbaikan" },
        { id: "REJECTED", label: "Ditolak" },
        { id: "APPROVED", label: "Disetujui" },
        { id: "PUBLISHED", label: "Publis" }
      ],
      jenis_statistik: [
        {
          id: "STATISTIK_DASAR",
          label: "Statistik Dasar",
          description: "Statistik yang pemanfaatannya ditujukan untuk keperluan yang bersifat luas, baik pemerintah maupun masyarakat, yang memiliki ciri-ciri lintas sektoral, berskala nasional maupun regional, makro, dan yang penyelenggaraannya menjadi tanggung jawab BPS.",
          color: "primary",
        },
        {
          id: "STATISTIK_SEKTORAL",
          label: "Statistik Sektoral",
          description: "Statistik yang pemanfaatannya ditujukan untuk memenuhi kebutuhan instansi pemerintah tertentu dalam rangka penyelenggaraan tugas-tugas pemerintah dan tugas pembangunan yang merupakan tugas pokok instansi pemerintah yang bersangkutan. Meskipun program pelaksanaannya menjadi tanggung jawab instansi pemerintah terkait, dalam praktek pelaksanaan dapat bekerja sama dengan BPS.",
          color: "secondary",
        },
        {
          id: "STATISTIK_KHUSUS",
          label: "Statistik Khusus",
          description: " Statistik yang pemanfaatannya ditujukan untuk memenuhi kebutuhan intern dari suatu instansi/perusahaan swasta dalam rangka penyelenggaraan riset atau penelitian. Meskipun pelaksanaannya menjadi tanggung jawab instansi/perusahaan terkait, dalm praktek pelaksanaan dapat bekerja sama dengan BPS.",
          color: "tertiary",
        },
      ],
      cara_pengumpulan_data: [
        { id: 'PENCACAHAN_LENGKAP', label: 'Pencacahan Lengkap ', code: 1 },
        { id: 'SURVEI', label: 'Survei', code: 2 },
        { id: 'KOMPILASI_PRODUK_ADMINISTRASI', label: 'Kompilasi Produk Administrasi', code: 3 },
        { id: 'CARA_LAIN_SESUAI_DENGAN_PERKEMBANGAN_TI', label: 'Cara Lain Sesuai Dengan Perkembangan Ti', code: 4 },
      ],
      sektor_kegiatan: [
        { id: 'PERTANIAN_DAN_PERIKANAN', label: 'Pertanian Dan Perikanan', code: 1 },
        { id: 'DEMOGRAFI_DAN_KEPENDUDUKAN', label: 'Demografi Dan Kependudukan', code: 2 },
        { id: 'PEMBANGUNAN', label: 'Pembangunan', code: 3 },
        { id: 'PROYEKSI_EKONOMI', label: 'Proyeksi Ekonomi', code: 4 },
        { id: 'PENDIDIKAN_DAN_PELATIHAN', label: 'Pendidikan Dan Pelatihan', code: 5 },
        { id: 'LINGKUNGAN', label: 'Lingkungan', code: 6 },
        { id: 'KEUANGAN', label: 'Keuangan', code: 7 },
        { id: 'GLOBALISASI', label: 'Globalisasi', code: 8 },
        { id: 'KESEHATAN', label: 'Kesehatan', code: 9 },
        { id: 'INDUSTRI_DAN_JASA', label: 'Industri Dan Jasa', code: 10 },
        { id: 'TEKNOLOGI_INFORMASI_DAN_KOMUNIKASI', label: 'Teknologi Informasi Dan Komunikasi', code: 11 },
        { id: 'PERDAGANGAN_INTERNASIONAL_DAN_NERACA_PERDAGANGAN', label: 'Perdagangan Internasional Dan Neraca Perdagangan', code: 12 },
        { id: 'KETENAGAKERJAAN', label: 'Ketenagakerjaan', code: 13 },
        { id: 'NERACA_NASIONAL', label: 'Neraca Nasional', code: 14 },
        { id: 'INDIKATOR_EKONOMI_BULANAN', label: 'Indikator Ekonomi Bulanan', code: 15 },
        { id: 'PRODUKTIVITAS', label: 'Produktivitas', code: 16 },
        { id: 'HARGA_DAN_PARITAS_DAYA_BELI', label: 'Harga Dan Paritas Daya Beli', code: 17 },
        { id: 'SEKTOR_PUBLIK_PERPAJAKAN_DAN_REGULASI_PASAR', label: 'Sektor Publik Perpajakan Dan Regulasi Pasar', code: 18 },
        { id: 'PERWILAYAHAN_DAN_PERKOTAAN', label: 'Perwilayahan Dan Perkotaan', code: 19 },
        { id: 'ILMU_PENGETAHUAN_DAN_HAK_PATEN', label: 'Ilmu Pengetahuan Dan Hak Paten', code: 20 },
        { id: 'PERLINDUNGAN_SOSIAL_DAN_KESEJAHTERAAN', label: 'Perlindungan Sosial Dan Kesejahteraan', code: 21 },
        { id: 'TRANSPORTASI', label: 'Transportasi', code: 22 },
      ],
      kegiatan_ini_dilakukan: [
        { id: 'HANYA_SEKALI', label: 'Hanya Sekali', code: 1 },
        { id: 'BERULANG', label: 'Berulang', code: 2 },
      ],
      frekuensi_penyelanggara: [
        { id: 'HARIAN', label: 'Harian ', code: 1 },
        { id: 'MINGGUAN', label: 'Mingguan', code: 2 },
        { id: 'BULANAN', label: 'Bulanan', code: 3 },
        { id: 'TRIWULANAN', label: 'Triwulanan', code: 4 },
        { id: 'EMPAT_BULANAN', label: 'Empat Bulanan', code: 5 },
        { id: 'SEMESTERAN', label: 'Semesteran', code: 6 },
        { id: 'TAHUNAN', label: 'Tahunan', code: 7 },
        { id: 'LEBIH_DARI_DUA_TAHUNAN', label: 'Lebih Dari Dua Tahunan', code: 8 },
      ],
      tipe_pengumpulan_data: [
        { id: 'LONGITUDINAL_PANEL', label: 'Longitudinal Panel', code: 1 },
        { id: 'LONGITUDINAL_CROSS_SECTIONAL', label: 'Longitudinal Cross Sectional', code: 2 },
        { id: 'CROSS_SECTIONAL', label: 'Cross Sectional', code: 3 },
      ],
      cakupan_wilayah_pengumpulan_data: [
        { id: 'SELURUH_WILAYAH_INDONESIA', label: 'Seluruh Wilayah Indonesia', code: 1 },
        { id: 'SEBAGIAN_WILAYAH_INDONESIA', label: 'Sebagian Wilayah Indonesia', code: 2 },
      ],
      jenis_rancangan_sampel: [
        { id: 'SINGLE_STAGE_ATAU_PHASE', label: 'Single Stage Atau Phase', code: 1 },
        { id: 'MULTI_STAGE_ATAU_PHASE', label: 'Multi Stage Atau Phase', code: 2 },
      ],
      metode_pemilihan_sampel_tahap_terakhir: [
        { id: 'SAMPEL_PROBABILITAS', label: 'Sampel Probabilitas', code: 1 },
        { id: 'SAMPEL_NONPROBABILITAS', label: 'Sampel Nonprobabilitas', code: 2 },
      ],
      metode_sampel_probabilitas: [
        { id: 'SIMPLE_RANDOM_SAMPLING', label: 'Simple Random Sampling', code: 1 },
        { id: 'SYSTEMATIC_RANDOM_SAMPLING', label: 'Systematic Random Sampling', code: 2 },
        { id: 'STRATIFIED_RANDOM_SAMPLING', label: 'Stratified Random Sampling', code: 3 },
        { id: 'CLUSTER_SAMPLING', label: 'Cluster Sampling', code: 4 },
        { id: 'PROBABILTY_PROPORTIONAL_TO_SIZE_SAMPLING', label: 'Probabilty Proportional to Size Sampling', code: 5 },
      ],
      metode_sampel_nonprobabilitas: [
        { id: 'QUOTA_SAMPLING', label: 'Quota Sampling', code: 6 },
        { id: 'ACCIDENTAL_SAMPLING', label: 'Accidental Sampling', code: 7 },
        { id: 'PURPOSIVE_SAMPLING', label: 'Purposive Sampling', code: 8 },
        { id: 'SNOWBALL_SAMPLING', label: 'Snowball Sampling', code: 9 },
        { id: 'SATURATION_SAMPLING', label: 'Saturation Sampling', code: 10 },
      ],
      kerangka_sampel_tahap_terakhir: [
        { id: 'LIST_FRAME', label: 'List Frame', code: 1 },
        { id: 'AREA_FRAME', label: 'Area Frame', code: 2 },
      ],
      metode_pemeriksaan_kualitas_pengumpulan_data: [
        { id: 'KUNJUNGAN_KEMBALI_ATAU_REVISIT', label: 'Kunjungan Kembali Atau Revisit', code: 1 },
        { id: 'SUPERVISI', label: 'Supervisi', code: 2 },
        { id: 'TASK_FORCE', label: 'Task Force', code: 4 },
        { id: 'LAINNYA', label: 'Lainnya', code: 8 },
      ],
      petugas_pengumpulan_data: [
        { id: 'STAF_INSTANSI_PENYELENGGARA', label: 'Staf Instansi Penyelenggara', code: 1 },
        { id: 'MITRA_ATAU_TENAGA_KONTRAK', label: 'Mitra Atau Tenaga Kontrak', code: 2 },
        { id: 'STAF_INSTANSI_PENYELENGGARA_DAN_MITRA_ATAU_TENAGA_KONTRAK', label: 'Staf Instansi Penyelenggara Dan Mitra Atau Tenaga Kontrak', code: 3 },
      ],
      persyaratan_pendidikan_terendah_petugas_pengumpulan_data: [
        { id: 'KURANG_DARI_ATAU_SAMA_DENGAN_SMP', label: 'Kurang Dari Atau Sama Dengan Smp', code: 1 },
        { id: 'SMA_ATAU_SMK', label: 'Sma Atau Smk', code: 2 },
        { id: 'DIPLOMA_I_ATAU_II_ATAU_III', label: 'Diploma I Atau Ii Atau Iii', code: 3 },
        { id: 'DIPLOMA_IV_ATAU_S1_ATAU_S2_ATAU_S3', label: 'Diploma Iv Atau S1 Atau S2 Atau S3', code: 4 },
      ],
      metode_analisis: [
        { id: 'DESKRIPTIF', label: 'Deskriptif', code: 1 },
        { id: 'INFERENSIA', label: 'Inferensia', code: 2 },
        { id: 'DESKRIPTIF_DAN_INFERENSIA', label: 'Deskriptif Dan Inferensia', code: 3 },
      ],
      ya_tidak: [
        { id: true, label: 'Ya', code: 1 },
        { id: false, label: 'Tidak', code: 2 },
      ],
      city: [],
      wilayah: [
        {
          id: 1,
          code: 11,
          name: "ACEH",
          children: []
        },
        {
          id: 2,
          code: 12,
          name: "SUMATERA UTARA",
          children: []
        },
        {
          id: 3,
          code: 13,
          name: "SUMATERA BARAT",
          children: []
        },
        {
          id: 4,
          code: 14,
          name: "RIAU",
          children: []
        },
        {
          id: 5,
          code: 15,
          name: "JAMBI",
          children: []
        },
        {
          id: 6,
          code: 16,
          name: "SUMATERA SELATAN",
          children: []
        },
        {
          id: 7,
          code: 17,
          name: "BENGKULU",
          children: []
        },
        {
          id: 8,
          code: 18,
          name: "LAMPUNG",
          children: []
        },
        {
          id: 9,
          code: 19,
          name: "KEPULAUAN BANGKA BELITUNG",
          children: []
        },
        {
          id: 10,
          code: 21,
          name: "KEPULAUAN RIAU",
          children: []
        },
        {
          id: 11,
          code: 31,
          name: "DKI JAKARTA",
          children: []
        },
        {
          id: 12,
          code: 32,
          name: "JAWA BARAT",
          children: []
        },
        {
          id: 13,
          code: 33,
          name: "JAWA TENGAH",
          children: []
        },
        {
          id: 14,
          code: 34,
          name: "DI YOGYAKARTA",
          children: []
        },
        {
          id: 15,
          code: 35,
          name: "JAWA TIMUR",
          children: []
        },
        {
          id: 16,
          code: 36,
          name: "BANTEN",
          children: []
        },
        {
          id: 17,
          code: 51,
          name: "BALI",
          children: []
        },
        {
          id: 18,
          code: 52,
          name: "NUSA TENGGARA BARAT",
          children: []
        },
        {
          id: 19,
          code: 53,
          name: "NUSA TENGGARA TIMUR",
          children: []
        },
        {
          id: 20,
          code: 61,
          name: "KALIMANTAN BARAT",
          children: []
        },
        {
          id: 21,
          code: 62,
          name: "KALIMANTAN TENGAH",
          children: []
        },
        {
          id: 22,
          code: 63,
          name: "KALIMANTAN SELATAN",
          children: []
        },
        {
          id: 23,
          code: 64,
          name: "KALIMANTAN TIMUR",
          children: []
        },
        {
          id: 24,
          code: 65,
          name: "KALIMANTAN UTARA",
          children: []
        },
        {
          id: 25,
          code: 71,
          name: "SULAWESI UTARA",
          children: []
        },
        {
          id: 26,
          code: 72,
          name: "SULAWESI TENGAH",
          children: []
        },
        {
          id: 27,
          code: 73,
          name: "SULAWESI SELATAN",
          children: []
        },
        {
          id: 28,
          code: 74,
          name: "SULAWESI TENGGARA",
          children: []
        },
        {
          id: 29,
          code: 75,
          name: "GORONTALO",
          children: []
        },
        {
          id: 30,
          code: 76,
          name: "SULAWESI BARAT",
          children: []
        },
        {
          id: 31,
          code: 81,
          name: "MALUKU",
          children: []
        },
        {
          id: 32,
          code: 82,
          name: "MALUKU UTARA",
          children: []
        },
        {
          id: 33,
          code: 91,
          name: "PAPUA BARAT",
          children: []
        },
        {
          id: 34,
          code: 94,
          name: "PAPUA",
          children: []
        }
      ],
      userWilayah: [],
      produsen_data: [],

    },
    modal: {
      error: {
        title: null,
        description: null,
      }
    }
  }),
  async mounted() {
    this.route = this.$route.name;
    this.getUserInfo(store.getters["auth/user"]);
    this.setWilayah();
    if (this.route == "UpdateMsKeg" || this.route == 'CycleMsKeg') {
      let id = parseInt(this.$route.params.id);
      this.updatedId = this.route == 'UpdateMsKeg' ? id : null;
      this.baseId = this.route == 'CycleMsKeg' ? id : null;

      this.isLoading = true;
      await this.getDetailMsKeg(id);
      this.isLoading = false;
    }
  },
  computed:{
    isUserPusat() {
      // 1. Cek peran aktif dari appData atau localStorage
      const activeRole = this.appData?.current_role || localStorage.getItem('msCurrentRole');
      if (activeRole) {
        if (
          activeRole === 'ROLE_WALIDATA_PUSAT' ||
          activeRole === 'ROLE_PRODUSEN_DATA_PUSAT' ||
          activeRole === 'ROLE_PEMBINA_DATA_PUSAT' ||
          activeRole === 'ROLE_SUPERADMIN' ||
          activeRole === 'ROLE_ADMIN'
        ) {
          return true;
        }
        if (
          activeRole === 'ROLE_WALIDATA_PROVINSI' ||
          activeRole === 'ROLE_WALIDATA_KABKOTA' ||
          activeRole === 'ROLE_WALIDATA_KABUPATEN_KOTA' ||
          activeRole === 'ROLE_PRODUSEN_DATA_PROVINSI' ||
          activeRole === 'ROLE_PRODUSEN_DATA_KABKOTA' ||
          activeRole === 'ROLE_PRODUSEN_DATA_KABUPATEN_KOTA' ||
          activeRole.includes('PROVINSI') ||
          activeRole.includes('KABKOTA') ||
          activeRole.includes('KABUPATEN')
        ) {
          return false;
        }
      }

      // 2. Cek kode wilayah instansi pengguna (00 = Pusat)
      const provCode = this.user?.organization?.province?.code;
      if (provCode && provCode !== '00') {
        return false;
      }

      // 3. Cek daftar peran pengguna di userRoles
      const roles = this.userRoles || [];
      const isPusatRole = roles.some(r =>
        r === 'ROLE_WALIDATA_PUSAT' ||
        r === 'ROLE_PRODUSEN_DATA_PUSAT' ||
        r === 'ROLE_PEMBINA_DATA_PUSAT' ||
        r === 'ROLE_SUPERADMIN' ||
        r === 'ROLE_ADMIN'
      );
      const isDaerahRole = roles.some(r =>
        r.includes('PROVINSI') ||
        r.includes('KABKOTA') ||
        r.includes('KABUPATEN')
      );

      if (isDaerahRole && !isPusatRole) return false;
      if (isPusatRole && !isDaerahRole) return true;

      if (provCode === '00') return true;

      return isPusatRole;
    },
    userRegionLabel() {
      const org = this.user?.organization;
      if (!org) return 'Wilayah Anda';
      const provName = org.province?.name || '';
      const cityName = org.city?.name || '';
      if (cityName && provName) return `${cityName}, ${provName}`;
      if (provName) return provName;
      if (org.name) return org.name;
      return 'Wilayah Anda';
    },
    activeRoleLabel() {
      const activeRole = this.appData?.current_role || localStorage.getItem('msCurrentRole') || (this.userRoles && this.userRoles[0]) || '';
      if (activeRole.includes('PRODUSEN_DATA_PUSAT')) return 'Produsen Data Pusat';
      if (activeRole.includes('WALIDATA_PUSAT')) return 'Walidata Pusat';
      if (activeRole.includes('PRODUSEN_DATA_PROVINSI')) return 'Produsen Data Provinsi';
      if (activeRole.includes('WALIDATA_PROVINSI')) return 'Walidata Provinsi';
      if (activeRole.includes('PRODUSEN_DATA_KABKOTA') || activeRole.includes('PRODUSEN_DATA_KABUPATEN_KOTA')) return 'Produsen Data Kab/Kota';
      if (activeRole.includes('WALIDATA_KABKOTA') || activeRole.includes('WALIDATA_KABUPATEN_KOTA')) return 'Walidata Kab/Kota';
      if (activeRole.includes('PEMBINA_DATA')) return 'Pembina Data';
      if (activeRole.includes('SUPERADMIN') || activeRole.includes('ADMIN')) return 'Superadmin';
      return activeRole || 'Pengguna';
    },
    isReviewVisible() {
      if (!this.isReviewOpen) return false;
      return (
        this.route === 'UpdateMsKeg' ||
        this.form.status === 'CORRECTION_REQUIRED' ||
        (this.form.reviews && this.form.reviews.length > 0) ||
        (this.reviewHistories && this.reviewHistories.length > 0) ||
        (this.msKegHistories && this.msKegHistories.length > 0)
      );
    },
    reviewHistories(){
      let msKeg = this.msKeg;
      if (!msKeg || !Array.isArray(msKeg.ms_keg_histories)) {
        return [];
      }
      let allReview = msKeg.ms_keg_histories.filter(x=> !x.active && x.reviews && x.reviews.length>0).map(x=>x.reviews).flat();
      allReview = lodash.uniqBy(allReview, 'note');
      let currentReviewNotes = msKeg.reviews ? msKeg.reviews.map(x => x.note) : [];

      let showedReviews = [];
      allReview.forEach(x => {
        if (!currentReviewNotes.includes(x.note)) {
          showedReviews.push(x);
        }
      })
      return showedReviews;
    },
    msKegHistories() {
      const msKeg = this.msKeg;
      if (!msKeg || !Array.isArray(msKeg.ms_keg_histories)) {
        return [];
      }
      // Sort dari yang terbaru ke yang terlama
      return [...msKeg.ms_keg_histories].sort((a, b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
        return tb - ta;
      });
    },

    judulKegiatanRules() {
      return judulKegiatanRules;
    }

  },
  watch: {
    'formExt.wilayah'() {
      this.data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data = this.formExt.wilayah.map(item => {
        return {//by selected one by one
          kode_provinsi: item.province_id,
          nama_provinsi: item.province_name,
          kode_kabupaten_kota: item.id,
          nama_kabupaten_kota: item.name
        }
      }).sort((x, y) => parseInt(x.kode_kabupaten_kota) - parseInt(y.kode_kabupaten_kota));
    },
    // ========================================
    // WATCHER 1: Kegiatan ini dilakukan
    // ========================================
    'data.blok_iv.kegiatan_ini_dilakukan'(newVal, oldVal) {
      if (oldVal && newVal !== 'BERULANG') {
        this.data.blok_iv.frekuensi_penyelanggara = null;
      }
    },

    // ========================================
    // WATCHER 2: Cara Pengumpulan Data
    // ========================================
    'data.cara_pengumpulan_data'(newVal, oldVal) {
      if (oldVal && newVal !== 'SURVEI') {
        // Clear Blok V
        this.data.blok_v = {
          jenis_rancangan_sampel: null,
          metode_pemilihan_sampel_tahap_terakhir: null,
          metode_yang_digunakan: null,
          kerangka_sampel_tahap_terakhir: null,
          fraksi_sampel_keseluruhan: null,
          nilai_perkiraan_sampling_error_variabel_utama: null,
          unit_sampel: null,
          unit_observasi: null
        };

        // Reset validation untuk Blok V
        this.$nextTick(() => {
          if (this.$refs.blokVObserver) {
            this.$refs.blokVObserver.reset();
          }
        });
      }
    },

    // ========================================
    // WATCHER 3: Cakupan Wilayah Pengumpulan Data
    // ========================================
    'data.blok_iv.cakupan_wilayah_pengumpulan_data'(newVal, oldVal) {
      if (oldVal && newVal !== 'SEBAGIAN_WILAYAH_INDONESIA') {
        this.data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data = [];
        this.formExt.wilayah = null;
      }
    },

    // ========================================
    // WATCHER 4: Metode Pemilihan Sampel Tahap Terakhir
    // ========================================
    'data.blok_v.metode_pemilihan_sampel_tahap_terakhir'(newVal, oldVal) {
      if (oldVal) {
        if (newVal !== 'SAMPEL_PROBABILITAS') {
          // Clear field yang hanya untuk probabilitas
          this.data.blok_v.kerangka_sampel_tahap_terakhir = null;
          // this.data.blok_v.fraksi_sampel_keseluruhan = null;
          // this.data.blok_v.nilai_perkiraan_sampling_error_variabel_utama = null;
          // this.data.blok_v.metode_yang_digunakan = null;
        }
      }
    },

    // ========================================
    // WATCHER 5: Sarana Pengumpulan Data (Deep Watch)
    // ========================================
    'data.blok_iv.sarana_pengumpulan_data': {
      handler(newVal, oldVal) {
        // Check jika ada perubahan dari state sebelumnya
        if (oldVal) {
          const hasPapiCapiCatiCawi = newVal.papi || newVal.capi ||
            newVal.cati;

          if (!hasPapiCapiCatiCawi) {
            // Clear field petugas
            this.data.blok_vi.petugas_pengumpulan_data = null;
            this.data.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data = null;
            this.data.blok_vi.jumlah_petugas_supervisor = null;
            this.data.blok_vi.jumlah_petugas_enumerator = null;
          }
        }
      },
      deep: true
    },

    // ========================================
    // WATCHER 6: Identitas Rekomendasi
    // Clear form jika rekomendasi dihapus
    // ========================================
    'formExt.getRecommendation'(newVal) {
      if (newVal === false) {
        // User memilih TIDAK mendapat rekomendasi
        this.data.identitas_rekomendasi = null;
        this.rekomendasi = null;
      }
    }
  },
  methods: {
    onSelectJenisStatistik(id) {
      if (id === 'STATISTIK_DASAR' && !this.isUserPusat) {
        if (!this.isStatistikDasarConfirmed) {
          this.$bvModal.show('modal-confirm-statistik-dasar');
          return;
        }
      }
      this.data.jenis_statistik = id;
      if (id !== 'STATISTIK_DASAR') {
        this.isStatistikDasarConfirmed = false;
      }
    },
    confirmStatistikDasar() {
      this.isStatistikDasarConfirmed = true;
      this.data.jenis_statistik = 'STATISTIK_DASAR';
      this.$bvModal.hide('modal-confirm-statistik-dasar');
    },
    cancelStatistikDasar() {
      this.isStatistikDasarConfirmed = false;
      if (this.data.jenis_statistik === 'STATISTIK_DASAR') {
        this.data.jenis_statistik = null;
      }
      this.$bvModal.hide('modal-confirm-statistik-dasar');
    },
    switchToStatistikSektoral() {
      this.isStatistikDasarConfirmed = false;
      this.data.jenis_statistik = 'STATISTIK_SEKTORAL';
      this.$bvModal.hide('modal-confirm-statistik-dasar');
    },
    addReviewNote() {
      if (!this.review.note || !this.review.note.trim()) return;
      if (!this.form.reviews) {
        this.form.reviews = [];
      }
      this.form.reviews.push({
        field: this.review.field,
        note: this.review.note.trim(),
        created_at: new Date().toISOString(),
      });
      this.review = {
        field: null,
        note: null,
      };
    },
    removeReviewNote(index) {
      if (this.form.reviews && this.form.reviews[index]) {
        this.form.reviews.splice(index, 1);
      }
    },
    getReviewFieldLabel(fieldId) {
      if (!fieldId) return '';
      const item = this.flatReviewFields && this.flatReviewFields.find(x => x.id === fieldId);
      return item ? item.label : fieldId;
    },
    async saveReviewsOnly() {
      if (!this.updatedId) return;
      this.isSavingReview = true;
      this.form.data = this.data;
      try {
        await MsService.updateMsKeg(this.form, this.updatedId);
        this.$bvToast.toast('Catatan pemeriksaan berhasil disimpan ke server.', {
          title: 'Sukses',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000
        });
      } catch (err) {
        console.error('Error saving reviews:', err);
        this.$bvToast.toast('Gagal menyimpan catatan pemeriksaan.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.isSavingReview = false;
      }
    },
    getUserInfo(user){
      if (!user) return;
      const org = user.sdiOrganization || {};
      const details = org.details || {};
      this.user = {
        username: user.username,
        name: user.name,
        email: user.email,
        organization: {
          id: org.id || null,
          name: org.name || null,
          address: details.address || null,
          province: details.province || null,
          city: details.city || null,
        } 
      };

      if (Array.isArray(user.role)) {
        this.userRoles = [...user.role];
      } else if (typeof user.role === 'string') {
        const raw = user.role.trim();
        if (raw.startsWith('[') && raw.endsWith(']')) {
          this.userRoles = raw.slice(1, -1).split(',').map(s => s.trim().replace(/^['"]|['"]$/g, '')).filter(Boolean);
        } else {
          this.userRoles = raw.split(',').map(s => s.trim().replace(/^['"]|['"]$/g, '')).filter(Boolean);
        }
      } else {
        this.userRoles = [];
      }
      this.form.submitter = this.user;
    },
    async getDetailMsKeg(id) {
      await MsService.getMsKegById(id).then(
        response => {
          const date = new Date()
          this.msKeg = response.data.result[0];
          let msKeg = response.data.result[0];
          this.form = {
              base_id: this.baseId ? this.baseId : null,
              submission_period: this.route=='CycleMsKeg'?date.getFullYear():msKeg.submission_period,
              data: null,
              reviews: msKeg.reviews ? [...msKeg.reviews] : [],
              status: msKeg.status,
              rejection_note: msKeg.rejection_note,
              submitter: this.user,
              produsen_data: {
                id: msKeg.produsen_data_id,
                name: msKeg.produsen_data_name,
                province_code: msKeg.produsen_data_province_code,
                city_code: msKeg.produsen_data_city_code
              },
              walidata_pusat: {
                id: msKeg.walidata_pusat_id,
                name: msKeg.walidata_pusat_name
              },
              version: 'v2',
              changes: null,
          };
          this.data = msKeg.data;
          this.formExt.getRecommendation = msKeg.data.identitas_rekomendasi ? true : false;
          if (msKeg.produsen_data_id) {
            this.formExt.produsenData = {
              id: msKeg.produsen_data_id,
              name: msKeg.produsen_data_name,
              provinceCode: msKeg.produsen_data_province_code,
              cityCode: msKeg.produsen_data_city_code
            }
          }

          if (msKeg.version == 'v1') {
            let keg = msKeg.data;
            this.data = {
              judul_kegiatan: keg.judulKegiatan,
              tahun: keg.tahun,
              jenis_statistik: msKeg.statistic_type,
              cara_pengumpulan_data: keg.caraPengumpulanData,
              sektor_kegiatan: keg.sektorKegiatan,
              identitas_rekomendasi: null,
              // blok_i: {
              //   instansi_penyelanggara: keg.blokI.instansiPenyelanggara,
              //   alamat_instansi_penyelenggara: {
              //     alamat:    keg.blokI.alamatLengkapInstansiPenyelenggara,
              //     telepon:   keg.blokI.telepon,
              //     email:     keg.blokI.email,
              //     faksimile: keg.blokI.faksimile
              //   }
              // },
              blok_i: {
                instansi_penyelanggara: null,
                alamat_instansi_penyelenggara: {
                  alamat: null,
                  telepon: null,
                  email: null,
                  faksimile: null
                }
              },
              blok_ii: {
                unit_penanggung_jawab: {
                  eselon1: keg.blokII.unitPenanggungJawabEselon1,
                  eselon2: keg.blokII.unitPenanggungJawabEselon2
                },
                penanggung_jawab_teknis: {
                  nama: keg.blokII.namaPenanggungJawabTeknis,
                  jabatan: keg.blokII.jabatanPenanggungJawabTeknis,
                  alamat: keg.blokII.alamatPenanggungJawabTeknis,
                  telepon: keg.blokII.teleponPenanggungJawabTeknis,
                  email: keg.blokII.emailPenanggungJawabTeknis,
                  faksimile: keg.blokII.faksimilePenanggungJawabTeknis
                }
              },
              blok_iii: {
                latar_belakang_kegiatan: keg.blokIII.latarBelakangKegiatan,
                tujuan_kegiatan: keg.blokIII.tujuanKegiatan,
                rencana_jadwal_kegiatan: {
                  perencanaan_kegiatan: keg.blokIII.rencanaJadwalKegiatan.perencanaanKegiatan.map(x => ({ awal: moment(x.awal).format('YYYY-MM-DD'), akhir: moment(x.akhir).format('YYYY-MM-DD') })),
                  desain: keg.blokIII.rencanaJadwalKegiatan.desain.map(x => ({ awal: moment(x.awal).format('YYYY-MM-DD'), akhir: moment(x.akhir).format('YYYY-MM-DD') })),
                  pengumpulan_data: keg.blokIII.rencanaJadwalKegiatan.pengumpulanData.map(x => ({ awal: moment(x.awal).format('YYYY-MM-DD'), akhir: moment(x.akhir).format('YYYY-MM-DD') })),
                  pengolahan_data: keg.blokIII.rencanaJadwalKegiatan.pengolahanData.map(x => ({ awal: moment(x.awal).format('YYYY-MM-DD'), akhir: moment(x.akhir).format('YYYY-MM-DD') })),
                  analisis: keg.blokIII.rencanaJadwalKegiatan.analisis.map(x => ({ awal: moment(x.awal).format('YYYY-MM-DD'), akhir: moment(x.akhir).format('YYYY-MM-DD') })),
                  diseminasi_hasil: keg.blokIII.rencanaJadwalKegiatan.diseminasiHasil.map(x => ({ awal: moment(x.awal).format('YYYY-MM-DD'), akhir: moment(x.akhir).format('YYYY-MM-DD') })),
                  evaluasi: keg.blokIII.rencanaJadwalKegiatan.evaluasi.map(x => ({ awal: moment(x.awal).format('YYYY-MM-DD'), akhir: moment(x.akhir).format('YYYY-MM-DD') }))
                },
                variabel_yang_dikumpulkan: keg.blokIII.variabelYangDikumpulkan.map(x => ({
                  nama: x.nama,
                  konsep: x.konsep,
                  definisi: x.definisi,
                  referensi_waktu: x.referensiWaktu
                }))
              },
              blok_iv: {
                kegiatan_ini_dilakukan: keg.blokIV.kegiatanIniDilakukan,
                frekuensi_penyelanggara: keg.blokIV.frekuensiPenyelanggara,
                tipe_pengumpulan_data: keg.blokIV.tipePengumpulanData,
                cakupan_wilayah_pengumpulan_data: keg.blokIV.cakupanWilayahPengumpulanData,
                sebagian_cakupan_wilayah_pengumpulan_data: keg.blokIV.cakupanWilayahPengumpulanData == 'SEBAGIAN_WILAYAH_INDONESIA' && keg.blokIV.sebagianCakupanWilayahPengumpulanData && keg.blokIV.sebagianCakupanWilayahPengumpulanData.length > 0 ?
                  keg.blokIV.sebagianCakupanWilayahPengumpulanData.map(x => ({
                    kode_provinsi: null,
                    nama_provinsi: x.provinsi,
                    kode_kabupaten_kota: null,
                    nama_kabupaten_kota: x.kabupatenKota
                  })) : [],
                metode_pengumpulan_data: {
                  wawancara: keg.blokIV.metodePengumpulanData.wawancara,
                  mengisi_kuesioner_sendiri: keg.blokIV.metodePengumpulanData.mengisiKuesionerSendiri,
                  pengamatan: keg.blokIV.metodePengumpulanData.pengamatan,
                  pengumpulan_data_sekunder: keg.blokIV.metodePengumpulanData.pengumpulanDataSekunder,
                  lainnya: keg.blokIV.metodePengumpulanData.lainnya,
                  metode_pengumpulan_lainnya: keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya ? keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya : null
                },
                sarana_pengumpulan_data: {
                  papi: keg.blokIV.saranaPengumpulanData.papi,
                  capi: keg.blokIV.saranaPengumpulanData.capi,
                  cati: keg.blokIV.saranaPengumpulanData.cati,
                  cawi: keg.blokIV.saranaPengumpulanData.cawi,
                  mail: keg.blokIV.saranaPengumpulanData.mail,
                  lainnya: keg.blokIV.saranaPengumpulanData.lainnya,
                  sarana_pengumpulan_lainnya:
                    keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya ? keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya : null,
                },
                unit_pengumpulan_data: {
                  individu: keg.blokIV.unitPengumpulanData.individu,
                  rumah_tangga: keg.blokIV.unitPengumpulanData.rumahTangga,
                  usaha_atau_perusahaan: keg.blokIV.unitPengumpulanData.usahaAtauPerusahaan,
                  lainnya: keg.blokIV.unitPengumpulanData.lainnya,
                  unit_pengumpulan_data_lainnya: keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya ? keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya : null
                }
              },
              blok_v: {
                jenis_rancangan_sampel: keg.blokV.jenisRancanganSampel,
                metode_pemilihan_sampel_tahap_terakhir: keg.blokV.metodePemilihanSampelTahapTerakhir,
                metode_yang_digunakan: keg.blokV.metodeYangdigunakan == 'MULTI_STAGE_SAMPLING' ? 'PROBABILTY_PROPORTIONAL_TO_SIZE_SAMPLING' : keg.blokV.metodeYangdigunakan,
                kerangka_sampel_tahap_terakhir: keg.blokV.kerangkaSampelTahapTerakhir,
                fraksi_sampel_keseluruhan: keg.blokV.fraksiSampelKeseluruhan,
                nilai_perkiraan_sampling_error_variabel_utama: keg.blokV.nilaiPerkiraanSamplingErrorVariabelUtama,
                unit_sampel: keg.blokV.unitSampel,
                unit_observasi: keg.blokV.unitObservasi
              },
              blok_vi: {
                apakah_melakukan_uji_coba: keg.blokVI.apakahMelakukanUjiCoba,
                metode_pemeriksaan_kualitas_pengumpulan_data: {
                  kunjungan_kembali: keg.blokVI.metodePemeriksaanKualitasPengumpulanData.kunjunganKembali,
                  supervisi: keg.blokVI.metodePemeriksaanKualitasPengumpulanData.supervisi,
                  taskforce: keg.blokVI.metodePemeriksaanKualitasPengumpulanData.taskforce,
                  lainnya: keg.blokVI.metodePemeriksaanKualitasPengumpulanData.lainnya,
                  metode_pemeriksaan_kualitas_pengumpulan_data_lainnya:
                    keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya ? keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya : null
                },
                apakah_melakukan_penyesuaian_nonrespon: keg.blokVI.apakahMelakukanPenyesuaianNonrespon,
                petugas_pengumpulan_data: keg.blokVI.petugasPengumpulanData,
                persyaratan_pendidikan_terendah_petugas_pengumpulan_data: keg.blokVI.persyaratanPendidikanTerendahPetugasPengumpulanData,
                jumlah_petugas_supervisor: keg.blokVI.jumlahPetugasSupervisor,
                jumlah_petugas_enumerator: keg.blokVI.jumlahPetugasEnumerator,
                apakah_melakukan_pelatihan_petugas: keg.blokVI.apakahMelakukanPelatihanPetugas
              },
              blok_vii: {
                tahapan_pengolahan_data: {
                  editing: keg.blokVII.tahapanPengolahanData.udi,
                  coding: keg.blokVII.tahapanPengolahanData.udi,
                  data_entry: keg.blokVII.tahapanPengolahanData.udi,
                  validasi: keg.blokVII.tahapanPengolahanData.udi
                },
                metode_analisis: keg.blokVII.metodeAnalisis,
                unit_analsis: {
                  individu: keg.blokVII.unitAnalsis.individu,
                  rumah_tangga: keg.blokVII.unitAnalsis.rumahTangga,
                  usaha_atau_perusahaan: keg.blokVII.unitAnalsis.usahaAtauPerusahaan,
                  lainnya: keg.blokVII.unitAnalsis.lainnya,
                  unit_analisis_lainnya: keg.blokVII.unitAnalsis.unitAnalisisLainnya ? keg.blokVII.unitAnalsis.unitAnalisisLainnya : null
                },
                tingkat_penyajian_hasil_analisis: {
                  nasional: keg.blokVII.tingkatPenyajianHasilAnalisis.nasional,
                  provinsi: keg.blokVII.tingkatPenyajianHasilAnalisis.provinsi,
                  kabupaten_atau_kota: keg.blokVII.tingkatPenyajianHasilAnalisis.kabupatenAtauKota,
                  kecamatan: keg.blokVII.tingkatPenyajianHasilAnalisis.kecamatan,
                  lainnya: keg.blokVII.tingkatPenyajianHasilAnalisis.lainnya,
                  tingkat_penyajian_hasil_analisis_lainnya: keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya ? keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya : null,
                }
              },
              blok_viii: {
                ketersediaan_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak,
                ketersediaan_produk_digital: keg.blokVIII.ketersediaanProdukDigital,
                ketersediaan_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata,
                rencana_jadwal_rilis_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak ? keg.blokVIII.rencanaJadwalRilisProdukTercetak.map(x => moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
                rencana_jadwal_rilis_produk_digital: keg.blokVIII.ketersediaanProdukDigital ? keg.blokVIII.rencanaJadwalRilisProdukDigital.map(x => moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
                rencana_jadwal_rilis_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata ? keg.blokVIII.rencanaJadwalRilisProdukMikrodata.map(x => moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
              }
            };
          }
          if (this.data.blok_iv.cakupan_wilayah_pengumpulan_data == 'SEBAGIAN_WILAYAH_INDONESIA') {
            this.formExt.wilayah = this.data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data.map(item => {
              let city = item.kode_kabupaten_kota ? this.options.city.find(x => x.id == item.kode_kabupaten_kota) : this.options.city.find(x => x.name == item.nama_kabupaten_kota);
              if (city !== undefined) {
                return {
                  id: city.id,
                  name: city.name,
                  province_id: city.province_id,
                  province_name: city.province_name
                }
              }
            })
          }
          if (this.route == "CycleMsKeg") {
            this.form.status = "DRAFT";
            this.form.rejection_note = null;
            this.data.tahun = null;
          }
          if(this.data && this.data.jenis_statistik === 'STATISTIK_DASAR'){
            this.isStatistikDasarConfirmed = true;
          }
          // ;
        },
        error => {
          console.error(error);
        }
      );
    },
    async validateForm() {
      let index = this.section.currentIndex;
      if (index == 0) {
        this.section.items[index].status = await this.$refs.halamanAwalObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 1) {
        this.section.items[index].status = await this.$refs.blokIObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 2) {
        this.section.items[index].status = await this.$refs.blokIIObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 3) {
        this.section.items[index].status = await this.$refs.blokIIIObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 4) {
        this.section.items[index].status = await this.$refs.blokIVObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 5) {
        this.section.items[index].status = await this.$refs.blokVObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 6) {
        this.section.items[index].status = await this.$refs.blokVIObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 7) {
        this.section.items[index].status = await this.$refs.blokVIIObserver.validate() ? 'valid' : 'invalid';
      }
      if (index == 8) {
        this.section.items[index].status = await this.$refs.blokVIIIObserver.validate() ? 'valid' : 'invalid';
      }
    },
    async validateAll() {
      this.section.items[0].status = await this.$refs.halamanAwalObserver.validate() ? 'valid' : 'invalid';
      this.section.items[1].status = await this.$refs.blokIObserver.validate() ? 'valid' : 'invalid';
      this.section.items[2].status = await this.$refs.blokIIObserver.validate() ? 'valid' : 'invalid';
      this.section.items[3].status = await this.$refs.blokIIIObserver.validate() ? 'valid' : 'invalid';
      this.section.items[4].status = await this.$refs.blokIVObserver.validate() ? 'valid' : 'invalid';
      if (this.data.cara_pengumpulan_data == 'SURVEI') {
        this.section.items[5].status = await this.$refs.blokVObserver.validate() ? 'valid' : 'invalid';
      }
      this.section.items[6].status = await this.$refs.blokVIObserver.validate() ? 'valid' : 'invalid';
      this.section.items[7].status = await this.$refs.blokVIIObserver.validate() ? 'valid' : 'invalid';
      this.section.items[8].status = await this.$refs.blokVIIIObserver.validate() ? 'valid' : 'invalid';
    },
    async save(saveType) {
      await this.validateAll();
      let isError = this.section.items.filter(x => x.status == 'invalid').length > 0;
      this.form.data = this.data;
      if (saveType == 'DRAFT') {
        if (this.form.data.judul_kegiatan == null || this.form.data.tahun == null || this.formExt.produsenData == null) {
          this.modal.error.title = 'Isian Error';
          this.modal.error.description = 'Untuk dapat menyimpan dalam bentuk DRAFT, minimal isian <span class="text-primary">Nama Kegiatan, Tahun kegiatan & Instansi Penyelanggara</span> tidak boleh kosong';
          this.$bvModal.show('modal-error');
        } else {
          this.sendData()
        }
      } else {
        if (isError) {
          this.modal.error.title = 'Isian Error';
          this.modal.error.description = 'Untuk dapat melakukan submit, pastikan tidak ada lagi isian yang error';
          this.$bvModal.show('modal-error');

        } else {
          this.form.status = this.form.status == 'DRAFT' ? 'SUBMITTED' : 'REVISED';
          this.sendData()
        }
      }
    },
    async sendData() {
      this.$bvModal.show('modal-saving');
      this.saveState = 'SAVING';
      if (this.route == "UpdateMsKeg") {
        MsService.updateMsKeg(this.form, this.updatedId).then(
          (result) => {
            let response = result.data.result[0];
            if (response.status == 403 || response.status == 500) {
              if (response.status == 403) {
                this.modal.error.title = 'Forbidden';
                this.modal.error.description = 'Anda tidak mempunyai akses untuk mengupdate item';
              }
              else {
                this.modal.error.title = response.title;
                this.modal.error.description = response.detail;
              }
              this.$bvModal.hide('modal-saving');
              this.$bvModal.show('modal-error');
            } else {
              if (response.id) {
                this.saveState = 'SUCCESS';
                this.delay(2000).then(() => this.$router.push('/metadata/summary'));
              } else {
                this.saveState = 'ERROR';
                this.saveError = response;
              }
            }
          },
          (error) => {
            this.saveState = 'ERROR';
            this.saveError = error.response;
          }
        );
      } else {
        MsService.saveNewMsKeg(this.form).then(
          (result) => {
            let response = result.data.result[0];
            if (response.status == 403 || response.status == 500) {
              if (response.status == 403) {
                this.modal.error.title = 'Forbidden';
                this.modal.error.description = 'Anda tidak mempunyai akses untuk menambahkan item';
              }
              else {
                this.modal.error.title = response.title;
                this.modal.error.description = response.detail;
              }
              this.$bvModal.hide('modal-saving');
              this.$bvModal.show('modal-error');
            } else {
              if (response.id) {
                this.saveState = 'SUCCESS';
                this.delay(2000).then(() => this.$router.push('/metadata/summary'));
              } else {
                this.saveState = 'ERROR';
                this.saveError = response;
              }
            }
          },
          (error) => {
            this.saveState = 'ERROR';
            this.saveError = error.response;
          }
        );
      }

    },
    async loadRekomendasi() {
      this.$bvModal.show('modal-loading')
      await rekomendasiService.getData(this.data.identitas_rekomendasi).then(
        response => {
          this.rekomendasi = response.data.result;
          if (this.rekomendasi.versi == 'v1') {
            this.mappingRekomendasi(this.rekomendasi);
          } else if (this.rekomendasi.versi == 'v2') {
            this.mappingRekomendasiV2(this.rekomendasi);

          }
        },
        error => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
      this.$bvModal.hide('modal-loading')
    },
    mappingRekomendasi(result) {
      let rekomendasi = JSON.parse(result.form)
      this.data.judul_kegiatan = result.judul_kegiatan ? result.judul_kegiatan : "";
      this.data.tahun = result.tahun ? result.tahun : "";
      this.data.jenis_statistik = "STATISTIK_SEKTORAL";
      this.data.cara_pengumpulan_data = result.cara_pengumpulan_data == 'survei' ? 'SURVEI' : (result.cara_pengumpulan_data == "kompromin" ? "KOMPILASI_PRODUK_ADMINISTRASI" : null),
        this.data.sektor_kegiatan = null;
      this.data.identitas_rekomendasi = result.nomor_rekomendasi ? result.nomor_rekomendasi : "",

        this.data.blok_ii = {
          unit_penanggung_jawab: {
            eselon1: null,
            eselon2: null
          },
          penanggung_jawab_teknis: {
            nama: rekomendasi.Nama_Manajer_Survei,
            jabatan: rekomendasi.Jabatan_Manajer_Survei,
            alamat: rekomendasi.Alamat_Manajer_Survei,
            telepon: rekomendasi.Telepon_Manajer_Survei,
            email: rekomendasi['E-mail_Manajer_Survei'],
            faksimile: rekomendasi.Fax_Manajer_Survei
          }
        },
        this.data.blok_iii = {
          latar_belakang_kegiatan: null,
          tujuan_kegiatan: rekomendasi.Tujuan_Survei ? rekomendasi.Tujuan_Survei : rekomendasi.Tujuan_Dan_Manfaat_Kegiatan,
          rencana_jadwal_kegiatan: {
            perencanaan_kegiatan: [
              {
                awal: rekomendasi.Perencanaan_Persiapan_Mulai,
                akhir: rekomendasi.Perencanaan_Persiapan_Selesai
              }
            ],
            desain: [
              {
                awal: null,
                akhir: null
              }
            ],
            pengumpulan_data: [
              {
                awal: rekomendasi.Pelaksanaan_Lapangan_Mulai ? rekomendasi.Pelaksanaan_Lapangan_Mulai : rekomendasi.Pengumpulan_Data_Mulai,
                akhir: rekomendasi.Pelaksanaan_Lapangan_Selesai ? rekomendasi.Pelaksanaan_Lapangan_Selesai : rekomendasi.Pengumpulan_Data_Selesai
              }
            ],
            pengolahan_data: [
              {
                awal: rekomendasi.Pengolahan_Mulai,
                akhir: rekomendasi.Pengolahan_Selesai
              }
            ],
            analisis: [
              {
                awal: rekomendasi.Analisis_Mulai,
                akhir: rekomendasi.Analisis_Selesai
              }
            ],
            diseminasi_hasil: [
              {
                awal: rekomendasi.Penyajian_Mulai ? rekomendasi.Penyajian_Mulai : rekomendasi.Diseminasi_Mulai,
                akhir: rekomendasi.Penyajian_Selesai ? rekomendasi.Penyajian_Selesai : rekomendasi.Diseminasi_Selesai
              }
            ],
            evaluasi: [
              {
                awal: null,
                akhir: null
              }
            ]
          },
          variabel_yang_dikumpulkan: rekomendasi.Variabel && rekomendasi.Variabel.length > 0 ? rekomendasi.Variabel.map(x => ({ nama: x.nama, konsep: null, definisi: null, referensi_waktu: x.referensi_waktu })) : [
            {
              nama: null,
              konsep: null,
              definisi: null,
              referensi_waktu: null
            }
          ]
        };
      let kegiatan_ini_dilakukan = rekomendasi.Survei_ini_dilakukan ? rekomendasi.Survei_ini_dilakukan : rekomendasi.Kegiatan_Ini_Dilakukan.value;
      let frekuensi = rekomendasi.Jika_Berulang_Frekuensi_Penyelenggaraan ? rekomendasi.Jika_Berulang_Frekuensi_Penyelenggaraan : rekomendasi.Frekuensi_Penyelenggaraan_Kegiatan?rekomendasi.Frekuensi_Penyelenggaraan_Kegiatan.value.toUpperCase():"";
      // let tipe_pengumpulan_data = rekomendasi.Tipe_Pengumpulan_Data ? rekomendasi.Tipe_Pengumpulan_Data : rekomendasi.Jenis_data.value;
      let cakupan_wilayah_pengumpulan_data = rekomendasi.Survei_dilakukan_di ? rekomendasi.Survei_dilakukan_di: rekomendasi.Cakupan_Wilayah_Data.value;
      let metode_pengumpulan_data = Array.isArray(rekomendasi.Metode_Pengumpulan_Data) ? rekomendasi.Metode_Pengumpulan_Data.map(x=>x.value).join(' ') : (rekomendasi.Metode_Pengumpulan_Data ? rekomendasi.Metode_Pengumpulan_Data : null);
      let metode_pengumpulan_data_lainnya = metode_pengumpulan_data && !metode_pengumpulan_data.toLowerCase().includes('wawancara', 'mengisi kuesioner sendiri','pengamatan', 'data sekunder') ? metode_pengumpulan_data : null;
      if (rekomendasi.Metode_Pengumpulan_Data_Lainnya){
          metode_pengumpulan_data_lainnya += ' ' + rekomendasi.Metode_Pengumpulan_Data_Lainnya;
      }
      let tipe_pengumpulan_data = rekomendasi.Tipe_Pengumpulan_Data ? rekomendasi.Tipe_Pengumpulan_Data : (rekomendasi.Tipe_Pengumpulan_Data_Kegiatan ? rekomendasi.Tipe_Pengumpulan_Data_Kegiatan.value : (rekomendasi.Jenis_data ? rekomendasi.Jenis_data.value : null));
      let mapped_tipe_pengumpulan_data = this.mapTipePengumpulanData(tipe_pengumpulan_data);
      this.data.blok_iv = {
        kegiatan_ini_dilakukan: ['BERULANG', 'Berulang'].includes(kegiatan_ini_dilakukan) ? "BERULANG" : "HANYA_SEKALI",
        frekuensi_penyelanggara: frekuensi == 'LAINNYA' ? 'LEBIH_DARI_DUA_TAHUNAN' : frekuensi,
        tipe_pengumpulan_data: mapped_tipe_pengumpulan_data,
        cakupan_wilayah_pengumpulan_data: ['SEBAGIAN WILAYAH INDONESIA','Sebagian wilayah Indonesia'].includes(cakupan_wilayah_pengumpulan_data) ? "SEBAGIAN_WILAYAH_INDONESIA":"SELURUH_WILAYAH_INDONESIA",
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: metode_pengumpulan_data.toLowerCase().includes('wawancara') ? true : false,
          mengisi_kuesioner_sendiri: metode_pengumpulan_data.toLowerCase().includes('mengisi kuesioner sendiri') ? true : false,
          pengamatan: metode_pengumpulan_data.toLowerCase().includes('pengamatan') ? true : false,
          pengumpulan_data_sekunder: false,
          lainnya: metode_pengumpulan_data_lainnya ? true : false,
          metode_pengumpulan_lainnya: metode_pengumpulan_data_lainnya ? metode_pengumpulan_data_lainnya : null,
        },
        sarana_pengumpulan_data: {
          papi: true,
          capi: false,
          cati: false,
          cawi: false,
          mail: false,
          lainnya: false,
          sarana_pengumpulan_lainnya: null
        },
        unit_pengumpulan_data: {
          individu: true,
          rumah_tangga: false,
          usaha_atau_perusahaan: false,
          lainnya: false,
          unit_pengumpulan_data_lainnya: null
        }
      };
      let sebagian_cakupan_wilayah_pengumpulan_data = rekomendasi.Wilayah_Data_New ? rekomendasi.Wilayah_Data_New : rekomendasi.Wilayah_Data;
      if (this.data.blok_iv.cakupan_wilayah_pengumpulan_data == 'SEBAGIAN_WILAYAH_INDONESIA') {
        this.formExt.wilayah = sebagian_cakupan_wilayah_pengumpulan_data.map(x => ({
          id: x.kode_kabkot,
          name: x.kabkot,
          province_id: x.kode_provinsi,
          province_name: x.provinsi,
        }))

      }

      if (this.data.cara_pengumpulan_data == 'SURVEI') {
        let metode_yang_digunakan = rekomendasi.Metode_Penelitian == 'SAMPEL NON PROBABILITAS' ? rekomendasi.Metode_untuk_Sampel_Non_Probabilitas.toUpperCase() : rekomendasi.Metode_pemilihan_sampel.toUpperCase();
        if (metode_yang_digunakan.includes('Simple Random')) { metode_yang_digunakan = 'SIMPLE_RANDOM_SAMPLING' }
        else if (metode_yang_digunakan.includes('Systematic')) { metode_yang_digunakan = 'SYSTEMATIC_RANDOM_SAMPLING' }
        else if (metode_yang_digunakan.includes('Stratified')) { metode_yang_digunakan = 'STRATIFIED_RANDOM_SAMPLING' }
        else if (metode_yang_digunakan.includes('Cluster')) { metode_yang_digunakan = 'CLUSTER_SAMPLING' }
        else if (metode_yang_digunakan.includes('Multi Stage')) { metode_yang_digunakan = 'MULTI_STAGE_SAMPLING' }
        else if (metode_yang_digunakan.includes('Quota')) { metode_yang_digunakan = 'QUOTA_SAMPLING' }
        else if (metode_yang_digunakan.includes('Accidental')) { metode_yang_digunakan = 'ACCIDENTAL_SAMPLING' }
        else if (metode_yang_digunakan.includes('Purposive')) { metode_yang_digunakan = 'PURPOSIVE_SAMPLING' }
        else if (metode_yang_digunakan.includes('Snowball')) { metode_yang_digunakan = 'SNOWBALL_SAMPLING' }
        else if (metode_yang_digunakan.includes('Saturation')) { metode_yang_digunakan = 'SATURATION_SAMPLING' }
        else { metode_yang_digunakan = null }
        this.data.blok_v = {
          jenis_rancangan_sampel: rekomendasi.Jenis_Rancangan_Sampel == "SINGLE STAGE/PHASE" ? 'SINGLE_STAGE_ATAU_PHASE' : 'MULTI_STAGE_ATAU_PHASE',
          metode_pemilihan_sampel_tahap_terakhir: rekomendasi.Metode_Penelitian == 'SAMPEL NON PROBABILITAS' ? 'SAMPEL_NONPROBABILITAS' : 'SAMPEL_PROBABILITAS',
          metode_yang_digunakan: metode_yang_digunakan,
          kerangka_sampel_tahap_terakhir: "LIST_FRAME",
          fraksi_sampel_keseluruhan: rekomendasi.Keseluruhan_fraksi_sampel,
          nilai_perkiraan_sampling_error_variabel_utama: rekomendasi.Perkiraan_sampling_error,
          unit_sampel: rekomendasi.Unit_sampel,
          unit_observasi: null
        };
      }
      let petugas_pengumpulan_data = Array.isArray(rekomendasi.Petugas_Pengumpulan_Data) ? rekomendasi.Petugas_Pengumpulan_Data.map(x => x.value).join(' ') : rekomendasi.Petugas_Pengumpul_Data;
      let persyaratan_pendidikan_terendah_petugas_pengumpulan_data = rekomendasi.Persyaratan_pendidikan_terendah_petugas_pengumpulan_data ? rekomendasi.Persyaratan_pendidikan_terendah_petugas_pengumpulan_data.value : rekomendasi.Persyaratan_pendidikan_terendah_petugas_pengumpul_data;

      this.data.blok_vi = {
        apakah_melakukan_uji_coba: rekomendasi.Apakah_melakukan_Uji_Coba == 'Tidak' ? false : true,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: true,
          supervisi: false,
          taskforce: false,
          lainnya: false,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: null
        },
        apakah_melakukan_penyesuaian_nonrespon: true,
        petugas_pengumpulan_data: petugas_pengumpulan_data.includes('LAINNYA') ? null : (petugas_pengumpulan_data.includes('STAF', 'Staf') ? "STAF_INSTANSI_PENYELENGGARA" : 'MITRA_ATAU_TENAGA_KONTRAK'),

        persyaratan_pendidikan_terendah_petugas_pengumpulan_data:
          persyaratan_pendidikan_terendah_petugas_pengumpulan_data.includes('SMK') ? "SMA_ATAU_SMK" :
            (persyaratan_pendidikan_terendah_petugas_pengumpulan_data.toLowerCase().includes('akademi') ? "DIPLOMA_I_ATAU_II_ATAU_III" :
              'KURANG_DARI_ATAU_SAMA_DENGAN_SMP'),
        jumlah_petugas_supervisor: rekomendasi.Supervisor_Penyelia_Pengawas ? parseInt(rekomendasi.Supervisor_Penyelia_Pengawas.replace(' orang', '')) : parseInt(rekomendasi.Supervisi_Penyelia_Pengawas.replace(' orang', '')),
        jumlah_petugas_enumerator: rekomendasi.PengumpulData_Enumerator ? parseInt(rekomendasi.PengumpulData_Enumerator.replace(' orang', '')) : parseInt(rekomendasi.Enumerator_Kompilator_Pengumpuldata.replace(' orang', '')),
        apakah_melakukan_pelatihan_petugas: rekomendasi.Apakah_melakukan_pelatihan_petugas ?
          (rekomendasi.Apakah_melakukan_pelatihan_petugas.trim().substring(0, 2).toUpperCase() == "YA" ? true : false) :
          (rekomendasi.Apakah_Melakukan_Pelatihan_Petugas_Pengumpulandata.trim().substring(0, 2).toUpperCase() == 'YA' ? true : false),
      };
      let tingkat_penyajian_hasil_analisis = rekomendasi.Tingkat_Penyajian_Data ? rekomendasi.Tingkat_Penyajian_Data.map(x => x.id) : [];
      let metode_analisis = rekomendasi.Metode_analisis_hasil_survei ? rekomendasi.Metode_analisis_hasil_survei : rekomendasi.Metode_Analisis;
      this.data.blok_vii = {
        tahapan_pengolahan_data: {
          editing: rekomendasi.Penyuntingan == 'Ya' ? true : false,
          coding: rekomendasi.Penyandian == 'Ya' ? true : false,
          data_entry: rekomendasi.Inputdata && rekomendasi.Inputdata == 'Ya' ? true : false,
          validasi: rekomendasi.Penyahihan == 'Ya' ? true : false,
        },
        metode_analisis: metode_analisis.toLowerCase().includes('inferensia') ? 'INFERENSIA' : 'DESKRIPTIF',
        unit_analsis: {
          individu: false,
          rumah_tangga: false,
          usaha_atau_perusahaan: false,
          lainnya: rekomendasi.Unit_Analisis ? true : false,
          unit_analisis_lainnya: rekomendasi.Unit_Analisis ? rekomendasi.Unit_Analisis : null,
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: tingkat_penyajian_hasil_analisis.includes('1') ? true : false,
          provinsi: tingkat_penyajian_hasil_analisis.includes('2') ? true : false,
          kabupaten_atau_kota: tingkat_penyajian_hasil_analisis.includes('4') ? true : false,
          kecamatan: tingkat_penyajian_hasil_analisis.includes('8') ? true : false,
          lainnya: tingkat_penyajian_hasil_analisis.includes('16') ? true : false,
          tingkat_penyajian_hasil_analisis_lainnya: tingkat_penyajian_hasil_analisis.includes('16') ? rekomendasi.Tingkat_Penyajian_Data_Lainnya : null,
        }
      };
      let ketersediaan_produk_tercetak = rekomendasi.Publikasi_dalam_Media_Cetak ? rekomendasi.Publikasi_dalam_Media_Cetak : rekomendasi.Publikasi_Tercetak;
      let ketersediaan_produk_digital = rekomendasi.Publikasi_dalam_Media_Elektronik ? rekomendasi.Publikasi_dalam_Media_Elektronik : rekomendasi.Publikasi_Elektronik;
      let ketersediaan_produk_mikrodata = rekomendasi.Micro_Data ? rekomendasi.Micro_Data : null;

      this.data.blok_viii = {
        ketersediaan_produk_tercetak: ketersediaan_produk_tercetak == 'Ya' ? true : false,
        ketersediaan_produk_digital: ketersediaan_produk_digital == 'Ya' ? true : false,
        ketersediaan_produk_mikrodata: ketersediaan_produk_mikrodata == 'Ya' ? true : false,
        rencana_jadwal_rilis_produk_tercetak: ketersediaan_produk_tercetak == 'Ya' ? [rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum ? this.formatDate(rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum) : this.formatDate(rekomendasi.Rencana_Penerbitan_Publikasi_Untuk_Umum)] : [],
        rencana_jadwal_rilis_produk_digital: ketersediaan_produk_digital == 'Ya' ? [rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum ? this.formatDate(rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum) : this.formatDate(rekomendasi.Rencana_Penerbitan_Publikasi_Untuk_Umum)] : [],
        rencana_jadwal_rilis_produk_mikrodata: ketersediaan_produk_mikrodata == 'Ya' ? [rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum ? this.formatDate(rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum) : this.formatDate(rekomendasi.Rencana_Penerbitan_Publikasi_Untuk_Umum)] : []
      }
    },
    mappingRekomendasiV2(result) {
      let rekomendasi = JSON.parse(result.form);

      // ============================================
      // BASIC INFORMATION MAPPING
      // ============================================
      this.data.judul_kegiatan = result.judul_kegiatan ? result.judul_kegiatan : "";
      this.data.tahun = result.tahun ? result.tahun : "";
      this.data.jenis_statistik = "STATISTIK_SEKTORAL";
      this.data.cara_pengumpulan_data = result.cara_pengumpulan_data == 'survei' ? 'SURVEI' :
        (result.cara_pengumpulan_data == "kompromin" ? "KOMPILASI_PRODUK_ADMINISTRASI" : null);
      this.data.sektor_kegiatan = null;
      this.data.identitas_rekomendasi = result.nomor_rekomendasi ? result.nomor_rekomendasi : "";

      // ============================================
      // BLOK II: PENYELENGGARA
      // ============================================
      this.data.blok_ii = {
        unit_penanggung_jawab: {
          eselon1: null,
          eselon2: null
        },
        penanggung_jawab_teknis: {
          nama: rekomendasi.blok_ii.penanggung_jawab_teknis.nama,
          jabatan: rekomendasi.blok_ii.penanggung_jawab_teknis.jabatan,
          alamat: rekomendasi.blok_ii.penanggung_jawab_teknis.alamat,
          telepon: rekomendasi.blok_ii.penanggung_jawab_teknis.telepon,
          email: rekomendasi.blok_ii.penanggung_jawab_teknis.email,
          faksimile: rekomendasi.blok_ii.penanggung_jawab_teknis.faksimile
        }
      };

      // ============================================
      // BLOK III: DESAIN KEGIATAN
      // ============================================

      // BLOK III - DENGAN HELPER METHOD
      this.data.blok_iii = {
        latar_belakang_kegiatan: rekomendasi.blok_iii?.latar_belakang_kegiatan || "",
        tujuan_kegiatan: rekomendasi.blok_iii?.tujuan_kegiatan || "",
        rencana_jadwal_kegiatan: {
          perencanaan_kegiatan: this.normalizeJadwalArray(
            rekomendasi.blok_iii?.rencana_jadwal_kegiatan?.perencanaan_kegiatan
          ),
          desain: this.normalizeJadwalArray(
            rekomendasi.blok_iii?.rencana_jadwal_kegiatan?.desain
          ),
          pengumpulan_data: this.normalizeJadwalArray(
            rekomendasi.blok_iii?.rencana_jadwal_kegiatan?.pengumpulan_data
          ),
          pengolahan_data: this.normalizeJadwalArray(
            rekomendasi.blok_iii?.rencana_jadwal_kegiatan?.pengolahan_data
          ),
          analisis: this.normalizeJadwalArray(
            rekomendasi.blok_iii?.rencana_jadwal_kegiatan?.analisis
          ),
          diseminasi_hasil: this.normalizeJadwalArray(
            rekomendasi.blok_iii?.rencana_jadwal_kegiatan?.diseminasi_hasil
          ),
          evaluasi: this.normalizeJadwalArray(
            rekomendasi.blok_iii?.rencana_jadwal_kegiatan?.evaluasi
          )
        },
        variabel_yang_dikumpulkan: this.mapVariabelYangDikumpulkan(
          rekomendasi.blok_iii?.variabel_yang_dikumpulkan
        )
      };

      // ============================================
      // BLOK IV: METODOLOGI
      // ============================================
      this.data.blok_iv = {
        kegiatan_ini_dilakukan: rekomendasi.blok_iv.kegiatan_ini_dilakukan ?
          this.mapKegiatanDilakukan(rekomendasi.blok_iv.kegiatan_ini_dilakukan) : null,
        frekuensi_penyelanggara: rekomendasi.blok_iv.frekuensi_penyelanggara ?
          this.mapFrekuensiPenyelenggaraan(rekomendasi.blok_iv.frekuensi_penyelanggara) : null,
        tipe_pengumpulan_data: this.mapTipePengumpulanData(rekomendasi.blok_iv?.tipe_pengumpulan_data),
        cakupan_wilayah_pengumpulan_data: rekomendasi.blok_iv.cakupan_wilayah_pengumpulan_data ? 
          this.mapCakupanWilayahPengumpulanData(rekomendasi.blok_iv.cakupan_wilayah_pengumpulan_data) : null,
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: rekomendasi.blok_iv.metode_pengumpulan_data.wawancara || false,
          mengisi_kuesioner_sendiri: rekomendasi.blok_iv.metode_pengumpulan_data.mengisi_kuesioner_sendiri || false,
          pengamatan: rekomendasi.blok_iv.metode_pengumpulan_data.pengamatan || false,
          pengumpulan_data_sekunder: rekomendasi.blok_iv.metode_pengumpulan_data.pengumpulan_data_sekunder || false,
          lainnya: rekomendasi.blok_iv.metode_pengumpulan_data.lainnya || false,
          metode_pengumpulan_lainnya: rekomendasi.blok_iv.metode_pengumpulan_data.metode_pengumpulan_lainnya || null
        },
        sarana_pengumpulan_data: {
          papi: rekomendasi.blok_iv.sarana_pengumpulan_data.papi || false,
          capi: rekomendasi.blok_iv.sarana_pengumpulan_data.capi || false,
          cati: rekomendasi.blok_iv.sarana_pengumpulan_data.cati || false,
          cawi: rekomendasi.blok_iv.sarana_pengumpulan_data.cawi || false,
          mail: rekomendasi.blok_iv.sarana_pengumpulan_data.mail || false,
          lainnya: rekomendasi.blok_iv.sarana_pengumpulan_data.lainnya || false,
          sarana_pengumpulan_lainnya: rekomendasi.blok_iv.sarana_pengumpulan_data.sarana_pengumpulan_lainnya || null
        },
        unit_pengumpulan_data: {
          individu: rekomendasi.blok_iv.unit_pengumpulan_data?.individu || false,
          rumah_tangga: rekomendasi.blok_iv.unit_pengumpulan_data?.rumah_tangga || false,
          usaha_atau_perusahaan: rekomendasi.blok_iv.unit_pengumpulan_data?.usaha_atau_perusahaan || false,
          lainnya: rekomendasi.blok_iv.unit_pengumpulan_data?.lainnya || false,
          unit_pengumpulan_data_lainnya: rekomendasi.blok_iv.unit_pengumpulan_data?.unit_pengumpulan_data_lainnya || null
        }
      };

      // ============================================
      // BLOK V: DESAIN SAMPEL (Conditional)
      // ============================================
      if (this.data.cara_pengumpulan_data === 'SURVEI') {
        this.data.blok_v = {
          jenis_rancangan_sampel: rekomendasi.blok_v.jenis_rancangan_sampel ?
            this.mapJenisRancanganSampel(rekomendasi.blok_v.jenis_rancangan_sampel) : null,
          metode_pemilihan_sampel_tahap_terakhir: rekomendasi.blok_v.metode_pemilihan_sampel_tahap_terakhir ?
            this.mapMetodePemilihanSampelTahapTerakhir(rekomendasi.blok_v.metode_pemilihan_sampel_tahap_terakhir) : null,
          metode_yang_digunakan: rekomendasi.blok_v.metode_yang_digunakan ?
            this.snakeCaseConvert(rekomendasi.blok_v.metode_yang_digunakan) : null,
          kerangka_sampel_tahap_terakhir: rekomendasi.blok_v.kerangka_sampel_tahap_terakhir ?
            this.mapKerangkaSampelTahapTerakhir(rekomendasi.blok_v.kerangka_sampel_tahap_terakhir) : null,
          fraksi_sampel_keseluruhan: rekomendasi.blok_v.fraksi_sampel_keseluruhan ?
            rekomendasi.blok_v.fraksi_sampel_keseluruhan : null,
          nilai_perkiraan_sampling_error_variabel_utama: rekomendasi.blok_v.nilai_perkiraan_sampling_error_variabel_utama ?
            rekomendasi.blok_v.nilai_perkiraan_sampling_error_variabel_utama : null,
          unit_sampel: rekomendasi.blok_v.unit_sampel ? rekomendasi.blok_v.unit_sampel : null,
          unit_observasi: rekomendasi.blok_v.unit_observasi ? rekomendasi.blok_v.unit_observasi : null
        };
      } else {
        // Clear Blok V jika BUKAN survei
        this.data.blok_v = {
          jenis_rancangan_sampel: null,
          metode_pemilihan_sampel_tahap_terakhir: null,
          metode_yang_digunakan: null,
          kerangka_sampel_tahap_terakhir: null,
          fraksi_sampel_keseluruhan: null,
          nilai_perkiraan_sampling_error_variabel_utama: null,
          unit_sampel: null,
          unit_observasi: null
        };
      }

      // ============================================
      // BLOK VI: PENGUMPULAN DATA
      // ============================================
      this.data.blok_vi = {
        apakah_melakukan_uji_coba: rekomendasi.blok_vi.apakah_melakukan_uji_coba || false,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: rekomendasi.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.kunjungan_kembali || false,
          supervisi: rekomendasi.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.supervisi || false,
          taskforce: rekomendasi.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.taskforce || false,
          lainnya: rekomendasi.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya || false,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya:
            rekomendasi.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.metode_pemeriksaan_kualitas_pengumpulan_data_lainnya || null
        },
        apakah_melakukan_penyesuaian_nonrespon: rekomendasi.blok_vi.apakah_melakukan_penyesuaian_nonrespon || null,
        petugas_pengumpulan_data: rekomendasi.blok_vi.petugas_pengumpulan_data ?
          this.mapPetugasPengumpulanData(rekomendasi.blok_vi.petugas_pengumpulan_data) : null,
        persyaratan_pendidikan_terendah_petugas_pengumpulan_data:
          rekomendasi.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data ?
            this.mapPersyaratanPendidikanTerendahPetugasPengumpulanData(rekomendasi.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data) : null,
        jumlah_petugas_supervisor: rekomendasi.blok_vi.jumlah_petugas_supervisor || null,
        jumlah_petugas_enumerator: rekomendasi.blok_vi.jumlah_petugas_enumerator || null,
        apakah_melakukan_pelatihan_petugas: rekomendasi.blok_vi.apakah_melakukan_pelatihan_petugas || false
      };

      // ============================================
      // BLOK VII: PENGOLAHAN DAN ANALISIS
      // ============================================
      this.data.blok_vii = {
        tahapan_pengolahan_data: {
          editing: rekomendasi.blok_vii.tahapan_pengolahan_data.editing || false,
          coding: rekomendasi.blok_vii.tahapan_pengolahan_data.coding || false,
          data_entry: rekomendasi.blok_vii.tahapan_pengolahan_data.data_entry || false,
          validasi: rekomendasi.blok_vii.tahapan_pengolahan_data.validasi || false
        },
        metode_analisis: rekomendasi.blok_vii.metode_analisis ?
          this.mapMetodeAnalisis(rekomendasi.blok_vii.metode_analisis) : null,
        unit_analsis: {
          individu: rekomendasi.blok_vii.unit_analsis?.individu || false,
          rumah_tangga: rekomendasi.blok_vii.unit_analsis?.rumah_tangga || false,
          usaha_atau_perusahaan: rekomendasi.blok_vii.unit_analsis?.usaha_atau_perusahaan || false,
          lainnya: rekomendasi.blok_vii.unit_analsis?.lainnya || false,
          unit_analisis_lainnya: rekomendasi.blok_vii.unit_analsis?.unit_analisis_lainnya || null
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: rekomendasi.blok_vii.tingkat_penyajian_hasil_analisis?.nasional || false,
          provinsi: rekomendasi.blok_vii.tingkat_penyajian_hasil_analisis?.provinsi || false,
          kabupaten_atau_kota: rekomendasi.blok_vii.tingkat_penyajian_hasil_analisis?.kabupaten_atau_kota || false,
          kecamatan: rekomendasi.blok_vii.tingkat_penyajian_hasil_analisis?.kecamatan || false,
          lainnya: rekomendasi.blok_vii.tingkat_penyajian_hasil_analisis?.lainnya || false,
          tingkat_penyajian_hasil_analisis_lainnya:
            rekomendasi.blok_vii.tingkat_penyajian_hasil_analisis?.tingkat_penyajian_hasil_analisis_lainnya || null
        }
      };

      // ============================================
      // BLOK VIII: DISEMINASI HASIL
      // ============================================
      this.data.blok_viii = {
        ketersediaan_produk_tercetak: rekomendasi.blok_viii.ketersediaan_produk_tercetak || false,
        ketersediaan_produk_digital: rekomendasi.blok_viii.ketersediaan_produk_digital || false,
        ketersediaan_produk_mikrodata: rekomendasi.blok_viii.ketersediaan_produk_mikrodata || false,
        rencana_jadwal_rilis_produk_tercetak: rekomendasi.blok_viii.rencana_jadwal_rilis_produk_tercetak || [],
        rencana_jadwal_rilis_produk_digital: rekomendasi.blok_viii.rencana_jadwal_rilis_produk_digital || [],
        rencana_jadwal_rilis_produk_mikrodata: rekomendasi.blok_viii.rencana_jadwal_rilis_produk_mikrodata || []
      };

      // ============================================
      // APPLY CONDITIONAL VALIDATION RULES
      // ============================================
      this.applyConditionalRules();

      // ============================================
      // RESET VALIDATION STATE
      // ============================================
      this.$nextTick(() => {
        // Reset all ValidationObserver
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('Observer') && this.$refs[key]) {
            this.$refs[key].reset();
          }
        });
      });

    },
    mapKegiatanDilakukan(value) {
        
        // Map ke enum yang benar
        const mapping = {
          'hanya_sekali': 'HANYA_SEKALI',
          'berulang': 'BERULANG'
        };
        
        return mapping[value] || value;
      },
      mapFrekuensiPenyelenggaraan(value) {
        
        // Map ke enum yang benar
        const mapping = {
          'harian': 'HARIAN',
          'mingguan': 'MINGGUAN',
          'bulanan': 'BULANAN',
          'triwulanan': 'TRIWULANAN',
          'empat_bulanan': 'EMPAT_BULANAN',
          'semesteran': 'SEMESTERAN',
          'tahunan': 'TAHUNAN',
          '>_dua_tahunan': 'LEBIH_DARI_DUA_TAHUNAN'
        };
        
        return mapping[value] || value;
      },
      mapTipePengumpulanData(value) {
        if (!value || value === '-') return null;
        // Map ke enum yang benar
        const mapping = {
          'longitudinal_panel': 'LONGITUDINAL_PANEL',
          'cross_sectional': 'CROSS_SECTIONAL',
          'longitudinal_cross_sectional': 'LONGITUDINAL_CROSS_SECTIONAL',
          'longitudinal': 'LONGITUDINAL_PANEL',
          'series': 'LONGITUDINAL_PANEL',
          'series dan cross section': 'LONGITUDINAL_CROSS_SECTIONAL',
          'longitudinal dan cross sectional': 'LONGITUDINAL_CROSS_SECTIONAL',
          'longitudinal panel': 'LONGITUDINAL_PANEL',
          'longitudinal cross sectional': 'LONGITUDINAL_CROSS_SECTIONAL'
        };
        
        const key = typeof value === 'string' ? value.toLowerCase().trim() : value;
        return mapping[key] || (['LONGITUDINAL_PANEL', 'CROSS_SECTIONAL', 'LONGITUDINAL_CROSS_SECTIONAL'].includes(value) ? value : null);
      },
      mapCakupanWilayahPengumpulanData(value) {
        
        // Map ke enum yang benar
        const mapping = {
          'seluruh_wilayah_indonesia': 'SELURUH_WILAYAH_INDONESIA',
          'sebagian_wilayah_indonesia': 'SEBAGIAN_WILAYAH_INDONESIA'
        };
        
        return mapping[value] || value;
      },
      mapJenisRancanganSampel(value) {
        
        // Map ke enum yang benar
        const mapping = {
          'single_stage': 'SINGLE_STAGE_ATAU_PHASE',
          'multi_stage': 'MULTI_STAGE_ATAU_PHASE'
        };
        
        return mapping[value] || value;
      },
      mapMetodePemilihanSampelTahapTerakhir(value) {
        
        // Map ke enum yang benar
        const mapping = {
          'sampel_probabilitas': 'SAMPEL_PROBABILITAS',
          'sampel_nonprobabilitas': 'SAMPEL_NONPROBABILITAS'
        };
        
        return mapping[value] || value;
      },
      mapKerangkaSampelTahapTerakhir(value) {
        
        // Map ke enum yang benar
        const mapping = {
          'list_frame': 'LIST_FRAME',
          'area_frame': 'AREA_FRAME'
        };
        
        return mapping[value] || value;
      },
      mapPetugasPengumpulanData(value) {
        
        // Map ke enum yang benar
        const mapping = {
          'staf_instansi_penyelenggara': 'STAF_INSTANSI_PENYELENGGARA',
          'mitra_atau_tenaga_kontrak': 'MITRA_ATAU_TENAGA_KONTRAK',
          'staf_instansi_penyelenggara_dan_mitra_atau_tenaga_kontrak':'STAF_INSTANSI_PENYELENGGARA_DAN_MITRA_ATAU_TENAGA_KONTRAK'
        };
        
        return mapping[value] || value;
      },
      mapPersyaratanPendidikanTerendahPetugasPengumpulanData(value) {
        // Map ke enum yang benar
        const mapping = {
          'smp': 'KURANG_DARI_ATAU_SAMA_DENGAN_SMP',
          'sma_atau_smk': 'SMA_ATAU_SMK',
          'diploma':'DIPLOMA_I_ATAU_II_ATAU_III',
          'sarjana':'DIPLOMA_IV_ATAU_S1_ATAU_S2_ATAU_S3'
        };
        
        return mapping[value] || value;
      },
      mapMetodeAnalisis(value) {
        // Map ke enum yang benar
        const mapping = {
          'analisis_deskriptif': 'DESKRIPTIF',
          'ANALISIS DESKRIPTIF': 'DESKRIPTIF',
          'analisis_inferensia': 'INFERENSIA',
          'ANALISIS INFERENSIA': 'INFERENSIA',
          'ANALISIS DESKRIPTIF DAN INFERENSIA': 'DESKRIPTIF_DAN_INFERENSIA',
          'analisis_deskriptif_dan_inferensia': 'DESKRIPTIF_DAN_INFERENSIA'
        };
        
        return mapping[value] || value;
      },
    mapVariabelYangDikumpulkan(variabelData) {
      // Default structure jika data tidak ada
      const defaultVariabel = [
        {
          nama: null,
          konsep: null,
          definisi: null,
          referensi_waktu: null
        }
      ];

      // Jika data tidak ada (null/undefined)
      if (!variabelData) {
        return defaultVariabel;
      }

      // Jika bukan array
      if (!Array.isArray(variabelData)) {
        return defaultVariabel;
      }

      // Filter item yang valid (ada isinya)
      const validVariabel = variabelData.filter(item =>
        item &&
        typeof item === 'object' &&
        (item.nama || item.konsep || item.definisi || item.referensi_waktu)
      );

      // Jika setelah di-filter kosong
      if (validVariabel.length === 0) {
        return defaultVariabel;
      }

      // Map dan ensure semua property ada
      return validVariabel.map(item => ({
        nama: item.nama || null,
        konsep: item.konsep || null,
        definisi: item.definisi || null,
        referensi_waktu: item.referensi_waktu || null
      }));
    },
    normalizeJadwalArray(jadwalData) {
      const defaultJadwal = [{ awal: null, akhir: null }];

      if (!jadwalData) {
        return defaultJadwal;
      }

      if (Array.isArray(jadwalData)) {
        const validArray = jadwalData.filter(item =>
          item && typeof item === 'object'
        );

        if (validArray.length === 0) {
          return defaultJadwal;
        }

        return validArray.map(item => ({
          awal: item.awal || null,
          akhir: item.akhir || null
        }));
      }

      if (typeof jadwalData === 'object') {
        return [{
          awal: jadwalData.awal || null,
          akhir: jadwalData.akhir || null
        }];
      }

      return defaultJadwal;
    },
    /**
   * Apply conditional validation rules
   * Auto-clear fields yang tidak relevan berdasarkan kondisi tertentu
   */
    applyConditionalRules() {
      // ========================================
      // RULE 1: Field 4.2 (Frekuensi Penyelanggara)
      // Hanya relevan jika 4.1 = BERULANG
      // ========================================
      if (this.data.blok_iv.kegiatan_ini_dilakukan !== 'BERULANG') {
        this.data.blok_iv.frekuensi_penyelanggara = null;
      }

      // ========================================
      // RULE 2: Field 4.5 (Sebagian Cakupan Wilayah)
      // Hanya relevan jika 4.4 = SEBAGIAN_WILAYAH_INDONESIA
      // ========================================
      if (this.data.blok_iv.cakupan_wilayah_pengumpulan_data !== 'SEBAGIAN_WILAYAH_INDONESIA') {
        this.data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data = [];
        this.formExt.wilayah = null;
      }

      // ========================================
      // RULE 3: BLOK V (Desain Sampel)
      // Hanya relevan jika cara_pengumpulan_data = SURVEI
      // ========================================
      if (this.data.cara_pengumpulan_data !== 'SURVEI') {
        this.data.blok_v = {
          jenis_rancangan_sampel: null,
          metode_pemilihan_sampel_tahap_terakhir: null,
          metode_yang_digunakan: null,
          kerangka_sampel_tahap_terakhir: null,
          fraksi_sampel_keseluruhan: null,
          nilai_perkiraan_sampling_error_variabel_utama: null,
          unit_sampel: null,
          unit_observasi: null
        };
      } else {
        // Jika SURVEI, terapkan sub-rules untuk Blok V
        this.applyBlokVRules();
      }

      // ========================================
      // RULE 4: Field 6.4-6.7 (Petugas)
      // Hanya relevan jika ada PAPI/CAPI/CATI/CAWI
      // ========================================
      const hasPapiCapiCatiCawi = this.data.blok_iv.sarana_pengumpulan_data.papi ||
        this.data.blok_iv.sarana_pengumpulan_data.capi ||
        this.data.blok_iv.sarana_pengumpulan_data.cati;

      if (!hasPapiCapiCatiCawi) {
        this.data.blok_vi.petugas_pengumpulan_data = null;
        this.data.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data = null;
        this.data.blok_vi.jumlah_petugas_supervisor = null;
        this.data.blok_vi.jumlah_petugas_enumerator = null;
      }
    },

    /**
     * Apply conditional rules khusus untuk Blok V
     */
    applyBlokVRules() {
      // ========================================
      // RULE 5.1: Field 5.3 (Metode yang Digunakan)
      // Berbeda antara SAMPEL_PROBABILITAS vs SAMPEL_NONPROBABILITAS
      // ========================================
      if (this.data.blok_v.metode_pemilihan_sampel_tahap_terakhir === 'SAMPEL_NONPROBABILITAS') {
        // Untuk nonprobabilitas, metode yang digunakan tidak relevan
        // (atau bisa dipilih dari options nonprobabilitas)
        // Tergantung business logic, untuk saat ini kita set null
        // this.data.blok_v.metode_yang_digunakan = null;
        // console.log('✓ Cleared: metode_yang_digunakan (nonprobabilitas)');
      }

      // ========================================
      // RULE 5.2: Field 5.4-5.6
      // Hanya relevan jika 5.2 = SAMPEL_PROBABILITAS
      // ========================================
      if (this.data.blok_v.metode_pemilihan_sampel_tahap_terakhir !== 'SAMPEL_PROBABILITAS') {
        this.data.blok_v.kerangka_sampel_tahap_terakhir = null;
        // this.data.blok_v.fraksi_sampel_keseluruhan = null;
        // this.data.blok_v.nilai_perkiraan_sampling_error_variabel_utama = null;
      }
    },

    /**
     * Helper method untuk convert string ke SNAKE_CASE
     * (pastikan method ini sudah ada, jika belum tambahkan)
     */
    snakeCaseConvert(str) {
      if (!str) return str;
      return str
        .replace(/\s+/g, '_')
        .replace(/[^\w_]/g, '')
        .toUpperCase();
    },
    capitalize(sentence) {
      return sentence ? sentence.replaceAll('_', ' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
    },
    statusFormatterStyle(status) {
      return status ? status.toLowerCase().replace('_', '-') : 'draft';
    },
    statusFormatter(status) {
      return status ? this.options.status.find(x => x.id == status).label : 'Draft';
    },
    changeQuesModeValue(att) {
      this.ques[att] = this.options[att].find(x => x.id == this.data[att]).code
    },
    changeEntriModeValue(att) {
      let value = this.options[att].find(x => x.code == this.ques[att]);
      if (value) {
        this.data[att] = value.id;
      }
    },
    next(){
      if(this.section.currentIndex != this.section.items.length-1){
        if (this.section.currentIndex == null) {
          if (this.data && this.data.jenis_statistik === 'STATISTIK_DASAR' && !this.isUserPusat && !this.isStatistikDasarConfirmed) {
            this.$bvModal.show('modal-confirm-statistik-dasar');
            return;
          }
        }
        this.validateForm();
        if (this.data.cara_pengumpulan_data != 'SURVEI' && this.section.currentIndex == 4) {
          this.section.currentIndex += 2
        } else {
          this.section.currentIndex = this.section.currentIndex == null ? 0 : this.section.currentIndex + 1
        }
      }
    },
    prev() {
      if (this.section.currentIndex != null) {
        if (this.data.cara_pengumpulan_data != 'SURVEI' && this.section.currentIndex == 6) {
          this.section.currentIndex -= 2
        } else {
          this.section.currentIndex = this.section.currentIndex == 0 ? null : this.section.currentIndex - 1
        }

      }
    },
    loadOptions({ callback }) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    async produsenDataLoadOptions({ searchQuery, callback }) {
      let name = searchQuery;
      let page = 0;
      let provinceCode = this.user.organization.province.code;
      let cityCode = this.user.organization.city.code;
      let roles = ['PRODUSEN_DATA', 'WALIDATA']
      await SdiOrganizationService.getAllSdiOrganization(page, name, provinceCode, cityCode, roles).then(
        (result) => {
          let options = result.data.content;
          callback(null, options)
        },
        (error) => {
          console.log(error)
        }
      );
    },
    produsenDataNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
      }
    },
    scrollToUpperMost: function () {
      setTimeout(function () {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, 100);
    },
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    formatDate(strinDate) {
      if (strinDate) {
        let bulan = [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember"
        ];
        let val = strinDate.split(" ");
        let day = parseInt(val[0]);
        let month = bulan.indexOf(val[1]) + 1
        let year = parseInt(val[2]);

        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        return year + "-" + month + "-" + day;
      }
    },
    wilayahNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    async setWilayah() {
      if (this.user.organization.province.code == '00') {
        this.options.userWilayah = this.options.wilayah
      } else {
        this.options.userWilayah = this.options.wilayah.filter(x => x.code == this.user.organization.province.code)
      }
      this.options.userWilayah.forEach(async (prov) => {
        await WilayahService.getKabupatenKotaByIdProvinsi(prov.id).then(
          response => {
            let cities = response.data.data.map(x => {
              let city = {
                id: x.kode, name: x.nama, province_id: prov.id, province_name: prov.name
              }
              this.options.city.push(city);
              return city;
            });
            prov.children = cities;
          },
          error => {
            console.error(error);
          }
        );
      });
    },
    getRecommendationChanged(value) {
      if (!value) {
        // User pilih TIDAK mendapat rekomendasi
        this.data.identitas_rekomendasi = null;
        this.rekomendasi = null;

        // Optional: Clear semua data yang di-auto-fill dari rekomendasi
        // Uncomment jika ingin reset form saat ganti pilihan
        /*
        if (confirm('Apakah Anda yakin? Semua data yang sudah diisi dari rekomendasi akan dihapus.')) {
          this.resetFormData();
        } else {
          this.formExt.getRecommendation = true;
        }
        */
      }
    },
  },

};
</script>
